export const locale = {
    lang: 'en',
    data: {
        HELLO: 'Hello {{value}}',
        MG_ACCOUNTS: {
            BANK_ACCOUNTS: "Bank accounts",
            ALL: "All",
            ACTIVE: "Active",
            DIACTIVE: "Inactive",
            BANK_NAME: "Bank Name",
            CARD_NUM: "Card Number",
            NEW_CARD_NUM: "New Card Number",
            IBAN_NUMBER: "IBAN Number",
            CURRENCY_TYPE: "Currency Type",
            STATUS: "Status",
            ACTIVITY: "Activity",
            ADD_BANK_ACCOUNT: 'add bank account',
            CANT_EDIT_IBAN: "It is not possible to edit the IBAN",
            BANK_ACCOUNT_NOT_REGISTERED: "No bank account has been registered.",
            NO_BANK_ACC: 'No bank account available',
            NEW_BANK_WARNING: "The waiting time for confirming the bank account information is at least 1 hour and at most 1 working day.",
            ACTIVE_DIALOG_TITLE: 'Are you sure about deactivation?',
            ACTIVE_DIALOG_TEXT: 'If the account is deactivated, it will not be possible to use the account in the charging and withdrawal requests section.',
            ADD_BANK: {
                ADD_BANK_ACCOUNT: 'add bank account',
                CARD_NUMBER: 'Card Number',
                IR: 'IR',
                IBAN: 'IBAN',
                APPROVED_BANKS: 'Approved banks',
                CURRENCY_TYPE: 'Currency Type'
            },
            EDIT_BANK: {
                EDIT_BANK_ACCOUNT: 'Edit bank account'
            },
            ALERT: {
                BANK_ACCOUN_OWNER_NAME: 'The bank account must be in the name of "{{fullname}}".',
                CARD_NUMBER_BANK_INVALID: '{{bankName}} accounts are not approved please registered another card number'
            }
        },
        MG_GENERAL: {
            CANCEL: 'Cancel',
            SAVE: 'Save',
            VIEW_ALL: 'View all',
            VIEW_LESS: 'View less',
            EDIT: 'Edit',
            VERIFY_PERSONAL_DATA_TITLE: 'Your personal information has not been verified',
            VERIFY_PERSONAL_DATA_LINK: 'Confirm information',
            ACCEPT: 'Accept',
            LANGUAGE: 'Language',
            CONTINUE: 'Continue',
            SUCCESSFUL_OPERATION: 'Successful operation',
            DELETE: 'Delete',
            DISPLAY_ORDER_FILTER: 'Display order filter',
            DETAILS: 'Details',
            NEXT: 'Next',
            PREV: 'Previous',
            FILTER: 'Filter',
            SELECT_DATES: 'Select dates',
            ORDER: 'Order',
            WITHDRAWALS: 'Withdrawals',
            RECEIPTS: 'Receipts',
            APPLY: 'Apply',
            FILTERS_AND_SORTS: 'Filters and Sorts',
            COPY: 'Copied',
            FINISH: 'Finish'
        },
        NAV: {
            BUY_LIST: "purchase history",
            BUY_VOUCHER: "Buy Voucher",
            DASHBOARD: "Dashboard",
            DEPOSIT: "Deposit",
            EXCHANGE_LOCAL_PAYMENT: "TC Wallet",
            E_MONEY_WITHDRAWAL: "E-money Payment",
            LOCAL_SEND: "Local Payment",
            LOCAL_WITHDRAWAL: "Local Payment",
            MY_ACCOUNTS: "My accounts",
            SEND: "Send",
            TC_ACCOUNTS: "TC Acounts",
            TC_WALLET_SEND: "TC to TC",
            TRANSACTIONS: "Transactions",
            WALLETS: "Wallets",
            WITHDRAW: "Withdraw",
            WITHDRAWAL: "Withdrawal",
            CRYPTO_WITHDRAWAL: 'Crypto Payment',
            CRYPTOCURRENCY_ACCOUNTS: 'Cryptocurrency Accounts',
            NEW_REQUEST: 'New Request',
            BANK_ACCOUNTS: 'Bank Accounts',
            E_MONEY_ACCOUNTS: 'E-Money Accounts',
            VOUCHER: 'Voucher',
            POINT: 'Points',
            WITHDRAW_LIST: 'Withdrawal List',
            FRIENDS: 'Friends',
            SUPPORTS: 'Support',
            TICKETS: 'Tickets',
            FAQ: 'FAQ',
            PROFILE: 'Profile',
            SETTING: 'Settings',
            MY_WALLETS: 'My Wallets',
            EXCHANGE: 'Exchange',
            SUPPORT: 'Support',
            RECIEVE: 'Receive',
            RECIEVEـTC_WALLET: 'TC Receive',
            LOCAL_RECIEVE: 'Local Receive',
            TC_WALLET: 'Tc Wallet',
            DEPOSIT_MONEY_CURRENCY: 'Local Payment',
            DEPOSIT_CRYPTO: 'Crypto Payment',
            DEPOSIT_ELECTRONIC_MONEY: 'E-Money Payment',
            DIGITAL_CURRENCY_PAYMENT: 'Cryptocurrency deposit',
            DIGITAL_CURRENCY_PAYMENT_WITHDRAWAL: 'Cryptocurrency withdraw',
            ANNOUNCEMENT: 'Announcements',
            PAYMENT_GATEWAY: "Payment gateway",
            MY_REQUEST_HISTORY: 'My request history',
            CLIENT_REQUEST_HISTORY: 'Client request history',
            SETTLEMENT_REQUEST_HISTORY: 'Settlement request history',
            P2P: 'P2P',
            P2P_MY_ORDERS: 'My Orders',
            P2P_NEW_AD: 'Create a Sales Ad',
            P2P_AD_LISTINGS: 'Buy from P2P',
            AFFILIATE_SUP: 'Affiliate',
            AFFILIATE_PROGRAM_SUP: 'Cooperation Program',
            AFFILIATE_REQUEST: 'Submit Collaboration Request',
            AFFILIATE_MY_PROGRAM: 'My Affiliate Program',
            AFFILIATE_VIEW_TRANSACTIONS: 'Affiliate Program History',
            AFFILIATE_MY_INTRODUCTION_PROGRAM_SUP: 'Submitting Collaboration Request',
            AFFILIATE_ENTER_CODE: 'Identification Code',
            AFFILIATE_CASHBACK: 'Cashback History',
            BANK_TRANSFER_PAYMENT: 'Bank Transfer Payment',
            TRANSACTIONS_LIST: 'Transaction List',
            SOCIAL_MEDIA: 'Media',
        },
        DASHBOARD: {
            CURRENCY: 'Currency',
            EXCHANGE_RATE: {
                EXCHANGE_RATE: 'Exchange Rate',
                SELL: 'Sell',
                BUY: 'Buy',
                FIAT_EXCHANGE_RATE: 'Fiat Exchange Rate',
                CRYPTO_EXCHANGE_RATE: 'Crypto Exchange Rate',
                BOTH_EXCHANGE_RATE: 'Crypto To Fiat Exchange Rate',
            },
            POINTS: {
                WITHDRAW: 'Withdrawal',
                TRANSACTIONS: 'Transactions',
                MY_POINTS: 'My Points',
            },
            TRANSFORM: {
                THE_ONLY_TRANSFER_OPPORTUNITY: 'Transfer opportunity been extended!!!',
                CLICK: 'Click Here!',
                TRANSFER: 'Transfer',
                MORE_DETAILS: 'More Details',
                DAY: 'Day',
                MINUTE: 'Minute',
                SECOND: 'Second',
                HOURS: 'Hours',
                CRYPTO_REVELUTION: 'Crypto Currency Revelution on TopChange!',
                TRANSFER_TO_GC_P_ONE: 'Transfer crypto currency wallets at TC',
                TRANSFER_TO_GC_P_TWO: 'to the Specialized platform GreenChange',
                NEW_ENVIROMENT: 'GreenChange new environment for automatic currency exchange exchanges'
            },
            ACTIVE_REQUESTS: {
                ACTIVE_REQUESTS: 'Active Requests',
                TRACKING_NUMBER: 'Tracking Number',
                AMOUNT_AND_TYPE: 'Amount and Type',
                CHANGE_STATUS_DATE: 'Change Status Date',
                STATUS: 'Status',
                MESSAGE: 'Message',
                INFO: 'To know the latest status of applications Click on the update button'
            },
            DOWNLOAD_APP: {
                TITLE: 'Download App',
                DOWNLOAD: 'Download'
            },
            WALLET: 'Wallet',
            SHOW_ALL: 'Show All',
        },
        BREAD_CRUMB: {
            ACCOUNTS: "Accounts",
            ADD_ACCOUNT: "Add account",
            ADD_BANK_ACCOUNT: "Add a new bank account",
            ADD_SERVICE_ACCOUNT: "Add a new account",
            ADD_Service_ACCOUNT: "Add a new e-money account",
            ADD_TICKET: "New ticket",
            ADD_WALLET: "Add a wallet",
            ANOUNNCEMENT: "Announcements",
            BANK: "Bank",
            TRANSFER: 'Transfer',
            BUY: "Buy",
            CASH: "Cash",
            CATEGORY: "Category",
            CREDIT: "Credits",
            DASHBOARD: "Dashboard",
            DEPOSIT: "Wallet deposit",
            DETAIL: "Details",
            EDIT_ACCOUNT: "Edit",
            EDIT_WALLET: "Edit wallet",
            ELECTRONIC_MONEY: "E-money",
            ELECTRONIC_MONEY_LIST: "E-money payment requets list",
            EXCHANGE: "Exchange",
            EXCHANGE_LOCAL_LIST: "TC wallet exhange list",
            E_MONEY_WITHDRAWALS_LIST: "E-money withdrawal list",
            FAQ: "FAQ",
            FRIENDS: "Friends",
            HISTORY: "Requests list",
            LIST: "List",
            LOCAL_RECEIVE_LIST: "Locan received payments list",
            LOCAL_SEND_LIST: "Local payment list",
            LOCAL_WITHDRAWALS_LIST: "Local withdrawal list",
            MONEY_CURRENCY: "Local payment methods",
            MONEY_CURRENCY_LIST: "Local payment request list",
            MY_ACCOUNTS: "My accounts",
            MY_WALLETS: "My wallets",
            NEW: "New",
            NEW_REQUEST: "New request",
            NOTIFICATION: "Notifications",
            NOTIFICATIONS: "Notifications",
            P2P: 'P2P',
            MY_AFFILIATE_PROGRAM: 'My Affiliate Program',
            MY_AFFILIATE_HISTORY: 'My Program History',
            SELL_SUCCESSFUL: 'Successful Sale',
            BUY_SUCCESSFUL: 'Successful Buy',
            MY_ORDERS: 'My Orders',
            ADVERTISE: 'My Advertise',
            REGISTER_NEW_AD: 'Register a new ad',
            SELL: 'Sell',
            ONLINE: "Online",
            POINT: "Point",
            POINT_LIST: "Points list",
            PROFILE: "Profile",
            RECEIVE_DETAIL: "Received payment details",
            RECEIVE_OTHER_WAYS_LIST: "List of received payments from other payment methods",
            RECEIVE_TC_WALLET_LIST: "List of received payments form TC  wallets",
            REQUEST_DETAIL: "Request details",
            SEND: "Send",
            SETTING: "Settings",
            SUPPORT: "Support",
            TC_ACCOUNTS: "TC wallets",
            TC_WALLET_LIST: "List of wallet requests",
            TC_WALLET_SEND_LIST: "TC wallet payment list",
            TICKETS: "Tickets",
            TRANSACTIONS: "Transactions",
            TRANSACTIONS_LIST: "Transactions list",
            TRANSFER_INFO: 'Transfer training',
            VOUCHER: "Voucher",
            WALLETS: "Wallets",
            WALLET_TC: "TC wallet",
            WITHDRAWAL: "Withdrawal",
            CRYPTO_LIST: 'Crypto List',
            DIGITAL_CURRENCY: 'cryptocurrency',
            CRYPTO_WITHDRAWAL_LIST: 'Crypto Withdrawal List',
            MY_REQUEST_HISTORY: 'My request history',
            CLIENT_REQUEST_HISTORY: 'Client request history',
            SETTLEMENT_REQUEST_HISTORY: 'Settlement request history',
            SEND_AFFLIATE_REQUEST: "Submit Collaboration Request",
            INVITEE: 'My introduction program',
            IDENTIFICATION_CODE: 'Identification code',
            AFFILIATE_PROGRAM: 'Affiliate program',
            PAYMENT_GATEWAY: "Payment gateway",
            AFFILIATE: 'Affiliate',
            WITHDRAWAL_BANK: 'Withdrawal - bank transfer',
            AFFILIATE_REQUEST: "Submit Collaboration Request",
            INVITEE_ENTER_CODE: 'Referral Code',
            INVITEE_INDEX: 'Referral Code',
            INVITEE_HISTORY: 'Cashback History',
            CRYPTO: 'Cryptocurrency',
            MY_ADS: 'My Ads',
            AUTHENTICATION: 'Authentication',
            CHANGE_MOBILE_NUMBER: 'Change Phone Number',
            TWO_FACTOR_AUTHENTICATION: 'Two-Factor Authentication',
            DIRECT_DEPOSIT_TITLE: 'Bank Transfer',
            BANK_TRANSFER_PAYMENT: 'Bank Transfer Payment',
            TRANSACTION_DETAIL: 'Transaction Details',
            CHAT_WITH_SELLER: 'Chat with seller',
            CHAT_WITH_BUYER: 'Chat with buyer',
            DEPOSIT_OFFLINE: 'Offline Deposit',
            CARD_OFFLINE_DEPOSIT: 'Offline Card-to-Card Deposit',
            SOCIAL_MEDIA: 'Social Media',
        },
        QUICK_ACCESS: {
            BUY_VOUCHER: "Buy vouher",
            CHANGE: "Change",
            DEPOSIT: "Deposit",
            DEPOSIT_E_MONEY_LIST: "E-money requests list",
            DEPOSIT_LOCAL_PAYMENT_LIST: "Loal requests list",
            DEPOSIT_NEW: "New deposit",
            EXCHANGE: "Exchange",
            EXCHANGE_LOCAL_PAYMENT_LIST: "local exchanges list",
            EXCHANGE_NEW: "New exchange",
            EXCHANGE_NEW_E_MONEY: "New e-money exchange",
            EXCHANGE_NEW_LOCAL_PAYMENT: "New local exchange",
            E_MONEY_LIST: "E-money requests list",
            FAQ: "FAQ",
            FRIENDS: "Friends",
            LIST: "List",
            LOCAL_PAYMENT_LIST: "Local requests list",
            MY_ACCOUNTS: "My acounts",
            MY_FRIENDS: "My friends",
            MY_WALLETS: "My wallets",
            NEW: "New",
            NEW_BANK_ACCOUNT: "New bank account",
            NEW_E_MONEY: "New e-money request",
            NEW_E_MONEY_ACCOUNT: "New e-money account",
            NEW_LOCAL_PAYMENT: "New local request",
            NEW_TICKET: "New ticket",
            NEW_WALLET: "New wallet",
            POINT: "Point",
            PROFILE: "Profile",
            RECIEVE: "Receive",
            RECIEVE_LOCAL_LIST: "list of local payments received",
            RECIEVE_TC_WALLET_LIST: "List of received payments from wallet",
            SEND: "Send",
            SEND_LOCAL_PAYMENT_LIST: "Local send payments list",
            SEND_NEW: "New send",
            SEND_TC_WALLET: "Send from wallet",
            SEND_TC_WALLET_LIST: "List of send payments from wallet",
            SETTING: "Settings",
            SUPPORT: "Support",
            TC_ACCOUNTS: "TC acounts",
            TICKETS: "Ticket",
            TRANSACTIONS: "Trsnsations",
            VOUCHER: "Voucher",
            VOUCHER_LIST: "Requests list",
            WALLET: "Wallet",
            WALLET_TRANSACTIONS: "Wallet transactions",
            WITHDRAWAL: "Withdrawal",
            WITHDRAWAL_E_MONEY_LIST: "E-money withdrawals list",
            WITHDRAWAL_LOCAL_PAYMENT_LIST: "Local withdrawals list",
            WITHDRAWAL_NEW: "New withdraw",
            WITHDRAWAL_POINT: "Point withdrawal",
            WITHDRAWAL_POINT_LIST: "Point withdrawal list",
            WITHDRAWAL_POINT_TRANSACTIONS: "Point transactions",
            BUY: 'Buy', ACCOUNTS: 'Accounts',
            CHANGE_WITH: 'Change "{{title}}" with ...',
            ALERT: {
                SAVE_CHANGE_SUCCESSFULLY: 'Changes saved successfully'
            }
        },
        ANNOUNCEMENT: {
            ACTIVE_ANNOUNCEMENTS: "Active announcements",
            ARCHIVE: "Archive",
            MORE: 'More',
            VIDEO: {
                TITLE: 'Tether is back to TopChange!',
                SUBTITLE: 'Small changes, big results.',
                TEXT: "The pieces of our financial services puzzle have all fallen into place.",
                TEXT1: "Experience faster and more secure transactions starting today.",
                TEXT2: "3- Zero transaction fees",
                TEXT3: '4- Faster transfer to a bank account',
                TEXT4: '5- High transaction security',
                TEXT31: 'Help Center',
                TEXT32: 'page.'
            },
            ALERT: {
                NO_CONTENT: "There is no content to display"
            }
        },
        PISHING: {
            PISHING: 'PISHING',
            IS_AN_OPERATION_OF_DECEPTION: 'is an operation of deception!',
            PISHING_TEXT: 'According to the laws and regulations, the account holder is responsible for all transactions and exchanges that are done through the citizens\' accounts and bank cards, and no claim of renting an account to legal, tax, disciplinary and judicial authorities is acceptable. In case a person leases his / her national account and code to another person and keeps in his / her account the funds that originated from criminal acts or causes its transfer, in addition to assisting in the main crime and tolerance The penalty for that crime is also punishable by money laundering.'
        },
        EVENT: {
            TITLE1: 'Crypto Currency Revolution in TopChange!',
            DESCRIPTION1: 'Transfer cryptocurrency wallets to a new and specialized platform called Green Change',
            DESCRIPTION2: 'New environment for automatic cryptocurrency exchanges',
            TITLE2: 'Green Change',
            BTN: 'Click for more information!',
            IMG: 'assets/media/images/events/PopUp-Transfer-en.png'
        },
        AUTH: {
            CONFIRM_ADDRESS: "Address verification",
            CONFIRM_MOBILE: "Mobile number verification",
            CONFIRM_PERSONAL: "Personal information verification",
            CONFIRM_PICTURE: "Photo verification",
            ERROR_404: "Request not Found",
            ERROR_500: "An error occurred. Please reload the page and try again.",
            ACCESS_DENIED: 'You do not have access to this page',
            CONNECTION_ERROR: 'The network connection was lost.',
            FORGOT_PASSWORD: "I forgot my password",
            TC_TERMS: 'TC Terms',
            ERROR_400: '‌Bad Request',
            INVALID_CAPTCHA: "Captcha is invalid",
            LOGOUT: "Log Out",
            NO_ACCOUNT: "have no account?",
            REQUIRED: "Required",
            RESEND_CODE: "Resend the code",
            WE_SENT_ACTIVATION_CODE_TO_PHONE: "A verification code has been sent to your mobile number",
            ERROR_UNKNOWN: "An error occurred while processing your request. Please try again.",
            LOGIN: {
                SUBMIT: "Login",
                TITLE: "Login"
            },

            TWO_FACTOR: {
                TITLE: 'Security verification',
                CODE: 'Authenticator Code',
                DESCRIPTION1: 'Please enter your authenticator code',
                DESCRIPTION2: '',
                HINT: 'Enter the {{value}}-digit code from Authenticator',
                SUBMIT: 'Submit',
                VALIDATION_CODE: 'Please Enter Authenticator Code'
            },

            RECOVER: {
                CONFIRM_PASS: "Repeat password",
                DESC1: "If you have forgotten your password",
                DESC2: "retrieve it via email or SMS.",
                EMAIL: "Email",
                PASS_NOT_SAME: "Repeat password must be equal to password",
                SMS: "SMS",
                TITLE: "Recover password",
                BY_EMAIL: {
                    CODE_SENT: "A verification code was sent to your email.",
                    HINT: "Please enter the verification code sent to your email",
                    SPAM_HINT: "Please check your spam folder if you didn't receive the code in your inbox.",
                },
                BY_SMS: {
                    CODE_SENT: "The verification code was sent to your mobile number",
                    HINT: "Please enter the SMS code"
                },
                SUCCESS: {
                    DESC: "You can log in to your account now.",
                    GO_TO_LOGIN: "Back to login page",
                    TITLE: "Password has been changed successfully"
                }


            },
            REGISTER: {
                ALREADY_HAVE_ACCOUNT: "Already have an account?",
                CODE: "Verification code",
                DESC: "Description",
                ENTER_EMAIL: "Please enter your email",
                LOGIN: "Login",
                PLEASE_COMPLETE_YOUR_FORM: "Please complete the form below",
                SENT_EMAIL_TEXT: "An email with a {{value}} digit code was sent to you",
                SENT_SMS_TEXT: "An SMS with a {{value}} digit code was sent to you",
                SUBMIT_CONFIRM_EMAIL: "Confirm",
                SUBMIT_EMAIL: "Enter",
                SUBMIT_FORM: "Create account",
                TITLE: "Register",
                YOUR_EMAIL: "Your email",
                SUCCESS: {
                    DESC: "You can now log in to your account",
                    GO_TO_LOGIN: "Login to account",
                    TITLE: "Registration completed successfully"
                }
            },
            INPUT: {
                COUNTRY: "Country",
                EMAIL: "Email",
                FIRSTNAME: "Name",
                FULLNAME: "Full name",
                GENDER: "Gender",
                I_ACCEPT: "Accept",
                LASTNAME: "Last name",
                NEW_CONFIRM_PASS: "Confirm new password",
                NEW_PASSWORD: "New password",
                PASSWORD: "Password",
                PHONE: "Mobile Number",
                TC_TERM: "TC terms and conditions",
                USERNAME: "Username"
            },
            VALIDATION: {
                INVALID_EMAIL: "The entered email is invalid",
                PASSWORD: {
                    COUNT_CHARACTER: '8-32 Characters',
                    UPPERCASE_LETTER: 'At least 1 Uppercase letter [A-Z]',
                    HAS_NUMBER: 'At least 1 number [0-9]'
                }
            }
        },
        NEW_AUTH: {
            WELOCOME: 'Welcome to TopChange',
            ENTER_EMAIL: 'Please enter your email.',
            ENTER_VALID_EMAIL: 'Please enter a valid email!',
            CONTINUE: 'Continue',
            CONFIRM_CODE: 'Confirm code',
            ENTER_CODE_SENT: 'Please enter the code sent to {{value}}. ',
            CHECK_SPAM: '(Also check your Spam folder)',
            CONFIRM: 'Confirm',
            VERIFY: 'Verify',
            INCORRECT_CODE: 'The entered code is incorrect.',
            RESEND: 'Resend',
            REGISTER: 'Register',
            REGISTRATION: 'Registration',
            SET_PASSWORD: 'Please set a secure password for your account.',
            PASSWORD: 'Password',
            REPEAT_PASSWORD: 'Repeat password',
            MORE_THAN_8: 'More than 8 characters',
            NUMBERS: 'Number or symbols',
            UPPERCASE: 'Uppercase letter',
            REFERRAL_CODE: 'Referral Code',
            OPTIONAL: '(Optional)',
            PASSWORDS_NOT_MATCH: 'Passwords do not match.',
            TERMS: ' <span>I have read and agree to</span><span class=\"role-text\">Terms and Conditions.</span>',
            LOGIN: 'Login',
            ENTER_EMAIL_PASSWORD: 'Please enter your email and password.',
            FORGET_PASSWORD: 'Forgot Password',
            AUTHENTICATOR_CODE: '2Fa Confirmation',
            ENTER_AUTHENTICATOR_CODE: 'Enter the verification code sent to your authentication app.',
            DONT_ACCESS_CODE: "Don't have access to the code?",
            REMOVE_TWO_FACTOR: 'Please contact support to remove the two-factor code.',
            ONLINE_SUPPORT: 'Online Support',
            SEND_CODE: 'Send code ',
            SEND_CODE_AGAIN: "Resend code",
            TC_TERMS: "TC Terms and Conditions",
            VALIDATION: {
                MIN_LENGTH: 'The {{name}} must be {{value}} digits',
                MAX_LENGTH: 'The {{name}} must be {{value}} digits',
            },
            FORGET_PASSWORD_PAGE: {
                TITLE: 'Forgot Password',
                SUBTITLE: 'Please enter your email to recover your password.',
                ENTER_CODE_SENT: 'Please enter the code sent to <span>{{value}}</span>.',
                VALIDATION: {
                    EMAIL_FORMAT: 'Please enter the email correctly! '
                },
                RESET_PASSWORD: {
                    TITLE: 'New Password',
                    SUBTITLE: 'Please set a new password for your account.',
                    CHANGE_PASSWORD: 'Change password'
                },
                ALERT: {
                    SUCCESS_CHANGE_PASS_TITLE: 'Your password has been changed successfully!',
                    SUCCESS_CHANGE_PASS_DESCRIPTION: 'Please log in again to access your account.',
                }
            },
            ALERT_TERMS: {
                TITLE: "Notice",
                DESC: "Please read these Terms of Use carefully. By accessing this site and any pages thereof, you agree to be bound by the Terms of Use below. If you do not agree to the Terms of Use below, do not access this site, or any pages thereof."
            },
            TERMS_RULES: {
                VISITOR_RESPONSIBILITY: {
                    TITLE: "Responsibility of visitors",
                    DESC: "The information on this website and services rendering here are not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation. None of the services referred to TopChange is available to persons residing in any country where the provision of such services would be contrary to local law or regulation. It is the responsibility of visitors to this website to ascertain the terms of and comply with any local law or regulation to which they are subject. Nothing on the TopChange website shall be considered a solicitation to buy or an offer to sell any product or service to any person in any jurisdiction where such offer, solicitation, purchase or sale would be unlawful under the laws of such jurisdiction."
                },
                SCOPE_OF_SERVICES: {
                    TITLE: "Scope of services",
                    DESC: "This website is operated by TopChange (abbreviated name - TC). TopChange is neither e-money operator nor payment service provider. TopChange provides visitors of this web site with information services for facilitating them to buy or sell e-money and e-vouchers of most popular global payment companies and to make prepayments for goods and services purchased by visitors via the Internet."
                },
                REGISTER: {
                    TITLE: "Register",
                    DESC: "For registering on TC web site visitors shall provide the following personnel information: real name and surname; e-mail; phone number; residence address; date of birth; personal ID card (or national passport, or passport for foreign travel, or driving license); selfie photo with personal ID card. TC verifies personal information by using any available methods of verification including personal phone calls and personal meetings. A visitor's TC wallet has limited functionality until a visitor provides all required personal information and all information is verified."
                },
                EXCLUSION_OF_WARRANTIES: {
                    TITLE: "Exclusion of warranties",
                    DESC: "TC does not make any express or implied warranties about the TC web site, including but not limited to implied warranties of merchantability, fitness for a particular purpose, or non-infringement. The TC web site is made available to its visitors \"as is\" and \"as available\" and TC does not warrant that any defects or inaccuracies will be corrected. TC does not warrant that the TC web site will meet your needs, or that it will be uninterrupted, timely, secure or error-free."
                },
                DISCLAIMER: {
                    TITLE: "Disclaimer and limitation of liability",
                    DESC: "To the maximum extent permitted by law, TC will not be liable for any consequential, incidental, special, direct, or indirect damages including but not limited to lost profits, trading losses or damages that result from use or loss of use of the TC web site and third party content, inconvenience or delay. Except as otherwise required by law, TC will not be liable to you or anyone else for any loss resulting from a cause over which TC does not have direct control. This includes failure of electronic or mechanical equipment or communications lines, unauthorized access, viruses, theft, operator errors, fire, war, pandemic, insurrection, terrorist act, riot, labour dispute, accident, emergency or action of government."
                },
                INDEMNIFICATION: {
                    TITLE: "Indemnification",
                    DESC: "As a condition of your use of the TC web site, you agree to indemnify and hold TC and its third party content providers harmless from and against any and all claims, losses, liability, costs and expenses (including but not limited to attorneys' fees) arising from your use of the TC web site, or from your violation of these Terms of Use."
                },
                CONFIDENTIALITY: {
                    TITLE: "Confidentiality",
                    DESC: "It is your obligation to keep TC wallet numbers and passwords confidential. You acknowledge and agree that any instruction or communication transmitted to you or on your behalf via any TC web site is made at your own risk. You acknowledge and agree that TC shall be entitled to rely upon your TC wallet number and/or password to identify you and agree you will not disclose this information to anyone not duly authorized by you."
                },
                TERMINATION: {
                    TITLE: "Termination",
                    DESC: "TC reserves the right to terminate your usage of this website at any time, for any reason, with or without cause and without prior notice."
                },
                SEVERABILITY: {
                    TITLE: "Severability",
                    DESC: "If for any reason any provision of these Terms of Use is deemed invalid or unenforceable, that provision will be enforced to the maximum extent permissible, and the remaining provisions will remain in full force and effect."
                }
            }
        },
        SETTING: {
            AUTO_CHANGES: "System changes",
            AUTHENTICATOR: "Authenticator",
            BETWEEN_MY_WALLETS: "Transfer between wallets",
            DASHBOARD: "Dashboard",
            DEFAULT_LANGUAGE: "Default language",
            DISABLED: "Inactive",
            EMAIL: "Email",
            EXCHANGE: "Exchange",
            EXPERT_MESSAGES: "Support Messages",
            EXPERT_OR_FRIENDS_CHANGES: "Friends or admins changes",
            FRIEND: "Friends",
            FRIENDS: "Friends",
            GENERAL_TEXT: "General",
            INTERNAL_TRANSFER: "Internal transfer",
            LOCAL: "Local",
            LOGIN: "Login",
            MESSAGE: "Messages",
            MY_CHANGES: "My changes",
            NOTIFY_SYSTEM: "System notifications",
            NOTIFY_SYSTEM_SETTING: "System notifications",
            PAYMENTS: "Paymnets",
            PAYMENT_GATEWAY: "Payment gateway",
            POINT: "Point withdrawal",
            POINT_CHANGE: "Point change",
            POINT_WITHDRAWAL: "Point withdrawal",
            POSSIBLE_TO_HAVE_SECURITY_CODE: "You must enter the verification code sent to your email to save the changes.",
            QUICK_ACCESS: "Quick access",
            RECEIVE: "Receive",
            REQUESTS: "Requests",
            REQUEST_MESSAGE: "Request message",
            REQUEST_PAYMENT: "Payments",
            REQUEST_SECURITY: "Security",
            REQUEST_SECURITY_SETTING: "Security",
            SECURITY_SETTING: "Security settings",
            SEND: "Send",
            SEND_CONFIRMATION_CODE: "Send verification code",
            SERVICE: "E-money",
            SETTING_GENERAL: "General",
            SETTING_REQUEST_SECURITY: "Security",
            SMS: "SMS",
            SMS_CREDIT_CHANGE: "validity of the SMS panel Change",
            TICKET: "Ticket",
            TIME_ZONE: "Local time",
            TITLE: "Settings",
            VERIFIED: "Verifications ",
            VERIFY_BANK_ACCOUNT: "Verify bank acount",
            VERIFY_INFO: "Verify information",
            VERIFY_INFORMATION: "Verify information",
            VOUCHER: "Voucher",
            WALLET_CHANGE: "Wallet change",
            DISPLAY_LANGUAGE: "Display Language",
            DISPLAY_LANGUAGE_DESCRIPTION: "The website will appear in the selected language",
            NOTIFICATION_LANGUAGE: "Notification Language",
            NOTIFICATION_LANGUAGE_DESCRIPTION: "The notification will appear in the selected language",
            TIME_ZONE_DESCRIPTION: "The time zone will appear in the selected language",
            PLEASE_CONFIGURE_AUTHENTICATOR: "Please enable two-factor authentication(2FA) first",
            GENERAL: {},
            OFF: 'Off',
            ON: 'On',
            ENABLE: "Enable",
            CHANGE: "Change",
            REMOVE: "Remove",
            SECURITY: "Security",
            ADVANCED_SECURITY: 'Advance Security',
            ANTI_PHISHING_CODE: 'Anti-Phishing Code',
            NOTIFICATION: {},
            USER_QUICK_ACCESS: {},
            ANTI_PHISHING_DES: 'Protect your account from phishing attempts and ensure that your notification emails are from Topchange only.',
            P2P: 'P2P',
            TWO_FACTOR_AUTHENTICATION: {
                TWO_FACTOR_AUTHENTICATION: "Two-Factor Authentication",
                AUTHENTICATION: "Authentication",
                PROTECT_YOUR_ACCOUNT_AND_TRANSACTION: "Protect your account and transaction when you log in and request",
                HAVING_TROUBLE: "Having trouble?",
                ENABLE_GOOGLE_AUTHENTICATOR: 'Enable Authenticator',
                CHANGE_GOOGLE_AUTHENTICATOR: 'Change Authenticator',
                DOWNLOAD_APP: 'Download App',
                DOWNLOAD_APP_DESC: 'Use an application on your phone to get two-factor authentication codes when prompted. We recommend using cloud-based TOTP apps such as: Google Authenticator ,1Password, Authy, LastPass Authenticator, or Microsoft Authenticator. You can download Google Authenticator from below:',
                SCAN_QR_CODE: 'Scan QR code',
                SCAN_QR_CODE_DESC: 'Scan this QR code in the Authenticator app',
                SCAN_QR_CODE_CHANGE_DESC: 'Choose your wallet which you want to charge',
                SCAN_QR_CODE_DESC_MANUAL: 'If you are unable to scan the QR code, please enter this code manually into the app.',
                BACKUP_KEY: 'Backup Key',
                BACKUP_NEW_KEY: 'Backup New Key',
                BACKUP_KEY_DESC: 'Save this Backup Key in a secure location',
                BACKUP_KEY_DESC_MANUAL: 'This Key will allow you to recover your Authenticator should you lose your phone. Otherwise, resetting  App Authenticator will take at least 7 days.',
                ENABLE_DESC: 'Enable the Authenticator by verifying your account',
                ENABLE_NEW_AUTH: 'Enable New Authenticator',
                ENABLE_NEW_AUTH_DESC: 'Please for enable new Authenticator enter verification codes',
                COMPLETE: 'Complete',
                DONE: 'Done',
                ENABLE: 'Enable',
                ALERT_SUCCESS_ENABLE: 'You have successfully enabled Authenticator to protect your account.',
                ALERT_SUCCESS_CHANGE: 'You may now use the new Authenticator to log in.',
                DOWNLOAD_FROM: 'Download form',
                LABEL_VERIFY_CODE: 'Email Verification Code',
                LABEL_TOTP_CODE: 'Two-Factor Authentication Code',
                HINT_TOTP_CODE: 'Please enter your 6-digit two-factor authentication code.',
                /*  HINT_VERIFY_CODE: 'Enter the {{codeLength}} digit code sent to {{email}}.', */
                HINT_VERIFY_CODE: 'Please check your spam folder if you didn\'t receive the code in your inbox.',
                COPIED_SUCCESSFULLY: 'Copied successfully',
                REMOVE_CURRENT: 'Remove Current',
                REMOVE_CURRENT_AUTH: 'Remove Current Authenticator',
                REMOVE_CURRENT_AUTH_DESC: 'Remove current Authenticator by verifying your identity',
                VERIFY_CHANGE: 'Verify',
                VERIFY_CHANGE_TITLE: 'Verify Current Authenticator',
                VERIFY_CHANGE_DESC: 'To change current Authenticator, verify your identity.',
                BACK_TO_SECURITY: 'Back to Security',
                ARE_U_SURE: 'Are you sure you want to remove Google Authenticator?',
                REQUESTE_DISABLE: 'Requests that use “App Authenticator” for authentication will be disabled after disabling this method.',
                DELETING_APP: 'Deleting App Authenticator will reduce the security of your account.',
                REMOVE_GOOGLE_AUTHENTICATOR: 'Remove Authenticator',
                OFF: 'Off',
                ON: 'On',
                ALERT: {
                    GOOGLE_AUTHENTICATOR_SUCCESSFULLY_REMOVED: 'Google Authentication Successfully removed !'
                }
            },
            ANTI_PHISHING: {
                ENABLE_ANTI_PHISHING_CODE: 'Enable Anti-Phishing Code',
                WHAT_IS_IT: 'What is an Anti-Phishing Code?',
                WHAT_IS_IT_ANS: 'An Anti-Phishing Code is a code that helps to prevent phishing attempts from fake TopChange Websites or emails address.',
                HOW_DOES_IT_WORK: 'How does it work?',
                HOW_DOES_IT_WORK_ANS: 'Once you have set your uniqe Anti-Phishing Code, it will be included in all genuine Topchange emails.',
                ANTI_PISHING_CODE: 'Anti-Phishing Code',
                CREAT_ANTI_PISHING_CODE: 'Create Anti-Phishing Code',
                CHANGE_ANTI_PISHING_CODE: 'Change Anti-Phishing Code',
                SHOW_ANTI_PISHING_CODE: 'Show Anti-Phishing Code',
                PLZ_ENTER_CODE: 'Please enter 4-20 none-special characters',
                SECURITY_VERIFICATION: 'Security Verification',
                ENTER_SIX_DIGIT_FROM_APP: 'Enter 6-Digit code from App Authenticator',
                TO_SECURE_YOUR_ACCOUNT_PLZ_COMPLETE_FLOWING_VERIFICATION: 'To Secure your account, Please complete flowing verification.',
                ANTI_PHISHING_CODE: 'Anti-Phishing Code',
                OLD_ANTI_PHISHING_CODE: 'Old Anti-phishing Code',
                CHANGE_CODE: 'Change Code',
                AUTHENTICATOR_CODE: 'Authenticator Code',
            },
            ALERT: {
                CHANGES_SAVED_SUCCESSFULLY: 'Changes saved successfully.',
                ENTER_CODE_THAT_SENT_TO_EMAIL_AND_PASSWORD: 'Enter the {{codeLength}} digit code sent to {{email}} and {{phone}}.'
            }
        },
        FRIENDS: {
            ACCEPT: "Accept",
            ADD_FRIEND: "Add friend",
            ALERT_DELETE: "Are you sure about deleting this user from your friends list?",
            BLOCK: "Block",
            BLOCKED_USER: "Blocked",
            DEPOSIT: "Account deposit",
            FRIEND: "Friend",
            FRIENDS_REQUEST: "Friendship requests",
            MORE: "Show More",
            MY_FRIENDS: "My friends",
            REJECT: "Reject",
            SEND: "Send",
            SEND_FRIEND_REQUEST: "Send friendship request",
            SEND_FRIEND_REQUEST_HINT: "Enter the user's email to send a friendship request. If the user exists, a friendship request will be sent.",
            SEND_REQUEST: "Send request",
            SENT_REQUEST: "Requests sent",
            UNBLOCK: "Unblock",
            UNFRIEND: "Cancel friendship",
            WALLETS: "Wallets",
            ALERT: {
                CONFIRM_DELETE_REQUEST: "Are you sure about deleting this request?",
                CONFIRM_REJECT_REQUEST: "Are you sure about rejecting this request?",
                REQUEST_SENT_SUCCESSFULLY: "Friendship request sent successfully",
                REQUEST_SENT_USER_NOT_FOUND: "The  user does not exist in the system. Your invitation was sent to them via email",
                SUCCECC_ACCEPT: "Friendship request accepted",
                SUCCECC_BLOCK: "The user has been blocked",
                SUCCECC_DELETE: "Friendship request deleted",
                SUCCECC_DELETE_FIREND: "The user has been removed from your friends list",
                SUCCECC_REJECT: "Friendship request rejected"
            }
        },
        ACCOUNTS: {
            ACCOUNT: "Account",
            ACCOUNTS: "Accounts",
            ACCOUNTS_INFORMATION: "Account information",
            ACCOUNT_NO: "Account number",
            ACCOUNT_NUMBER: "Account number",
            ACCOUNT_OWNERS_NAME: "Account owner's name",
            ADD_BANK_ACCOUNT: "New bank account",
            TAG: 'Tag',
            BANK: "Bank",
            BANKS: "Banks",
            SELECT_BANK: 'Select Bank',
            BANK_ADDRESS: "Bank address",
            BANK_NAME: "Bank name",
            BRANCH_CODE: "Branch code",
            CARD_NO: "Card Number",
            CARD_NUMBER: "Card Number",
            EDIT_BANK_ACCOUNT: "Edit bank account",
            EDIT_SERVICE_ACCOUNT: "Edit e-money account",
            IBAN_NUMBER: "IBAN Number",
            MY_ACCOUNT: "My account",
            NEW_BANKS: "New bank account",
            NEW_SERVICE: "New e-money account",
            NEW_SERVICE_ACCOUNT: "New e-money account",
            OWNER: "Account owner",
            SERVICE: "E-money",
            SERVICES: "E-money",
            SWIFT_CODE: "Swift code",
            TC_ACCOUNT: "TC account",
            TC_BANK_ACCOUNT: "TC bank account",
            CRYPTO: 'Cryptocurrency',
            NEW_CRYPTO: 'New Crypto Account',
            EDIT_CRYPTO_ACCOUNT: 'Edit Crypto Account',
            BANK_ACCOUNT_LIST: '‌‌Bank Account List',
            CRYPTO_ACCOUNT_LIST: 'Cryptocurrency Account List',
            EMONEY_ACCOUNT_LIST: 'E-Money Account List',
            REJECTED_TITLE: 'Invalid information!',
            REJECTED_TEXT: 'Please enter account details to review and edit.',
            BANK_IS_NOT_VALID: 'Please select the bank from the options in the list',
            CARD_NUMBER_IS_NOT_VALID: 'Card number is not valid',
            CARD_NUMBER_NOT_SUPPORTED: 'Bank card number entered is not supported',
            ENTER_RELATED_CARD_NUMBER: 'Please enter {{bankName}} card number',
            YOU_DONT_HAVE_ENOUGH_BANK_ACCOUNT_Q: 'You don\'t have enough bank account?',
            YOU_DONT_HAVE_ENOUGH_BANK_ACCOUNT: 'You don\'t have enough bank account',
            FIRST_REGISTER_NEW_BANK_ACCOUNT: 'First, register a new bank account.',
            THEN_REGISTER_YOUR_WITHDRAWAL_REQUEST_FROM_BEGINNING: 'Then register your withdrawal request',
            REGISTER_FROM_BEGINNING: 'from the beginning.',
            BANK_ACCOUNT: 'Bank Account',
            ADD_ACOUNT: 'Add Account',
            TOTAL_RECEIVED: "Total Received",
            UN_ACCEPTABLE_BANK_HINT: 'Avoid registering accounts of financial institutions.',
            ALERT: {
                ACCOUNT_INFO_COPIED: "Account information was copied to the clipboard",
                ADD_BANK_ACCOUNT: "Add a bank account",
                ADD_SERVICE_ACCOUNT: "Add an e-money account",
                ADD_SUCCESS: 'Account information saved successfully. \n Wait for the information to be confirmed',
                ADD_SUCCESS_EMONEY: 'Account information saved successfully.',
                BANK_ACCOUNT_IS_PENDING: "Your account will be verified by experts after review.",
                DELETE_BANK: "Are you sure about deleting this bank account?",
                DELETE_SERVICE: "Are you sure about deleting this e-money account?",
                DELETE_SUCCESS: "The account was successfully deleted",
                EDIT_SUCCESS: "'Account information has been edited successfully.\n Wait for the information to be confirmed.'",
                EDIT_SUCCESS_EMONEY: "Account information has been edited successfully.",
                VERIFY_NEEDS: "Your personal information has not been verified.",
                VERIFY_TIME_INFO: "This account will be  automatically verified after the first successful request",
                YOUR_SERVICE_ACCOUNT_IS_EMPTY: "E-money account is not registered.",
                YOUR_CRYPTO_ACCOUNT_IS_EMPTY: ' Your Crypto account is empty, please add your account number.',
                ADD_CRYPTO_ACCOUNT: 'Add Crypto Account',
                YOUR_BANK_ACCOUNT_IS_EMPTY: "There is no registered bank account.",
                FOR_ADD_BANK_ACCOUNT: 'To Add New Bank Account',
                UN_ACCEPTABLE_BANK: 'Dear user, the bank accounts from ‌Saman Blue Bank, Kosar, melal and noor financial institution are not approved. Please refrain from registering account information of these banks.',
                IBAN_NUBER_IS_NOT_FOR_THIS_BANK: 'The Iban Number entered is not ralated to the selected bank.'
            }
        },
        TICKETS: {
            ATTACHMENT: "Attach file",
            DEPARTMENT: "Department",
            I_HAVE_TRACKING_NUMBER: "I have a ticket number",
            LOCK_MESSAGE: "Your wallet has been locked. For more info please send us a ticket.",
            MESSAGE: "Messages",
            NEW_TICKET: "New Ticket",
            PRIORITY: "Priority",
            SUBJECT: "Subject",
            TEXT: "Note",
            TICKET_NO: "Ticket Number",
            TICKET_NUMBER: "Ticket Number",
            TICKET_STATE: "Status",
            ALERT: {
                ADD_RATE_SUCCESS: "Your point has successfully been submited in the system.",
                ADD_SUCCESS: "Your ticket has been successfully submited.",
                CLOSED_BEFORE: "You have already closed this ticket.",
                CLOSE_CONFIRM: "Are you sure you want to close this ticket?",
                CLOSE_SUCCESS: "Ticket has been successfully closed.",
                NOT_FOUND: "The desired ticket has not been found.",
                SEND_MESSAGE_TO_OPEN_TICKETS: "For re-opening the ticket you need to send a message.",
                TICKET_HAS_BEEN_ARCHIVED: 'This ticket has been archived and it is not possible to reply to it',
                TICKET_HAS_BEEN_CLOSED: 'This ticket has been closed and it is not possible to reply to it',
                TICKET_REPLY_SUCCESS: "Your message has been successfully sent."
            }
        },
        FAQ: {
            ASK_QUESTION: "Asking a question",
            BROWSE_TOPICS: "Primary Topics",
            FREQUENTLY_QUESTIONS: "Frequesntly Asked Questions",
            HOW_CAN_HELP: "Welcome. How may I Help you"
        },
        REQUEST: {
            ACCEPT_ABOVE_INFO: "I accept the accuracy of the above information.",
            ACCOUNT_INFO: "Account info",
            AMOUNT: "Top up amount",
            ARCHIVE: "Archive",
            ARCHIVE_DATE: "Archie date",
            BALANCE: "Balance",
            BANK: "Bank",
            BONUS: "Bonus",
            BONUS_FIXED_AMOUNT: "Fixed amount",
            BUY_AMOUNT: "Buy amount",
            CALCULATED_AMOUNT_ALONE: "Calculated amount",
            CALCULATED_AMOUNT_BUNOS: "Amount with bonus",
            CHANGE_STATE: "Change status",
            CHANGE_STATUS_DATE: "Date of Status Change",
            CHARGE_AMOUNT: "Top up amount",
            COMMISION: "Commission",
            DATE: "Date",
            DECIMAL_SCALE: "Decimal scale",
            DEPOSIT_INFORMATION: "Payment info",
            DEPOSIT_PAYMENT_TYPE: "Deposit payment type",
            DETAIL: "Details",
            DIGITAL_CURRENCY: "Digital currency",
            DONT_HAVE_WALLET_NUMBER: "I do not have the wallet number.",
            ELECTROINC_MONEY: "E-money",
            ELECTRONIC_MONEY: "Electronic Money",
            ELECTRONIC_MONEY_NAME: "E-Money\'s Name",
            CRYPTO_NAME: "Cryptocurrency Name",
            CRYPTOCURRENCY: "Cryptocurrency",
            ELECTRONIC_MONEY_PAYMENT: "Paying E-Money",
            END: "End",
            EXCHANGE_RATE: "Exchange rate",
            EXCHANGE_TEXT: "Transfer",
            EXCHANGE_TYPE: "Exchange type",
            EXPERT_DESCRIPTION: "Expert\'s Note",
            FRIEND: "Friend",
            FROM_WALLET: "From wallet",
            GET: "Get",
            GET_AMOUNT: "Get amount",
            GET_SERVICE: "E-money get service",
            INITIAL_COST: "Initial cost",
            LOCAL_PAYMENT: "Local Payment",
            LOCATION: "Delivery Location",
            MAXIMUM_COMMISION: "Maximum commission",
            MAXIMUM_BONUS: "Maximum bonus",
            MAX_AMOUNT: "Maxmimum amount",
            MESSAGE_PLACE_HOLDER: "Submit your message",
            MINIMUM_COMMISION: "Minimum commission",
            MIN_AMOUNT: "Minimum amount",
            MONEY_CURRENCY: "Local payment",
            MORE_INFO: "More Info",
            MY_PAYMENT: "My payments",
            MY_WALLET: "My wallets",
            PAYMENT_INFO_WILL_SEND_VIA_NOTIFICATION: "Payment information will be sent to you via notifications",
            PAYMENT_TYPE: "Payment type",
            PAY_ACCOUNT: "Pay from account",
            PAY_AMOUNT: "Pay amount",
            PAY_CURRENCY: "Pay Currency",
            PAY_SERVICE: "E-money pay service",
            POINT: "Point",
            QUANTITY: "Quantity",
            RECEIVER: "Receiver",
            RECEIVE_CURRENCY: "Receive Currency",
            RECIEVE_CURRENCY: "Receive currency",
            RECIEVE_TYPE: "Receive type",
            REFRENCE_NUMBER: "Request amount",
            REQUESTED_DATE: "Request date",
            REQUESTS: "Requests",
            REQUEST_DATE: "Request date",
            REQUEST_INFO: "Request details",
            REQUEST_DEPOSIT_INFO: "Request information",
            REQUEST_LIST: "Request List",
            SECURITY: "Security settings",
            SELECT_FRIEND: "Select Friend",
            SELL_AMOUNT: "Sell amount",
            SEND_DATE: "Send date",
            SEND_TO_THIRD_PARTY: "Deposit to third party account",
            SEND_TO_THIRD_PARTY_TC_WALLET: "Send to friend\'s wallet",
            SERVICE_NAME: "Name",
            THIRD_PARTY: "Third party",
            THIRD_PARTY_INFORMATION: "Third party information",
            THIRD_PARTY_WALLET: "Third Party Wallet",
            TOTAL_AMOUNT: "Total paid amount",
            TO_WALLET: "To wallet",
            TRACKING_NUMBER: "Tracking Number",
            TRANSFER_DATE: "Transfer Date",
            TRANSFER: 'Transfer',
            TRANSFER_AMOUNT: 'Transfer Amount',
            VERIFY: "Confirm",
            WAITING: "Waiting",
            WALLET: "Wallet",
            WALLET_NOT_FOUND: "Wallet was not found",
            WAYS_SEND_TO_OTHERS: "Methods of sending to others",
            WHEN_RECEIVE_PAYMENT_INFO: "After receiving the payment information, you can follow the continuation of the steps",
            WITHDRAWAL_AMOUNT: "Withdrawal amount",
            WITHDRAWAL_TYPE: "Withdrawal method",
            YOUR_REQUEST_SUBMITTED: "Your request has been submitted successfully.",
            CRYPTO: 'Crypto',
            BY_LOCAL_PAYMENT: 'By Local Payment',
            WITH_CRYPTOCURRENCY: 'With Cryptocurrency',
            WITH_EMONEY: 'With E-Money',
            SERVICE_PAYMENT: 'Service Payment',
            CRYPTO_PAYMENT: 'Crypto Payment',
            CONVERSATION_CLODES: 'This conversation is closed',
            PAYMENT_AMOUNT: 'Payment Amount',
            NO_PAYMENT: "There is no submitted payment to show.",
            OTHER_WAYS_TRANSMISSION: "Transfer by other methods",
            TRANSACTION_AMOUNT: 'Transaction Amount',
            SELECT_BANK: 'Select Bank Account',
            SELECT_PAYMENT_GATEWAY: 'Select payment gateway',
            I_PAY: "I Pay",
            TOTAL_RECEIVED: "Total Received",
            COMPLETE_THE_REQUESt: 'Complete The Request',
            CHANGE_INFORMATION: 'Change Information',
            SUBMIT_REQUEST: 'Submit',
            VERIFY_INFORMATION: 'Verify Information',
            SUCCESS_ALERT: 'Your request has been successfully registered.',
            VERIFY_INFO_ERROR_ALERT: 'Confirm the correctness of the above information.',

            DEPOSIT: {
                CHARGE_AMOUNT: "Charge Amount",
                CHARGE_TYPE: "Charge method",
                DEPOSIT_INFO: "Payment info",
                MONY_CURRENCY: "Local payment",
                BY_ID: {
                    CREATE_ID: 'Create ID',
                    SELECT_WALLET: 'select wallet',
                    CHANGE_DEFAULT_WALLET: 'change',
                    PAY_BY_ID: 'Pay by deposit ID',
                    DEPOSIT_AMOUNT: 'Deposit Amount',
                    MONEY_MEETING: 'Receiving amount',
                    STEP1_TEXT: 'First, transfer the amount to the destination account through Satna or Paya along with the deposit ID.',
                    STEP1_TEXT2: 'Deposit ID registration is required',
                    STEP2_TEXT: 'Wait for your wallet to be recharged, the amount will be automatically added to your wallet during the Paya cycle and you will be notified',
                    ALERT: "If you transfer the amount from Mellat Bank account to deposit method, your wallet will be charged sooner due to Mellat being the destination bank.",
                    ALERT1: "When transferring money, it is mandatory to register the deposit ID. If you do not register or incorrectly register the deposit ID, your wallet will not be charged; the money will be returned after 72 hours and the deposit fee will be deducted.",
                    DESTINATION_IBAN: "IBAN Destination",
                    DESTINATION_ACCOUNT_NUM: "Destination Account Number",
                    DESTINATION_ACCOUNT_OWNER_NAME: "Account Owner Name",
                    DEPOSIT_ID: "Deposit ID",
                    ORIGIN_IBAN: "IBAN Source",
                    TIP1: 'The deposit must be made with your approved cards in TC, otherwise the amount will be returned to your account after 24 hours.',
                    TIP2: "If you deposit an amount from an account other than the account connected to the ID, the money will be returned after 72 hours and the deposit fee will be deducted.",
                    ALERT_ADD: '- IBAN number must be in your name and confirmed in TC. \n - Every bank account will have a unique deposit ID permanently.',
                    EMPTY_ID: "Please create a deposit ID",
                    NEW: 'new',
                    SELECT_DEFAULT_WALLET_TO_DEPOSIT: 'The default wallet you want to top up with the deposit ID; choose.',
                    SELECT_SOURCE_ACCOUNT: 'To top up Riyal wallet, make a deposit to one of the destination accounts through the deposit ID.',
                    ID_CREATED_SUCCESSFULLY: 'The payment ID was created successfully.',
                    DEFAULT_WALLET_CHANGED_SUCCESSFULLY: 'Operation completed successfully',
                    YOU_DONT_HAVE_ENOUGH_BANK_ACCOUNT: 'You don\'t have a bank account',
                    FIRST_REGISTER_BANK_ACCOUNT: 'First register a bank account.',
                    EDIT_MOBILE_NUMBER: 'Edit Mobile Number',
                    STATUS: {
                        VERIFIED: 'verified',
                        REJECTED: 'rejected',
                        PENDING: 'pending',
                    },
                    EXCEPTION_IN_CREATION_ID: 'Error creating ID',
                    ID_CREATION_FAILED: 'Failed to create ID',
                    ID_CREATION_PENDING: 'Please wait for the destination account information and deposit ID to be displayed.',
                    CREATE_ID_AGAIN_ALERT: 'Dear user, please create ID again',
                    CONTACT_SUPPORT_ALERT: 'Dear user, please contact support to solve this problem'
                },
                ALERT: {
                    WAIT_FOR_GET_CASH_PAY_DETAIL: "Your request has been successfully submitted. Please wait for a message or a call from the expert.",
                    WAIT_FOR_PROCESS_PAYMENT_REQUEST: "Dear User after reviewing and confirming your registerd payments, We will charge your wallet accordingly.",
                },
                CHARGING_TC: 'Charging TC Wallets by cash and Banking',
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: "Deposit Request Notification",
                            REJECTED: 'Payment rejected',
                            ACCOUNT_ASSIGNED: 'Payment information'
                        },
                        BODY: {
                            MESSAGE: "A message has been sent by the expert for the request with the tracking number {{0}}.",
                            REFUND: "Request with the tracking number {{0}} has been refunded to your wallet.",
                            REJECTED: "Request with the tracking number {{0}} has been rejected.",
                            AUTO_REJECTED: "Request with the tracking number {{0}} has been rejected.",
                            DONE: 'The request with the tracking number {{0}} was successfully completed',
                            ACCOUNT_ASSIGNED: 'Bank account information was registered to pay the deposit request with the tracking number {{0}}.'
                        }
                    }
                },
                STEPS_HINT: {
                    SELECT_WALLET: 'Choose your wallet which you want to charge',
                    ENTER_EMONEY_AMOUNT: 'Enter the amount of electronic money you want to pay in order to charge the wallet.',
                    ENTER_CRYPTO_AMOUNT: 'Enter the amount of Cryptocurrency you want to pay in order to charge the wallet.',
                    ACCEPT_INFO: 'To submit a request, check and confirm the accuracy of the information.',
                    ENTER_EXCHANGE_AMOUNT: 'Enter the amount you want to exchange.',
                    PAYMENT_EMONEY: 'Please deposit the amount to the mentioned account and then register your payment information.',
                    ENTER_AMOUNT: 'enter the amount you want to deposit',
                    BANK_WAITING: 'Your request has been successfully submitted, please wait to receive our account information for payment',
                    CASH_WAITING: 'Your request has been successfully submitted،Please wait to receive payment location information',
                    BANK_PAYMENT: 'Please deposit the payable amount to the mentioned account',
                    CASH_PAYMENT: 'After delivery, register the payment information',
                    ONLINE_PAYMENT: 'Your request has been successfully submitted، Please select your bank and pay the amount online',
                    CREDIT_ENTER_PAYMENT_INFO: 'Please enter payment information.',
                    GATEWAY_PAY: 'Your request has been successfully submitted. Please pay the desired amount through the portal of the source site by clicking on the payment button.'

                },
                CRYPTO: {
                    WITH_CRYPTO: 'Via cryptocurrency',
                    WIDOE_GUIDE: 'Video guide',
                    CURRENCY_TYPE: 'Type of cryptocurrency',
                    SELECT_NETWORK: 'Select the network',
                    CONTROL_ADDRESS: 'Carefully check your deposit address. If you enter an incorrect address, your assets may become inaccessible.',
                    DIRECT_DEPOSIT: 'Avoid direct deposits from international exchanges, especially American exchanges like CoinBase and Kraken, which restrict Iranian users. If necessary, use a personal wallet, disposable addresses, and multi-layer transfer methods to keep your assets secure.',
                    DEPOSIT_ADDRESS: 'Tether deposit address',
                    ASSETS_SECURITY: 'To keep your assets secure, please only deposit Tether to this address. Depositing any other currency to this address may result in the loss of your assets.',
                    SELECT_TRANSFER_NETWORK: 'To receive a Tether deposit address, first select the transfer network.'
                },
                DIRECT_DEPOSIT: {
                    DIRECT_DEPOSIT_TITLE: 'Bank Transfer',
                    ALERT: 'The deposit must be made using your verified cards on TC. Otherwise, the amount will be refunded to your account after 24 hours.',
                    ALERT_LINE_TWO: 'Your selected wallet will be credited after deposit confirmation at the real-time exchange rate.',
                    DESC_DIRECT_DEPOSIT: 'To top up your wallet, transfer funds to one of the destination accounts.',
                    MY_BANK_ACCOUNT: 'My Bank Accounts',
                    DEPOSIT_AMOUNT_GUIDE_TEXT_ONE: 'First, transfer the amount to the destination account via Satna, Paya or Pol.',
                    MONEY_MEETING: 'Money Settlement',
                    DEPOSIT_AMOUNT_GUIDE_TEXT_TWO: 'Your selected wallet will be credited after your deposit is confirmed at the real-time exchange rate.',
                    SELECT_WALLET_FOR_DIRECT_DEPOSIT: 'Select the default wallet you want to top up.',
                    ONLY_RIAL_WALLET: 'You can only recharge your Rial wallet.',
                },
                OFFLINE: {
                    TITLE: 'Offline Deposit',
                    CARD_OFFLINE_DEPOSIT: 'Offline Card-to-Card Deposit',
                    IBAN_OFFLINE_DEPOSIT: 'Iban Offline',
                    DEPOSIT_CARD_NUMBER: 'Deposit Card Number',
                    CONTINUED_GUIDE: 'Continue Guide',
                    CARD_PAGE_DESC_SUPPORT: 'Make a payment using the card number above and send the payment receipt to support so this case can be followed up.',
                    EN_IBAN_OFFLINE: 'Iban Offline',
                    HOW_IS_THIS_ROUTE_DONE: 'How is this route done?',
                    IBAN_PAGE_DESC_NUMBER: 'For IBAN transfers, please contact support before making the payment. The amount and deposit destination will be verified, and payment details will be coordinated exclusively for your request.',
                    ALERT_IBAN_PAGE: 'Before any IBAN transfer, please coordinate with support first.',
                    WALLET_TC: 'TC Wallet',
                    BANK_CARD: 'Bank Card',
                    AMOUNT_RECEIVED: 'Amount Received:',
                    ALERT_SELECT_BANK: 'You can only select a bank that you have already verified in TC.',
                    ALERT_RATE_BANK: 'Deposits must be made using cards verified in TC; otherwise, the amount will be refunded to your account after 72 hours. Your selected wallet will be charged at the real-time exchange rate upon deposit confirmation.',
                    SUBMIT_FORM: 'Submit Form',
                    REFRENCE_NUMBER: 'Transaction Reference/Documentation Code/Reference number',
                    ALERT_PRICE_RATE_COMMISSION: 'This is not the final wallet top-up amount. The commission fee and the live exchange rate may affect the final amount. For more information, please contact support.',
                    INFO_EXCHANGE_RAGE_SUBMIT: 'Rate at the time of submission: Every {{payAmount}} {{payAmountCurrency}} is equivalent to {{getAmount}} {{getAmountCurrency}}. The final rate will be calculated based on the exchange rate at the time the deposit is received.',
                    CARD_NUMBER: 'Card Number',
                    IBAN_NUMBER: 'IBAN Number',
                    ALERT_UNNECESSARY_FORM_SUBMISSION_WARNING: 'If your deposit has not been successfully completed, please refrain from submitting unnecessary forms.',
                }
            },

            WITHDRAWAL: {
                ACCOUNT_INFORMATION: "Account details",
                BANK_ACCOUNT: "Bank account",
                DEPOSIT_TO_MY_ACCOUNT: "Deposit to my account",
                DEPOSIT_TO_THIRD_PARTY_ACCOUNT: "Deposit to Third party account",
                E_MONEY_PAYMENT: "Deposit E-Money",
                E_MONEY_WITHDRAWAL: "Withdraw E-Money",
                LOCAL_PAYMENT: "Local payment",
                LOCAL_WITHDRAWAL: "Withdraw Local payment",
                LOCATION: "Delivery Location",
                RECEIVER_NAME: "Receiver\'s name",
                RECEIVER_NAME_HINT: "If the receiver is going to be someone other than yourself, Please write their full name.",
                SELECT_ACCOUNT: "Select account",
                TO_CRYPTOCURRENCY_ACCOUNT: 'To Cryptocurrency Account',
                TO_EMONEY_ACCOUNT: 'To E-Money Account',
                ALERT_PENDING_PROCCESING: 'Pending approval and review',
                ALERT_PENDING_PROCCESING_Text: 'After checking and confirming the information, the amount will be automatically added to your account during the payment cycle and you will be notified.',
                SETTLEMENT_TIME: 'Settlement Time',
                SETTLEMENT_TIME_TEXT: 'The amount will be automatically transferred to your accounts during the regular working cycle* by 17:00 of the next day and will be notified to you.',
                WITHDRAW_BANK_RULE_TEXT: 'The total Withdrawal amount is up to {{value}} million toman, with a maximum of {{count}} withdrawal requests per day.',
                WITHDRAW_ADD_BANK_ACCOUNT_TEXT: 'Due to the limit of daily deposit to each bank account ({{value}} million Tomans); To receive the full amount, register {{accountCount}} more bank account or change the requested amount.',
                WITHDRAW_BANK_ACCOUNT_PENDING_VERIFY: 'Bank account pending verification',
                WITHDRAW_BANK_ACCOUNT_PENDING_VERIFY_TEXT: 'Your bank account information is being verified, please register a withdrawal request after verifying the account.',
                DEPOSIT_TO: 'Deposit To',
                WITHDRAWAL_INFO: 'Withdrawal information',
                WAIT_FOR_CONFIRMATION_OF_ACCOUNT: 'Wait for confirmation of account information',
                ACCOUNT_SELECTION_IS_REQUIRED: 'Account selection is required.',
                RECEIVED_AMOUNT_EXCEEDS_DAILY_SETTLEMENT_LIMIT: "The amount to be received exceeds the daily settlement limit.",
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: 'Withdraw Request Notification',

                        },
                        BODY: {
                            DONE: "Request with tracking number {{0}} has been done. Amount of {{1}} has been withdrawn from your wallet.",
                            MESSAGE: "A message has been sent by the expert for the request with the tracking number {{0}}.",
                            REFUND: "Request with tracking number {{0}} has been refunded.",
                            REJECT: "Request with tracking number {{0}} has been rejected.",
                            REJECTED: 'The request with the tracking number {{0}} was rejected.',
                        }
                    }
                },
                STEPS_HINT: {
                    SELECT_EMONEY_ACCOUNT: 'Select your electronic money account which you want to deposit.',
                    SELECT_CRYPTO_ACCOUNT: 'Select your Cryptocurrency account which you want to deposit.',
                    SELECT_WALLET: 'Choose your wallet to withdraw the amount.',
                    ENTER_AMOUNT: 'Enter the withdrawal amount from your desired wallet.',
                    ACCEPT_INFO: 'To submit a request, check and confirm the accuracy of the information.',
                    SELECT_BANK_ACCOUNT: 'Select your bank account to deposit.',
                    SELECT_LOCATION: 'Select the desired city to receive the amount.',
                    ENTER_RECEIVER_NAME: 'Enter the recipient\'s first and last name.',
                    TRANSFER_TO_ACCOUNT: 'Transfer the desired amount to the {{value}} account.'
                },
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: "Withrawn amount should not exceed the balance of your wallet.",
                    CRYPTO_REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: 'The withdrawal amount cannot exceed the withdrawable balance.',
                },
                CRYPTO: {
                    CHECK_NETWORK: 'Ensure that the network you select for the transfer matches the network of the destination address.',
                    TO_ADDRESS: 'Destination address',
                    LOSE_ASSETS: 'Entering an invalid address will result in the loss of your assets.',
                    WITHDRAW_AMOUNT: 'Withdrawal amount',
                    TETHER: 'Tether',
                    BALANCE: 'Balance',
                    WITHDARABLE: 'Available',
                    MIN: 'Min',
                    MAX: 'Max',
                    CALCULATES: 'Accounts',
                    FILL_INFO: 'Enter the information first',
                    CANCEL: 'Cancel',
                    REGISTER: 'Submit',
                    NETWORK_FEE: ' transaction fee',
                    FINAL_WITHDRAW_AMOUNT: 'Amount sent to your wallet address',
                    WITHDRAW_CONFIRMATION: 'Withdrawal Confirmation',
                    ENSURE_NETWORK: 'Ensure the network address is correct.',
                    CANNOT_CANCEL: 'Once the request is submitted, withdrawal cannot be canceled.',
                    NETWORK: 'Network',
                    CANCEL_CONFIRM: 'Cancel',
                    ACCEPT: 'Accept',
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: "The withdrawal amount cannot exceed the network's maximum withdrawal limit ({{amount}} {{currency}}).",
                    REQUESTED_AMOUNT_IS_LESS_THAN_BALANCE: "The withdrawal amount cannot be lower than the minimum withdrawal amount ({{amount}} {{currency}}).",
                    DEPOSIT: 'Wallet Top-Up',
                    YOU_DONT_HAVE_A_CRYPTO_WALLET: 'You don’t have a crypto wallet.',
                    PLEASE_CREATE_A_WALLET_FIRST: 'Please create a wallet first.',
                    YOUR_WALLET_IS_EMPTY: 'Your wallet is empty!',
                    FIRST_UP_TO_BALANCE_WALLET: 'Please top up your balance first so you can proceed with your withdrawal.',
                    PROCESSING: 'Processing',
                    ALERT_PENDING_PROCCESING: 'Your withdrawal is being processed on the blockchain network. This process may take some time; please be patient.',
                    FROM_WALLET: 'From Wallet',
                    WITHDRAWAL_AMOUNT_FROM_WALLET: 'Withdrawal Amount from Wallet',
                    DESTINATION_ADDRESS: 'Destination Address',
                    TRANSACTION_ID: 'Transaction ID (hash)',
                    AMOUNT_DEPOSITED_TO_DESTINATION_ADDRESS: 'Amount Deposited to Destination Address',
                    NETWORK_TRANSFER_FEE: 'Network Transfer Fee',
                    REJECTED_TITLE: 'Reason for Request Rejection',
                    ALERT_WITHDRAWABLE_TEXT: 'You can only withdraw cryptocurrency up to the amount of your crypto deposit.',
                    TOTAL_BALANCE: 'Total Balance:',
                    WITHDRAWABLE_BALANCE: 'Withdrawable Balance:',
                    YOU_HAVE_NOT_ADDED_ANY_CRYPTO_ASSETS_YET: "You haven't added any crypto assets yet.",
                    CRYPTO_DEPOSIT: 'Crypto Deposit',
                }
            },
            SEND: {
                ENTER_ALERT_INFORMATION: "Please enter the required info.",
                INTERNAL_TRANSFER: "Internal Transfer",
                LOCAL_SEND: "Local Payment",
                TC_TO_TC: 'TC to TC',
                RECEIVER: 'Receiver',
                RECEIVER_FULL_NAME: 'Receiver Full Name',
                RECEIVER_USER_NAME: 'Receiver Username',
                SEND_AMOUNT: 'Send Amount',
                PAY_AMOUNT: 'Pay Amount',
                SEND_FROM_TC_WALLET: 'Send from tc wallet',
                SEND_TYPE: 'Send Type',
                SEND_DATE: 'Send Date',
                TO_TC: 'to TC',
                SEND: "Send",
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: "Sending Amount should not exceed wallet\' balance.",
                    WITHDRAWAL_AMOUNT_IS_MORE_THAN_BALANCE: "The withdrawal amount, including fees, cannot exceed the wallet balance.",
                },
                ALERT: {
                    SEND_TC_WALLET_SUCCESS: "Sending to destination wallet was successful.",
                    WAIT_FOR_GET_CASH_PAY_DETAIL: "Your request has been successfully submitted. Please wait for a message or a call from the expert.",
                    WAIT_FOR_PROCESS_PAYMENT_REQUEST: "Dear User after reviewing and confirming your registerd payments, We will charge your wallet accordingly.",
                },
                TC_WALLET_SEND: 'TC-Wallet Payment',
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            ACCOUNT_ASSIGNED: 'Send request payment information'
                        },
                        BODY: {
                            DONE: "Request with Tracking number {{0}} was successfully Done. The amount of {{1}} was deposited to your destination account.",
                            REFUND: "Request with tracking number {{0}} was Refunded.",
                            REJECTED: "Request with tracjing number {{0}} was Rejected.",
                            TO_ANOTHER: 'The request with the tracking number {{0}} was successfully completed.',
                            ACCOUNT_ASSIGNED: 'Bank account information was registered to pay the send request with the tracking number {{0}}.'

                        }
                    }
                },
                STEPS_HINT: {
                    SELECT_THIRD_PARTY_WALLET: 'Specify the recipient\'s wallet to send the amount',
                    ENTER_SEND_AMOUNT: 'Enter the payment amount',
                    ACCEPT_INFO: 'To submit a request, check and confirm the accuracy of the information.',
                    BANK_WAITING: 'Your request has been successfully submitted, please wait to receive our account information for payment.',
                    BANK_PAYMENT: 'Please deposit the payable amount to the mentioned account.',
                    CASH_WAITING: 'Your request has been successfully submitted،Please wait to receive payment location information.',
                    CASH_PAYMENT: 'After delivery, register the payment information',
                    ENTER_PAYMENT_INFO: 'Please enter payment information.',
                    ONLINE_PAYMENT: 'Your request has been successfully submitted، Please select your bank and pay the amount online.'
                },
                TC_WALLET: {
                    NOTIFY: {
                        NOTIFICATION: {
                            BODY: {
                                RECEIVE: "Amount of {{0}} from the user {{1}} with tracking number of {{2}} Was received.",
                            }
                        }
                    },
                    STEPS_HINT: {
                        SELECT_WALLET: 'Choose your wallet to withdraw the amount.',
                        SELECT_THIRD_PARTY_WALLET: 'Specify the recipient\'s wallet to send the amount',
                        ENTER_SEND_AMOUNT: 'Enter the sent amount',
                        ACCEPT_INFO: 'To submit a request, check and confirm the accuracy of the information.',
                    },
                }
            },
            RECEIVE: {
                AMOUNT: "Received Amount",
                ARCHIVE: "Archive",
                ARCHIVED: "Archived",
                ARCHIVED_DATE_FROM: "Archive from date of",
                ARCHIVED_DATE_TO: "Archive to date of",
                ARCHIVED_SUCCESSFULLY: "Transaction was successfully archived.",
                BE_ARCHIVED: "Get Archived",
                FROM_USER: "From User",
                FROM_WALLET: "From wallet",
                MORE_INFO: "More info",
                RECEIVE_DATE: "Date of receive",
                RECIEVE_INFO: "Received payment details",
                RECIVE: "Receive",
                SENDER: "Sender",
                TO_WALLET: "To wallet",
                OTHER_WAY: {
                    NOTIFY: {
                        NOTIFICATION: {
                            BODY: {
                                TO_ANOTHER: "Amount of {{0}} from the user {{1}} with tracking number of {{2}} Was received."
                            }
                        }
                    }
                }
            },
            EXCHANGE: {
                CHANGE: "Changes saved successfully.",
                CURRENCY: "Exchange pay Service",
                ELECTRONIC_MONEY: "E-money",
                ELECTRONIC_MONEY_TO_ELECTRONIC_MONEY: "E-money Exchange",
                EXCHANGE: "Exchange",
                EXCHANGE_AMOUNT: "Exchange amount",
                EXCHANGE_DATE: "Exchange date",
                EXCHANGE_INFO: "Exchange info",
                EXCHANGE_TYPE: "Exchange type",
                GET_SERVICE: "Get with E-money",
                LOCAL_PAYMENT: "Local Payment",
                NEW_EXCHANGE: "New Exchange",
                NO_HAVE_ANY_GET_SERVICE: "No Get service is available.",
                SELECT: "Select",
                SELECTED_GET_SERVICE: "Pay in E-money",
                SELECTED_PAY_SERVICE: "Pay with E-money",
                SELECT_CURRENCY: "Exchange currency",
                SELECT_GET_SERVICE: "Choose E-money Get service",
                SELECT_PAY_SERVICE: "Choose E-money pay service",
                TC_TO_TC: "TC to TC",
                TC_WALLET: "TC Wallet",
                PAY_SERVICE: 'Pay Service',
                SUBSERVICE: 'Subservice',
                STEPS_HINT: {
                    SELECT_WALLET: 'Choose your wallet to withdraw the amount.',
                    SELECT_WALLET_TO_TRANSFER: 'Choose your wallet to transfer money.',
                    ENTER_EXCHANGE_AMOUNT: 'Enter the amount you want to conver',
                    ACCEPT_INFO: 'To submit a request, check and confirm the accuracy of the information.',
                    SELECT_PAY_GET_SERVICE: 'Select the paid / received service to convert.',
                    ENTER_ACCOUNT_INFO: 'Specify your account information or that of the recipient.',
                    PAYMENT: 'Your request has been successfully submitted, please deposit the amount to the mentioned account and then register your payment information.'
                },

                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: 'Exchange service notification',
                        },
                        BODY: {
                            DONE: "Request with Tracking number {{0}} was successfully Done. The amount of {{1}} was deposited to your destination account.",
                            MESSAGE: "A message has been sent by the expert for the request with the tracking number {{0}}.",
                            REFUND: "Request with tracking number {{0}} was Refunded.",
                            REJECT: "Request with tracjing number … was Rejected.",
                            REJECTED: 'The request with the tracking number {{0}} was rejected.',
                        }
                    }
                },
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: 'Exchange amount should not exceed the wallet\'s balance.'
                }
            },
            VOUCHER: {
                AMOUNT: "Amount",
                COMISSION: "Commission",
                EXCHANGE_RATE: "Exchange rate",
                MAX_QUANTITY: "Maximum quantity",
                MIN_QUANTITY: "Minimum quantity",
                PURCHASED_DATE: "Purchase date",
                PURCHASED_INFO: "Purchase details",
                PURCHASED_VOUCHERS: "Purchased Vouchers",
                QUANTITY: "Quantity",
                SERIAL_NUMBER: "Serial Number",
                TOTAL_COMISSION: "Total commission",
                TOTAL_PRICE: "Total price",
                UNIT_COMMISSION: "Unit commission",
                UNIT_PRICE: "Price per Unit",
                USER_PRICE: "User Price",
                VOUCHER: "Voucher",
                VOUCHER_ITEM: "Voucher item",
                VOUCHER_TYPE: "Voucher type",
                WOULD_RECEIVE_VOUCHER_INFO_EMAIL: "Would you like to receive you purchased voucher\'s info via Email?",
                VOUCHER_NAME: 'Voucher Name',
                TYPE: 'Type',
                STEPS_HINT: {
                    SELECT_WALLET: 'Choose your wallet to buy a voucher.',
                    NUMBER_OF_PURCHASE: 'Enter the desired number to purchase the selected voucher.',
                    ACCEPT_INFO: 'To submit a request, check and confirm the accuracy of the information.',
                }
            },
            POINTS: {
                CHANGE_STATUS: "Change status",
                CHANGE_TYPE: "Status change",
                EACH: "Each 1000 points",
                EACH_1000_POINT: "Each 1000 points",
                GET_AMOUNT: "Get Amount",
                INVOICE_TYPE: "Exchanging points to balance",
                MIN_NUM_FOR_WITHDAWAL: "Minimum amount of points to withdraw",
                MY_POINTS: "My points",
                NEW_WITHDRAWAL: "New withdrawal",
                NUMBER_OF_POINT: "Number of points",
                NUMBER_OF_POINTS: "Number of points",
                POINTS: "Point",
                TOTAL_POINTS: "Total Points",
                TO_TC_WALLET: "Deposit to TC wallet",
                TRANSACTION_NAME: "Transaction Name",
                TRANSACTION_TYPE: "Transaction Type",
                WALLET: "Wallet",
                WHITDRAW_POINT: "Pionts Withdrawal",
                WITHDRAWAL: "Points withdrawal",
                WITHDRAWAL_INFO: "Withdrawal Details",
                WITHDRAWAL_POINTS: "Withdrawn points",
                WITHDRAW_DATE: "Withdrawal Date",
                STEPS_HINT: {
                    SELECT_WALLET: 'Choose your wallet to deposit the amount.',
                    POINT_WITHDRAWAL: 'Enter the desired point to withdraw.',
                    ACCEPT_INFO: 'To submit a request, check and confirm the accuracy of the information.',
                },
                ALERT: {
                    IS_LOWER_THAN_MIN: "You total points is less than minimum amount of withdrawal."
                },
                VALIDATION: {
                    MIN_POINT_FOR_WITHDRAWAL: "Minimum amount of withdrawal:",
                }
            },
            CONFIRMATION: {
                CONFIRMATION_CODE: "Confirmation Code",
                CONFIRMATION_HELP_EMAIL: "To submit your request, Please enter the confirmation code that was sent to your Email.",
                CONFIRMATION_HELP_SMS: "To submit your request, Please enter the confirmation code that was sent to your Mobile Phone.",
                CONFIRMATION_HELP_2FA: 'To submit your request, Please enter the 6-digit code from Authenticator',
                SECURITY_CODE: "Confirmation Code",
                SEND_CODE: "Send Code",
                AUTHENTICATOR_CODE: "Authenticator Code",
                ENTER_CODE_FROM_AUTHENTICATOR: "Please check your spam folder if you didn't receive the code in your inbox."
            },
            PAYMENT: {
                ACCOUNT_INFO: 'Account Info',
                ADD: 'Add Payment',
                AMOUNT: 'Amount',
                AMOUNT_MUST_PAY: 'Please deposit {{value}} this account, then register your payment information.',
                AMOUNT_MUST_PAY_CASH: 'Please deliver the amount of {{value}} to the desired location and then register your payment information',
                AMOUNT_OUT_STANSING: 'Amount Outstanding',
                CREATED_DATE: "Submition date",
                INTER_PAYMENT_INFO: "Please enter the payment info",
                MY_PAYMENTS: "My payments",
                NEW_PAYMENT: "New Payment",
                PAYMENT: "Payment",
                PAYMENT_AMOUNT: "Payable amount",
                PAYMENT_DATE: "Payment date",
                PAYMENT_DETAILS: "Payment details",
                PAYMENT_HISTORY: "Payment History",
                PAYMENT_INFO: "Payment info",
                PAYMENT_LOCATION: "Payment location",
                PAYMENT_REF_NUMBER: "Refrence Number",
                PAY_AMOUNT: "Pay amount",
                PAY_NOW: "Pay",
                REFRENCE_NUMBER: "Request Number",
                TRANSACTIONS_PAYMENTS: 'Transactions Payment',
                SENDER: "Sender",
                SENDER_ACCOUNT_NUMBER: "Account info",
                WALLET_ADDRESS: 'Wallet Address',
                HASH: 'Hash',
                MEMO: 'Memo',
                TAG: 'Tag',
                SEND_BY_THIRD_PARTY: "Pay from third party account",
                SUM_OF_TOTAL_AMOUNT_APPROVED: "Total Approved amount",
                TC_ACCOUNT: "TC Account",
                TC_PAYMENTS: "TC Payments",
                TC_SERVICE_ACCOUNT: "TC Account",
                TOTAL_AMOUNT_PAID: "Total Paid amount",
                TOTAL_WAITING_FOR_CONFIRMATION: "Total pending amount",
                YOUR_ACCOUNT: 'Your Account',
                YOUR_SERVICE_ACCOUNT: "Your account will be verified by experts after review.",
                YOU_HAVE: 'You have',
                YOUR_REQUEST_WILL_BE_REJECT_AFTER_TIME_FINISHED: 'minutes to add your payments, after this time, request will be rejected.',
                TIME_FINISHED: 'Your time to add payment is over',
                E_MONEY: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                REJECTED: 'Payment rejected',
                            },
                            BODY: {
                                REJECTED: "Payment for the request with the tracking number of {{0}} was rejected",
                            }
                        }
                    }
                },
                BANK: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                REJECTED: 'Payment rejected',
                                ACCOUNT_ASSIGNED: 'Payment info'
                            },
                            BODY: {
                                ACCOUNT_ASSIGNED: "Bank account details for the request with the tracking number of {{0}} was Submitted.",
                                REJECTED: "Payment for the request with the tracking number of {{0}} was rejected"
                            }
                        }

                    }

                },

                CASH: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                REJECTED: 'Payment rejected',

                            },
                            BODY: {
                                REJECTED: "Payment for the request with the tracking number of {{0}} was rejected"
                            }
                        }
                    }
                },
                ALERT: {
                    CANT_DELETE_PAYMENT: 'You can not delete this payment.',
                }
            },
            PAYMENT_GATEWAY: {
                TRANSACTION_ID: 'Transaction ID',
                TYPE: 'Type',
                AMOUNT: 'Amount',
                REQUESTED_AMOUNT: 'Requested Amount',
                REQUESTED_AMOUNT_DETAIL: 'Requested Amount',
                PAY_AMOUNT: 'Pay Amount',
                GET_AMOUNT: 'Get Amount',
                SETTLEMENT_AMOUNT: 'Settlement Amount',
                STATUS: 'Status',
                MERCHANT: 'Merchant',
                CREATED_IP_ADDRESS: 'Created IP Address',
                STATUS_HISTORY: 'Status History',
                INVOICE_NUMBER: 'Invoice Number',
                TERMINAL_ID: 'Terminal ID',
                TERMINAL_WALLET: 'Terminal Wallet',
                CONSUMER_WALLET: 'Consumer Wallet',
                USER: 'User',
                SETTLEMENT_DATE: 'Settlement Date',
                ADDITIANAL_DATA: 'Additianal Data',
                TERMINAL: 'Terminal',
                LOCAL_DATE_TIME: 'Local Date Time',
                CONSUMER_ID: 'Consumer ID',
                RETURN_URL: 'Return Url',
                STATUS_DATE: 'Status Date:',
                EXCHANGE_RATE: "Exchange rate",
            },
            ALERT: {
                ONLINE_PAYMENT: "Attention, please use the selected card on the payment page of TopChange for completing the transaction. Otherwise, your request will not be processed, and the amount will not be traceable for up to 72 hours!",
                ADD_NEW_BANK: "If you are interestedin adding a new bank account.",
                AMOUNT_MUST_BE_INTEGER: "The amount should be in numbers.",
                AMOUNT_PRECISION_ERROR: "Decimal scale should be less than…",
                BETWEEN_MY_WALLET_SUCCESS: "Money transfer between desired wallets was successful",
                CAN_SEND_MESSAGE: "Sending a message is activated after registering the request",
                COMMISION_DATA_NOT_FOUND: "Commission info was not found.",
                COMMISSION_DATA_IS_NOT_DEFIENED: "Commission info was not registered.",
                CONFIRM_PAYMENT_DELETE: "Are you sure you want to delete this payment?",
                CONFIRM_REQUEST_DELETE: "Are you sure you want to delete this request?",
                CURRENCY_EXCHANGE_RATE_LIST_NOT_FOUND: "List of Currency exchange commissions was not found.",
                CURRENCY_LIST_IS_NOT_FOUND: "Currency list was not found.",
                ONLINE_SUCCESS: "Your payment was successful and your wallet was charged.",
                PAYMENT_ADD_SUCCESSFUL: "Your payment has been successfully submitted.",
                PAYMENT_DELETED_SUCCESS: "The selected payment has been deleted successfully.",
                PAYMENT_TEXT: "Your request is in payment status.",
                PROCESSING_TEXT: "Your request is in processing status.",
                REJECTED_TEXT: "You request has been rejected.",
                REQUEST_DELETED_SUCCESS: "The selected request has been deleted successfully.",
                REQUEST_WAS_NOT_FOUND: "Request was not found.",
                THERE_IS_NO_MESSAG: "There is no message to view.",
                THERE_IS_NO_MESSAGE: "There is no message to view.",
                THERE_IS_NO_MESSAGE_NEW: 'There is currently no message.',
                USE_V1: "Dear user, to follow up on this request, refer to the old version of the site.",
                WAITING_FOR_INFORMATION: "Please await payment information.",
                WAITING_MESSAGE: "Dear user, please wait for our experts to review your request",
                WAIT_FOR_GET_BANK_ACCOUNT_DETAILS: "Your request has been successfully submitted, the bank account information for deposit payment will be notified to you soon through notifications. You can exit the request at this stage and after receiving the information, register your payment to complete the charge of your wallet.",
                WAIT_FOR_PROCESS_CREDIT_REQUEST: "Dear user, after reviewing and confirming your payment information sent by our experts, the desired wallet will be charged.",
                WAIT_FOR_PROCESS_WITHDRAW_CASH_PAYMENT: "Dear user, after reviewing and confirming your request by our experts, the amount will be delivered to the desired recipient",
                WAIT_FOR_PROCESS_WITHDRAW_PAYMENT_REQUEST: "Dear user, after reviewing and confirming your request by our experts, the amount will be credited to the desired account",
                WAIT_FOR_PROCESS_WITHDRAW_BANK_PAYMENT_REQUEST: "Your withdrawal Request has been submitted.\nPlease note that all the Rial withdrawals in Topchange are processed and done via PAYA banking system. So you have to wait till the evening of the next day in order to receive your amount. Obviously there will be no settelments ftom PAYA system on fridays and public holidays.\nAlso be aware that after the completion of your request, Topchange will only deduct the amount from your wallet when it is confirmed that you have received the amount in your account. No withdrawal request can be cancelled after submission.",
                WAIT_FOR_PROCESS_WITHDRAW_BANK_PAYMENT_REQUEST2: "Please wait until the evening of next day to receive your amount and only get in contact with the support department after the aformentioned time.",
                WAIT_TILL_ACCEPT_PAYMENT: "Please wait for payment confirmation by experts",
                WHAIT_FOR_ASSIGN_PAYMENT: "Please wait for payment information from experts.",
                WITHDRAWAL_POINT_SUCCESS: "The points were withdrawn successfully and the amount was deposited in the desired wallet.",
                MIN_ORDER: 'The minimum order must be greater than {{value}}',
                MAX_ORDER: 'The maximum order must be less than {{value}}',
                NEED_VERIFY: 'For using this section you should do needed verifications',
                REQUEST_SUCCESS_WAITING: 'Your request has been submitted and is currently under review.',
                ALERT_REQUEST_SUCCESS_WAITING_TEXT: 'Your request will be reviewed within the next few hours, and the requested wallet balance will be updated accordingly.'
            },
            SELECTED_WALLET: 'Selected ',
            CURRENCY: 'Currency',
            NOTIFY: {
                TITLE: {
                    DEPOSIT_E_MONEY: "Deposit (E-money)",
                    DEPOSIT_MONEY_CURRENCY: "Deposit (Local payment)",
                    EXCHANGE_MONEY_CURRENCY: "Exchange (Wallet)",
                    POINT: "Point Withdrawals",
                    RECEIVE_OTHER_WAY: "Receive (Local payment)",
                    RECEIVE_TC_WALLET: "Receive (Wallet)",
                    SEND_OTHER_WAY: "Send (Local payment)",
                    SEND_TC_WALLET: "Send (E-money)",
                    VOUCHER: "Voucher",
                    WITHDRAWAL_E_MONEY: "Withdraw (E-money)",
                    WITHDRAWAL_MONEY_CURRENCY: "Withdraw (Local payment)",
                    DEPOSIT_CRYPTO: 'Deposit (Cryptocurrency)',
                    WITHDRAWAL_CRYPTO: 'Withdrawal (Cryptocurrency)',
                },
                NOTIFICATION: {
                    TITLE: {
                        MESSAGE: 'Deposit request message',
                    },
                    BODY: {
                        DONE: "The request with the tracking number {{0}} was successfully completed. Your wallet has been deposited {{1}}.",
                        MESSAGE: "A message has been sent by the expert for the request with the tracking number {{0}}.",
                        REFUND: "The request was returned with the tracking number {{0}}.",
                        REJECT: "The request with the tracking number {{0}} was rejected.",
                    }
                }
            },
            COMMISSION: {
                BONUS: "Bonus",
                BONUS_FIXED_AMOUNT: "Fixed amount",
                BUY_AMOUNT: "Buy amount",
                CALCULATED_AMOUNT: "Calculated amount with commission",
                CHARGE_AMOUNT: "Deposit amount",
                COMMISSION: "Commission",
                CONVERTED_AMOUNT: "Exchange amount",
                EXCHANGE_RATE: "Exchange rate",
                FIXED_AMOUNT: "Fixed amount",
                GET_AMOUNT: "Get amount",
                GET_AMOUNT_THIRD_PARTY: "Third party get amount",
                INITIAL_COST: "Initial cost",
                MAXIMUM_COMMISION: "Maximum commission",
                MINIMUM_COMMISION: "Minimum commission",
                MAXIMUM_BONUS: "Maximum bonus",
                MINIMUM_BONUS: "Minimum bonus",
                PAY_AMOUNT: "Pay amount",
                POINT: "Point",
                REQUESTED_AMOUNT: "Resuest amount",
                SELL_AMOUNT: "Sell amount",
                SEND_AMOUNT: "Send amount",
                UPDATE_TIME: "Updating",
                WITHDRAWAL_AMOUNT: "Withdrawal amount",
                CALCULATED_AMOUNT_BUNOS: 'Calculated Amount',
                CALCULATIONS: 'Calculations',
                CALCULATION_DETAILS: 'Calculation Details'
            },

            DIGITAL_CURRENCY_CRYPTO: 'cryptocurrency',
            TRANSACTION_NETWORK: 'Transaction network',
            TRANSACTION_ID: 'Transaction ID',
            AMOUNT_CRYPTO: 'Amount',
            REQUESTED_DATE_TRANSACTION: 'Transaction date',
            MORE: 'More',
            DEPOSIT_METHOD: 'Deposit method',
            TRANSACTION_SOURCE_ADDRESS: "Transaction source address",
            TRANSACTION_DESTINATION_ADDRESS: "Transaction destination address",
            RECEIVED_AMOUNT: "Received amount",
            MORE_INFORMATION: "More information",
            POINTS_CRYPTO: "Points",
            VIEW_TRANSACTION_LINK: "View transaction link",
            DIRECTDEPOSIT: {
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            DIRECT_DEPOSIT: {
                                SUCCESSFUL: 'Bank Transfer Successful',
                                REFUND: 'Bank Transfer Refunded'
                            }
                        },
                        BODY: {
                            DIRECT_DEPOSIT: {
                                SUCCESSFUL: 'Your bank transfer has been received and your wallet has been successfully credited.',
                                REFUND: 'Since the source account was not registered in TopChange, the transferred amount has been refunded to your bank account.'
                            }
                        }
                    }
                }
            }
        },
        HISTORY: {
            SERVICE: 'E-Money',
            WALLET: 'Wallet',
            REQUEST_STATUS: 'Request Status'
        },
        PROFILE: {
            ACCOUNT_INFO: "Account Info",
            CONTACT_INFO: "Contact Info",
            ADDRESS: "Address",
            ADDRESSES_DOC: "Choose proof of residence document",
            ADDRESS_INFO: "Address",
            BACK_IMAGE: "Back card",
            BACK_OF_ID_CARD: "Choose back of identity card image",
            BIRTH_DATE: "Birth date",
            CHANGE_PASSWORD: "Change password",
            CHANGE_YOUR_PHONE_NUMBER_QUESTION: "Do you want to change your mobile number?",
            CITY: "City",
            PHONECALL_INTERVIEW: 'Phone-Call Interview',
            KYC: 'KYC',
            LETTER_OF_COMMITMENT: 'Letter of commitment',
            CONFIRM_NEW_PASSWORD: "Confirm new password",
            COUNTRY: "Country",
            DRIVING_LICENSE: "Driving license",
            EDIT_MOBILE_INFO: "To change your mobile number, you must first confirm your current number",
            ENTER_CODE: "Enter the code",
            ENTER_YOUR_PHONE_NUMBER: "Enter your mobile number",
            FRONT_IMAGE: "Front Image",
            FRONT_OF_ID_CARD: "Choose front of identity card image",
            IDENTITY_CARD: "Identity card",
            IF_IMAGE_NOT_GOOD: "If the quality of the picture is not good enough",
            IMAGE_DETAIL: "Image details",
            LANDLINE_NUMBER: "Landline Number",
            MOBILE_NUMBER: "Mobile number",
            NEW_PASSWORD: "New password",
            NOT_VERIFIED: "Unverified",
            NOT_VERIFIED2: "Unverified",
            NOT_VERIFIED3: "Unverified",
            OLD_PASSWORD: "Previouse password",
            PASSPORT: "Passport",
            PERSONAL_INFO: "Personal info",
            PHONE_NUMBER: "Mobile number",
            PHOTO: "Photo",
            PLEASE_VERFY_PROFILE: "To use the site services, please confirm your information",
            REG_DATE: "Registration date",
            SELECT_ONE_BELOW_OPTIONS: "Please select one of the following options",
            STATE: "State",
            TAKE_IMAGE: "Take picture",
            TAKE_NEW_ONE: "Take a new picture",
            TAKE_PIC_DESCRIPTION: "Dear user, in order to prevent any violations and maintain the security of transactions, send us your photo with the following specifications. <br/>* All information should be written on white paper automatically.<br/>* Photo size less than 2 MB. <br/> <div class='title'>1- White sheet</div> Take a white sheet with the information specified in the image in front of you. <br/> <div class='title'>2- Attach ID card</div>- Attach your ID card to the sheet as you see in the picture. <br/> <div class='title'>3-Code</div> The code shown in Write the following form in your own handwriting on the sheet. <br/> <div class='title'>4- Text</div>- I, ......................., with national ID ..........., have sent my document to authenticate my identification at  Topchange website on ../../.. . I confirm that I did not provide this information to anyone else, and I have agreed not to buy or sell cryptocurrencies or fiat funds for any third parties. I understand and agree to all of the responsibilities that comes throughout my participation in both mentioned websites. <br/> <div class='title'>5-Signature</div> Your signature.",
            TITLE: "Profile",
            UPLOAD_DRIVING_PHOTO: "Choose drivering license image",
            UPLOAD_IDENTITY_CARD_PHOTO: "Upload identity card",
            UPLOAD_FRONT_OF_YOUR_IDENTITY_CARD_IMAGE: 'Upload front of your identity card image',
            UPLOAD_BACK_OF_YOUR_IDENTITY_CARD_IMAGE: 'Upload back of your identity card image',
            UPLOAD_IMAGE: "Choose image",
            UPLOAD_IMAGE_FROM_YOUR_STORAGE: "Upload from your system memory",
            UPLOAD_PASSPORT_PHOTO: "Choose passport image",
            UPLOAD_PHOTO_OF_PASSPORT: "Upload passport image",
            USER_GROUP: "User group",
            USE_CAMERA_TO_TAKE_IMAGE: "Use your phone's camera to take a picture.",
            VERIFICATION: "Verification",
            VERIFIED: "Verified",
            VERIFIED2: "Verified",
            VERIFY_CURRENT_PHONE_NUMBER: "Confirm current mobile number",
            VERIFY_NOW: "Info verification",
            VERIFY_PERSONAL_INFO: "Personal info verification",
            VERIFY_TEXT: "Verify",
            WRITE_BLOW_CODE_ON_PAPER: "Write this code on a paper.",
            YOUR_PHONE_NUMBER: "Mobile number",
            ZIP_CODE: "Zip code",
            VERIFY_DESCRIPTION: 'Dear user, in order to increase your security and prevent any violations by profiteers, please To confirm the following information',
            FIRST_NAME: 'First Name',
            LAST_NAME: 'Last Name',
            BIRTHDAY: 'Birthday',
            BIRTHDATE: 'Birthdate',
            GENDER: 'Gender',
            CHANGE_AVATAR: 'Change Avatar',
            YOUR_PHONE_NUMBER_IS: 'Your Mobile number is',
            SELECT_AVATAR_MESSAGE: 'Please select yout user photo then press submit',
            SELECT_AVATAR: 'Select Avatar',
            PHONECALL_INTERVIEW_DESCRIPTION: 'Kindly note that to maintain and improve the security of your TC account, you must first complete the phone-call authentication in order to use the financial services. Please click on the button below to receive a phone call by one of our admins.\n Please note that if you do not answer the call of our experts, you will not be able to re-apply for a phone-call interview within 3 hours.',
            PHONECALL_INTERVIEW_DESCRIPTION1: '1.Please note that you need to perform the phone-call verification step if and only if you intend to submit any of the following requests; Otherwise, you can skip this step of the verification process.',
            ADDRESS_DESCRIPTION1: '1.Please note that you need to perform the Address verification step if and only if you intend to submit any of the following requests; Otherwise, you can skip this step of the verification process.',
            PHONECALL_INTERVIEW_DESCRIPTION2: '2.Please note that in case of failure to respond to the call of our experts up to 3 hours you will not be able to register a request for a phone interview.',
            CALL_ME: 'Call Me!',
            RETRY_CALL_DIALOG_TEXT: 'Kindly note that, you must first complete the phone-call authentication in order to use the financial services. Please click the "Try it again" button to accomplish this.',
            WAITING_FOR_PHONECALL: 'Dear user, your request has been sent and our experts will contact you within 2 hours. Please be patient.',
            PHONECALL_INTERVIEW_DONE: 'You have successfully passed the phone call interview!',
            PHONECALL_INTERVIEW_REJECTED: 'Your request Rejected',
            PHONECALL_INTERVIEW_CONFIRM_DES: 'Dear user, please note that the verification of telephone calls is only for the following  is required, otherwise you will not need to do this verification:',
            SUPPORT: 'Support',
            SUSPENDED: 'Suspended',
            SUSPEND_ALERT: 'Your request wallet',
            SKIP: 'Skip',
            ERROR: {
                PASSWORD_MIN_LENGTH: 'Password must contain at least {{value}} characters',
                PASSWORD_MAX_LENGTH: 'maximum length of password is {{value}} characters',
                PASSWORD_IS_NOT_SAME: "Confirmation of new password is different to new password."
            },
            REQUESTS_TYPE: {
                DEPOSIT_E_MONEY: 'Deposit by local payment',
                DEPOSIT_MONEY_CURRENCY: 'Deposit by E-Money',
                EXCHANGE_MONEY_CURRENCY: 'Exchange(Tc-Wallet)',
                WITHDRAWAL_POINT: 'Withdrawal point',
                SEND_E_MONEY: 'Send E-Money',
                SEND_TC_WALLET: 'Send from Tc-Wallet',
                SEND_MONEY_CURRENCY: 'Send by local payment',
                VOUCHER: 'Buy Voucher',
                WITHDRAWAL_E_MONEY: 'Withdrawal by E-Money',
                WITHDRAWAL_MONEY_CURRENCY: 'Withdrawal by local payment',
            },
            VERIFY: {
                VERIFY: 'Verify',
                REQUIRED: "Required",
                OPTIONAL: "Optional",
                TYPE: {
                    ADDRESS: 'Address information',
                    PERSONAL: 'Personal information',
                    PERSONAL_IDENTITY: 'Personal information',
                    PERSONAL_PASSPORT: 'Personal information',
                    DRIVER_LICENSE: 'Personal information',
                    PHOTO_UPLOAD: 'Photo information',
                    PHOTO_CAMERA: 'Photo information',
                    PHOTO: 'Photo'
                },
                NOTIFY: {

                    TITLE: {
                        VERIFY_INFO: 'Information verification'
                    },
                    NOTIFICATION: {
                        BODY: {
                            ACCEPTED: 'Your {{0}} has been verified.',
                            REJECTED: 'Your {{0}} has been rejected.'
                        }
                    },
                    KYC: {
                        NOTIFICATION: {
                            TITLE: {
                                ACCEPTED: 'KYC Authentication',
                                REJECTED: 'KYC Authentication'
                            },
                            BODY: {
                                REJECTED: 'Your identity has been rejected in the system.',
                                ACCEPTED: 'Your identity has been verified successfully in the system.'
                            }
                        }
                    }
                },
                KYC: {
                    INFORMATION: 'Information',
                    ENTER_TO_KYC: 'Enter to KYC',
                    IRANIAN_USERS_CONFIRM_ALERT: 'If your document\'s issuing country is Iran, please enter your name and family in Persian.',
                    DESCRIPTION: 'Dear user, in order to increase security and prevent any profiteering violations, please do your verification',
                    ALERT_ERROR: 'Unfortunately your authentication is failed, please contact support team',
                    ALERT_DONE: 'Your authentication has been completed successfully.',
                    ALERT_WAITING: 'Completing the authentication process ...'
                },
                LETTER_OF_COMMITMENT: {
                    ALERT_DONE: 'You have successfully submitted your commitment letter.',
                    ALERT_MISS_MATCH_DATA: 'Unfortunately your authentication is failed, please contact support team',
                    TEXT: 'I, <strong>{{name}}</strong>, with the national number <strong>{{code}}</strong>, sent my documents to Top Change for verification, and I confirm that the registration was completed by me. I also agree not to accept cash or digital currency in any form in return for having anyone to use my account. I confirm that I have not given anybody else my bank account details, and that if I receive an illegal deposit, I will be held legally liable, including legal penalties and compensation for the plaintiff.',
                    CONFIRM_CHECKBOX: 'I confirm the above information',
                    MISS_MATCH_DATA: 'Miss Match Data'
                }
            },
            ALERT: {
                ADDRESS_HAS_BEEN_UPDATED: "Your address information was successfully updated.",
                ADDRESS_IS_OPTIONAL: "Please first fill in the address information form to activate the personal information confirmation section for you",
                ADDRESS_UPLOAD_HINT: "Note: To confirm the address, upload a clear scan of one of the valid documents such as this year's bill (landline, water, electricity, gas), title deed or vehicles, lease and insurance policy. To confirm the information, the address entered in the system and the information on the submitted bill must be the same",
                ADDRESS_VERIFYED: "Your address has been successfully verified",
                ADDRESS_VERIFY_IS_PENDING: "Your address information is being reviewed by our experts.",
                DOCUMENTS_UPLOADED: "Documents uploaded successfully",
                ERROR_ADDRESS_INFO_NOT_VERIFIED: "Your address information has not been verified",
                ERROR_ADDRESS_INFO_REJECTED: "Your address verification request was rejected.",
                ERROR_PERSONAL_INFO_NOT_VERIFIED: "Your personal information has not been verified",
                ERROR_PERSONAL_INFO_REJECTED: "Your personal information verification request has been rejected",
                ERROR_PHOTO_VERIFY_REJECTED: "Your authentication request has been rejected",
                MOBILE_NUMBER_HAS_BEEN_VERIFIED: "Your mobile number has been successfully verified",
                MOBILE_NUMBER_HAS_BEEN_SUCCESSFULLY_REGISTRED: 'Your mobile number has been successfully registered.',
                NEED_FILL_ADDRESS_FORM: "Confirmation of address is not mandatory, But if you want to benefit from all the features of the site, you should confirm your address",
                NEED_FILL_PERSONAL_FORM: "Please first fill in the personal information form to activate the user information verification section for you",
                PASSWORD_CHANGED_SUCCESSFULLY: "Password changed successfully! Please log in again",
                PASSWORD_MAX_LENGTH: "Password must be… characters at the most.",
                PASSWORD_MIN_LENGTH: "Password must be at least… characters.",
                PEERSONAL_INFO_HAS_BEEN_UPDATED: "Your personal information has been successfully updated.",
                PERSONAL_INFO_SHOULD_MATCH_WITH_ID_CARD: "Note: The personal information entered must match your identity card or passport.",
                PERSONAL_INFO_VERIFYED: "Your information has been successfully verified",
                PERSONAL_INFO_VERIFY_IS_PENDING: "Your information is being reviewed by our experts.",
                PHOTO_VERIFY_ACCEPTED: "Your identity has been successfully verified.",
                PHOTO_VERIFY_IS_PENDING: "Your information is being reviewed by our experts.",
                VERIFY_NEEDS: "Your personal information has not been verified.",
                CAMERA_PERMISSION_ERROR: 'To use this option, allow your browser to acess your camera.',
                NOT_FOUND_CAMERA: 'Your device does not have camera.'
            }

        },
        NOTIFICATION: {
            ADMIN: "Support",
            DESCRIPTION: "Description",
            EMPTY: "Notification is empty",
            EMPTY_FRIENDS: "No new request",
            EMPTY_TICKETS: "Nothing to show",
            FRIENDS: "Friends",
            ME: "Me",
            NEW: "New",
            NOTIFICATIONS: "Notifications",
            SELL_SUCCESSFUL: 'Successful Sale',
            BUY_SUCCESSFUL: 'Successful Buy',
            MY_ORDERS: 'My Orders',
            REGISTER_NEW_AD: 'Register a new ad',
            SELL: 'Sell',
            TICKETS: "Tickets",
            TITLE: "Notification",
            TYPE: "Notification Type",
            ALERTS: 'Alerts',
            YOU_HAVE_NO_NEW_MESSAGES: 'You have no new messages.',
            SHOW_ALL: 'Show all',
            READ_ALL: 'Read all',
            ANNOUNCEMENT: 'Updates',
        },
        P2P: {
            DEPOSIT_PAGE: {
                EARN_MORE_P2P: 'Earn more with P2P and win prizes',
                SALE: 'Sale'
            },
            USER: {
                NOTIFICATION: {
                    BODY: {
                        ADVERTISEMENT: {
                            INPROGRESS: "You have a buyer for the sales ad <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span>.",
                            CREATED: "Your sales ad <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> (P2P) has been successfully registered.",
                            DONE: "Your sales ad <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> (P2P) has been successfully completed.",
                            CANCEL: "Your sales ad <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> (P2P) has been successfully canceled.",
                            CLOSED: "Your purchase ad <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> (P2P) has been closed.",
                            RETURN: {
                                REMAIN: {
                                    AMOUNT: {
                                        DONE: "Your sales ad <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{2}}</span></span> (P2P) has fallen below the 'minimum purchase' and <span class=\"fa-number-dir\">&rlm;{{1}}<span>{{2}}</span></span> has been transferred to wallet {{3}}."
                                    }
                                }
                            },
                            ORDER: {
                                TAKECOLLATERAL: "The amount <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> of your collateral has been taken by support."
                            }
                        },
                        SELLER: {
                            DONE: "Your sales order <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> (P2P) has been successfully completed."
                        },
                        BUYER: {
                            DONE: "Your purchase order <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> (P2P) has been successfully completed."
                        },
                        ORDER: {
                            CONFIRM: "Dear user, please check the payment validity and release the sales ad <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> (P2P) as soon as possible.",
                            TAKECOLLATERAL: "The amount <span class=\"fa-number-dir\">&rlm;{{2}}<span>{{3}}</span></span> of your collateral has been taken by support."
                        }
                    },
                    TITLE: {
                        ADVERTISEMENT: {
                            INPROGRESS: "P2P Purchase Request",
                            CREATED: "P2P Sales Ad",
                            DONE: "P2P Sales Ad",
                            CANCEL: "P2P Ad Cancellation",
                            CLOSED: "P2P Ad Closure",
                            RETURN: {
                                REMAIN: {
                                    AMOUNT: {
                                        DONE: "P2P Remaining Amount Return"
                                    }
                                }
                            },
                            ORDER: {
                                TAKECOLLATERAL: "P2P Collateral"
                            }
                        },
                        ORDER: {
                            CONFIRM: "P2P Payment Confirmation",
                            TAKECOLLATERAL: "P2P Collateral"
                        },
                        SELLER: {
                            DONE: "P2P Sales Order"
                        },
                        BUYER: {
                            DONE: "P2P Purchase Order"
                        }
                    }
                }
            },
            ADMIN: {
                NOTIFICATION: {
                    TITLE: {
                        ADVERTISEMENT: {
                            CANCEL: 'P2P Ad Cancellation'
                        }
                    },
                    BODY: {
                        ADVERTISEMENT: {
                            CANCEL: 'Your advertisement with transaction ID {{1}} has been canceled by support.'
                        }
                    }
                }
            },
            FILTER: 'Filter',
            TYPE: 'Type',
            STATUS: 'Status',
            WALLET: 'Wallet',
            SELECT_WALLET: 'Select Wallet',
            FROM_DATE: 'From Date',
            TO_DATE: 'To Date',
            CLEAR_ALL: 'Clear All',
            SEARCH: 'Search',
            TRACKING_NUMBER: 'Tracking Number',
            OPERATION: 'Operation',
            VALUE: 'Value',
            PAYMENT_METHOD: 'Payment Method',
            REQUEST_DATE: 'Request Date',
            BUYERS: 'Buyers',
            BUYER: 'Buyer',
            TABLE_EMPTY_MESSAGE: 'No results found!',
            BUY: 'buy',
            SELL: 'sell',
            DONE: 'done',
            IN_PROGRESS: 'in progress',
            SUPPORT: 'support',
            CLOSED: 'closed',
            TRANSFER_RATE: 'Transfer Rate',
            PRICE: 'Price',
            BACK: 'Back',
            RELEASE: 'Release',
            CARD_NUMBER: 'Card Number',
            DEPOSIT: 'Deposit',
            DOCUMENT: 'Document',
            RECEIVE_CONFIRMATION_TITLE: 'Are you sure of the authenticity of the buyer\'s payment?',
            CONFIRM_CONTINUE: 'Confirm and continue',
            CONFIRM: 'Confirm',
            CANCEL: 'Cancel',
            GET_CODE: 'Send Code',
            CHECK_AGAIN: 'Check Again',
            TWO_STEP_VERIFICATION: 'Account two-step verification',
            CALL_SUPPORT: 'Contact support',
            ENTER_CONVERSATION: 'Ask for support',
            MY_ADS: 'My Ads',
            CREATE_NEW_AD: 'Create New Ad ',
            SOLD_PERCENTAGE: 'Percentage sold',
            SELLABLE_AMOUNT: 'Available amount',
            SOLD_AMOUNT: 'Amount sold',
            EXCHANGE_REATE: ' Conversion rate',
            AD_CREATE_DATE: 'Ad registration date',
            SHOW_ORDER: 'View order',
            PERCENTAGE: 'Percentage',
            VALIDATION: {
                CANT_BE_MORE_THAN_REQUEST_AMOUNT: "The amount must not be more than the Salable amount",
                CANT_BE_SET_ZERO: "The amount cannot be zero",
                CANT_BE_LESS_VALUE: 'The amount cannot be less than {{value}}',
                SELECT_WALLET_FIRST: 'Please select your desired wallet',
                AMOUNT_CANT_BE_MORE_THAN_BALANCE: 'Amount cannot be more than wallet balance',
                AMOUNT_CANT_BE_MORE_THAN_ADV_AMOUNT: 'The requested amount cannot be more than the total amount of the advertisement',
                AMOUNT_CANT_BE_LESS_THAN_TEN: 'The requested amount cannot be less than 10 {{value}} .',
                AMOUNT_CANT_BE_LESS_THAN: 'The requested amount cannot be less than {{value}} {{currency}} .',
                AMOUNT_CANT_BE_SET_ZERO: 'The requested amount cannot be zero',
                AMOUNT_CANT_BE_MORE_MAX_PAY: 'The requested amount cannot be more than {{amount}} {{currency}}'
            },
            DESCRIPTION: {
                RELEASE_PROPERTY: 'Please release your sold property within the specified time. Otherwise, the buyer will refer to the support and after checking the platform experts will transfer the sold currency to the buyer\'s wallet.',
                PAYMENT_LIMIT: 'Due to the limit of payment through card to card, it is possible that the buyer has used several bank cards, so be careful in checking the deposit information.',
                INFORMATION_DISCREPANCY: 'In case of any discrepancies in the seller\'s payment information, do not release your currency and click the \"Incorrect information\" button. We will not be responsible for refunding your payment in case of wrong release.',
                IMPORTANT_INFORMATION: 'Do not give your sensitive bank information to users so that people do not misuse it.',
                TRANSFORM_THROUGH_CHANNEL: 'You should never use any form of money transfer that advertises through third party channels such as social networks or messengers or face-to-face advertisements. The platform cannot be held responsible for any damages that occur outside of the platform. Also, the platform has no P2P anywhere.',
                PAYMENT_SPECIFIED_TIME: 'Please make your payment in the specified time and make sure to click the "Paid, Next" button. After the seller confirms the payment, the system transfers the digital asset to your account.',
                POSSIBLE_MULTIPLE_CARD: 'Due to the card-to-card payment limit, it is possible to use several bank cards.',
                DEPOSIT_FROM_ACCOUNT: 'Note that you must deposit money from the bank account of your choice. In case of any discrepancy in the payment information, the seller will not release his currency and will not be responsible for returning your payment.',
                DEPOSIT_AMOUNT_CORRECTLY: 'Be careful when depositing money, deposit the amount correctly. If the deposit amount is low, the platform will deposit currency equivalent to your deposit amount into your wallet. Also, if you deposit more than the specified amount, try to talk to the seller and solve your problem. The platform will not be responsible in this regard.',
                AFTER_EACH_PAYMENT: 'Note that after each payment, enter your card number, tracking number (referral) and payment amount, and also upload a photo of your payment receipt in the embedded place.',
                PAYMENT_RECEIPT: 'Please keep your payment receipt at the end of the transaction',

                PAY_ATTENTION: "Pay attention to the remaining time for payment.",
                PAY_WITH_BANK: "To pay with a bank card, you can send the amount using one or multiple cards.",
                NOTE_BANK_CARDS: "Note that all bank cards used must be in your name. Otherwise, the seller may refuse the payment, the transaction could be canceled, and the platform will not be responsible.",
                ENSURE_AMOUNT_SEND: "Ensure that the amount you send is neither more nor less than the required amount. If it is, the platform will need to contact the seller, and resolving the issue may take a long time.",
                AFTER_PAYMENT: "After each payment, enter your card number, the reference number, and the amount paid, and also upload a picture of the payment receipt in the designated area.",
                PAYMENT_RECEIPTS: "Please keep your payment receipts until the transaction is complete.",
                CONDUCT_TRANSACTION: "Under no circumstances should you conduct a transaction involving the transfer of money through a third-party channel such as social networks, messaging apps, or face-to-face deals. The platform cannot be held responsible for any losses or damages resulting from transactions made outside the platform.",
                ADDITIONALLY: "Additionally, the platform does not interfere in P2P transactions and merely provides the infrastructure for your transactions."
            },
            CUSTOMER_PAYMENT_INFORMATION: 'Customer Payment Information',
            PAYMENT_INFORMATION: 'Payment Information',
            TOO_MUCH_DEPOSITED: '',
            EXCESS_AMOUNT: 'Excess amount',
            REMAINING_RELEASE_TIME: 'Remaining Release Time',
            CHAT_WITH_SUPPORT: 'Chat with support',
            ENTER_YOUR_MESSAGE: 'Enter your message',
            CONFIRMATION: {
                CONFIRMING: 'Please note that confirming the above message means receiving the money in full and confirming the correctness of the buyer\'s payment information.',
                DISCREPANCIES: 'Please contact support if you see any discrepancies.',
                AFTER_CONFIRMING: 'After confirming this message, your money will be released and the platform will not be responsible for it.'
            },
            EMAIL_CODE: 'Email Code',
            SENT_EMAIL_TEXT: "Enter the 6-digit code sent to {{value}}.",
            ADVERTISE: {
                SEARCH: "Search",
                CURRENCY_TYPE: "Currency",
                CURRENCY_AMOUNT: "Desired Amount",
                DESIRED_AMOUNT: 'Desired Amount',
                ACTIVE_ADVERTISES: "Active ads",
                SELLER: "Seller",
                TRANSACTION: "Transaction",
                COMPLETE: "Complete",
                EXCHANGE_RATE: "Exchange rate",
                SELL_AMOUNT: "Selling price",
                SELL: "Sale",
                MIN: "At least",
                PAYMENT_METHOD: "Payment Method",
                BUY_CURRENCY: "Buy Currency",
                BUY: "Buy",
                ADVERTISE: "Advertisements",
                VIDEOHELP: "Video guide",
                CREATE_ADVERTISE: "Make an ad",
                MY_ORDERS: "My orders",
                ENTER_AMOUNT: "Enter the currency amount",
                PAID_VALUE: "Your payment amount",
                SELECT_WALLET: "Choose a wallet",
                USER: "User",
                ORDER: "Order",
                COMPLETED: "Completed",
                AVAILABLE: "Available",
                TIME_LIMIT: "Deposit time limit",
                MINUTE: "Minutes",
                CANCEL: "Cancel",
                DOLLAR: 'TCD',
                RIAL: 'Rial',
                DERHAM: 'Derham',
                EURO: 'Euro',
                DERHAM_WALLET: 'Derham Wallet',
                EURO_WALLET: 'Euro Wallet',
                DOLLAR_WALLET: 'TCD Wallet ',
                EMPTY_DATA: 'Not found',
                ORDER_BY: 'Sort by',
                NewestListing: 'Newest Ads',
                LowestPrice: 'Lowest exchange rate ',
                HighestAmount: 'Highest Quantity',
                DEALS: 'Deals',
                SUCCESSFUL: 'Successful',
                AMOUNT: 'Amount',
            },
            BUYER_INFORMATION: "Buyer information",
            ENTERED_VALUE_EXCEEDS_LIMITS: "The entered value exceeds the allowable limit",
            MINIMUM_ALLOWED_AMOUNT: "The minimum allowable amount is {{number}} {{currency}}",
            VIEW_MY_ORDERS: "View my orders",
            MY_AD_INFO: "My ad info",
            DETAILS: "Details",
            REQUESTED_FOR_SALE: "Amount requested for sale",
            SALABLE_AMOUNT: "Salable amount",
            COLLATERAL_AMOUNT: "collateral amount ({{value}}%)",
            COMMISSION: "commission ({{value}}%)",
            EQUIVALENT_RIAL: "Equivalent Rial",
            MINIMUM_PURCHASE: "Minimum purchase per order",
            CARD_TO_CARD: "Card to Card",
            SATNA: "Satna",
            PAYA: "Paya",
            BUYER_DIPOSIT_LIMIT: "Buyer deposit time limit",
            ADVERTISING_PERIOD: "Advertising period",
            VIEW_PAYMENTS: "View payments",
            ORDER_COMPLETED: "Your order has been completed",
            SHARE_YOUR_EXPERIENCE: "Please share your experience with us.",
            PAYMENTS: "Payments",
            PURCHASE_INFO: "My sales information",
            PAYMENT_INFO: "My payment information",
            NEXT: "Next",
            STEPPER: {
                PURCHASE_AMOUNT: "Purchase Amount Determination",
                SALES_DETERMINATION: "Sales Determination",
                COMMITMENT_LATER: "Commitment letter",
                CONFIRM_INFORMATION: 'Confirm information',
                ADVERTISEMENT_REGISTRATION: 'Advertisement registration',
                CURRENCY_RECEIPT: 'Currency receipt',
                PAYMENT: "Payment",
            },
            ENTER_CURRENCY_AMOUNT: "Enter the currency amount",
            CURRENCY_AMOUNT: "Currency Amount",
            DOLLAR: "TCD",
            PAYMENT_AMOUNT: "Your payment amount",
            RIAL: "Rial",
            CHOOSE_WALLET: "Choose a wallet",
            CHOOSE_BANK_ACCOUNT: "Choose Bank Account",
            USER_DOT: "User:",
            DIPOSIT_DOT: "Diposit:",
            TRANSFER_RATE_DOT: "Transfer rate:",
            PAYMENT_METHOD_DOT: "Payment method:",
            DIPOSIT_TIME_LIMIT_DOT: "Deposit time limit:",
            BUY_CURRENCY: "Buy Currency",
            COMMITMENT_LATER_DESCRIPTION: {
                RESPONSIBLE_FOR_AD: "Be truthful and fair, treat others with utmost respect, and take responsibility for your ads.",
                SALLER_PRICE_BUYER: "The price of the orders established between the seller and the buyer is final and non-negotiable",
                SPECIFIED_TIME: "Please complete your release within the specified time. If this time expires, you should be accountable to the buyer and the support team. In case of non-response, the platform is allowed to release the advertisement amount",
                CONTROLLED_ASSETS_PLATFORM: "Your payment goes directly to the seller's account and only the digital asset that the seller wants to sell during the transaction is controlled by the platform.",
                DIPOSIT_FROM_ACCOUNT: "Note that the received amount must be deposited from the same account mentioned in the payment form. In case of discrepancy, do not perform the release in any way and contact the support. If the platform is released It has no responsibility for the released amount",
                DIPOSIT_FROM_ACCOUNT2: 'Please note that the received amount must be deposited from the same account specified in the payment form. In case of any discrepancy, do not proceed with the release under any circumstances and inform support. If the release is carried out, the platform bears no responsibility for the released amount.',
                OVERPAY_CARE: "In case of discrepancy between the received amount and the payment form, do not perform the release under any circumstances and refer to the support",
                PRESS_WITHOUT_PAYING: "If you fill in the payment form with false information without paying and click on the payment button, your access to this service will be closed forever and the platform will claim reserves any damage caused by it",
                DOES_NOT_PAY_LIMITATION: "If you do not release the money after receiving the amount in your bank account, the platform can perform the release and block your access to the PaytoPay service forever.",
                DIGITAL_ASSETS_MENTION: "Please do not mention information about your digital assets during bank transfers. Otherwise, your payment may be intercepted or the bank may block your payment.",
                AVAILABLE_UNFULFILLED: "If you have unfulfilled orders or disputes with the buyer, please ensure that you are always available via the mobile phone number or email you have registered on the platform.",
                THIRD_CHANNELS: "You should never make a transaction with any form of money transfer through a third channel such as social networks or messengers or face-to-face transactions. The platform cannot be held responsible for damages or losses that occurred outside the platform. Also, the platform is not involved in any part of the P2P transfer.",
                COMMITMENT_LATER: "Users should refrain from using profanity and insulting words while using the platform. If you observe this behavior, you will be dealt with.",
                SHARE_ACCOUNT_WARNING: "Do not use another person's account under any circumstances. Also, do not share your account information with others. If such behavior is seen, your account will be blocked and FATA police will be informed if necessary.",
                AGENDA_VIOLATION: "In the event of any violation of the declared \"Seller Guidelines\", the Platform may, in accordance with the relevant laws and regulations, or at its discretion, take such actions as it deems appropriate, including confiscation, blocking the offending account or disabling any account functionality. to adopt in the trading platform.",

                THIRD_PARTY_PAYMENT_WARNING: "Only use a bank account and payment method that is registered in your name and matches your verified identity information; third-party payments are not permitted.",
                ASSET_LOCK_WARNING: "Once a transaction begins, the seller's assets will be locked in escrow and cannot be accessed until the order is completed or cancelled.",
                PAYMENT_DEADLINE_WARNING: "The buyer is required to transfer the full order amount within the specified timeframe and according to the declared payment information.",
                FINAL_TRANSACTION_WARNING: "P2P transactions are final; carefully review the amount, price, and payment details before placing an order.",

                BUYER_PAYMENT_DEADLINE: "The buyer must pay the full order amount within the specified time limit and according to the provided payment details.",
                RELEASE_DEADLINE_WARNING: "Please release the funds within the specified time limit. If this period expires, you will be required to respond to the buyer and the support team. If you fail to respond, the platform is authorized to release the advertised amount.",
                FAKE_PAYMENT_CONFIRMATION_WARNING: "If you click the “Payment Completed” button without making the payment and submit false information in the payment form, your access to this service will be permanently blocked. The platform reserves the right to claim compensation for any resulting damages.",
                OFF_PLATFORM_TRANSACTION_WARNING: "You must never transfer funds or conduct transactions through third-party channels, such as social media, messaging apps, or in-person arrangements. The platform cannot be held responsible for any loss or damage resulting from transactions conducted outside the platform. Furthermore, the platform is not involved in any part of the P2P fund transfer process.",
            },
            COMMITMENT_ACCEPTION_PT_ONE: "I, {{value}}, have read the above",
            RULES: " commitment letter ",
            COMMITMENT_ACCEPTION_PT_TWO: ", rules, and regulations, and I agree to them.",
            COMMITMENT_ACCEPTION: "I, {{value}}, have read the above <span class=\"username\">commitment letter</span>, rules, and regulations, and I agree to them.",
            TERMS_COMMITMENT_AGREEMENT: "I, {{value}}, have read and agree to the <a>Terms of Service</a>.",
            DATE_DOT: "Date:",
            TIME_DOT: "Time:",
            PAYMENT_TO_DOT: "Payment To:",
            RECEIVER_PARAMETER_DOT: "Receiver: <span>{{value}} (seller)</span>",
            PRICE_DOT: 'Price:',
            CARD_NUMBER_DOT: 'Card Number:',
            ACCOUNT_NUMBER_DOT: "Account Number:",
            IBAN_NUMBER_DOT: "IBAN Number:",
            BANK_TITLE_DOT: "Bank Name:",
            ENTER_PAYMENT_INFORMATION: 'Enter your payment information',
            REMAINING_TIME_DOT: 'Remaining time:',
            ENTER_DEPOSIT_AMOUNT: 'Enter the deposit amount',
            DEPOSIT_AMOUNT: 'Deposit amount',
            ENTER_TRACKING_NUMBER: 'Enter the tracking number',
            RECEIPT_IMAGE: 'Receipt image (required)',
            UPLOAD_LIMIT_HINT: 'Less than {{value}} MB',
            UPLOAD_LIMIT_ERROR: 'Maximum file size: {{value}} MB',
            UPLOAD_LIMIT_TYPE: 'Maximum file size: {{value}} MB',
            SUBMIT: 'Submit',
            DONE_NEXT: 'Done, next',
            EXPECTATION: 'Expectation!',
            PAYMENT_NOTIFIED: 'Dear user, your payment has been notified to the seller.',
            AFTER_SELLER_CONFIRMED: 'After your payment is confirmed by the seller, the money will be transferred to your wallet.',
            WATING_SELLER_CONFIRMATION: "Dear user, your payment has been notified to the seller. To chat with the seller, you can enter this order's chat via the chat icon at the top of the page or go to My Orders list. After payment confirmation, the money will be transferred to your wallet.",
            NEED_TO_CONTACT_THE_SELLER: 'Need to contact the seller?',
            ENTER_THE_ORDER_CHAT: 'Enter the order chat',
            REMAINING_AMOUNT: 'Remaining amount',
            MY_SALES_INFORMATION: 'My purchase information',
            DESIRED_CURRENCY_AMOUNT: "Amount of desired currency",
            VALUE_NOT_ALLOWED: "The entered value is not allowed",
            MINIMUM_PURCHASE_PER_ORDER: "Minimum purchase per order",
            AD_DURATION: "Ad duration",
            DAY: "Day",
            COMPUTING: "Computing",
            TOTAL_REQUESTED_AMOUNT: "Total requested amount",
            MINIMUM_ORDER_LIMIT: "Minimum order limit",
            EXCHANGE_RATES_TYPES: "Types of exchange rates",
            FLOATING_CONVERSION_RATE: "Floating conversion rate",
            FINAL_RATE_CONVERTION: "Final Rate = Market Floating Conversion Rate",
            USER_DETERMINES_SALES_RATE: "User Determines the Sales Rate (Conversion)",
            FIXED_CONVERTION_RATE: "Fixed conversion rate",
            ATTENTION: "Attention",
            GUARANTEE_AMOUNT_COMPLY: "The deposit amount is considered as the user's guarantee to comply with the principles and rules of the P2P platform. This amount will be returned to your wallet after the ad is closed.",
            HIDDEN_AD_CASE: "Your ad will be hidden from public view in the following cases:",
            AD_TIME_OVER: "If the specified time for displaying the ad expires, you can delete your current ad and create a new one.",
            AD_REMAIN_AMOUNT: "If the remaining amount from your ad falls below the 'Minimum Purchase per Order', you can delete your ad. The remaining amount will be returned to your wallet.",
            ORDERS_FOR_SALE: "Your sell ad will be automatically hidden when there are 4 orders for it.",
            SUPPORT_AGAINST_ORDERS: "As soon as you receive 3 support requests against your orders, all your ads will be temporarily hidden.",
            RULES_VIOLATION_BAN: "According to the violation of the specified rules, the relevant expert can temporarily or permanently ban you from using the P2P service.",
            NEW_BANK_REGISTERATION: "Dear user, if you need to register new bank account information, you can",
            CLICK_HERE: "<span>click here</span>",
            GOT_IT: "Got it",
            RETURN_TO_WALLET_CONFIRMATION: "Return remaining amount to wallet",
            REMAINING_AMOUNT_TRANSFER_NOTICE: "The remaining amount of your advertisement is less than your 'minimum purchase limit'. Therefore, this remaining amount will be transferred to your wallet. Please note that your advertisement is no longer visible. You can create a new advertisement.",
            TRANSFER_NOTICE_CREATE: 'The remaining amount of your advertisement will be transferred to your wallet. Please note that your advertisement is no longer visible. You can create a new advertisement.',
            CANCEL_ADVERTISEMENT: "Cancel Advertisement",
            DELETE_ADVERTISEMENT_WARNING: "It's not possible to delete the advertisement. First, attend to your 'In Progress' orders and complete them.",
            NO_BUYER_FOUND: "No buyer found",
            ADVERTISEMENT_CLOSED_NOTIFICATION: "Dear user, since no buyer was found within the specified time period for your advertisement, your advertisement has been closed.",
            CANCEL_SALE_CONFIRMATION: "Are you sure you want to cancel your sale advertisement?",
            YES_SALE_CONFIRMATION: "Yes",
            NO_SALE_CONFIRMATION: "No",
            MINUTES: "minutes",
            EDIT_INFORMATION: "editing information",
            MY_ORDERS: "My orders",
            ALL_ITEMS: "َAll",
            RETURN_TO_MAIN: "Return to main page",
            AD_SUCCESSFULLY_REGISTERED: "Your ad has been successfully registered",
            AD_RESPONSIBILITY: "Please be responsible for your ad and if you receive a notification, take care of it as soon as possible.",
            PAYMENT_PERIOD: "Payment period",
            CARD_INFO: "Card information",
            DESIRED_AMOUNT: "Enter desired amount",
            CURRENT_RATE: "Current rate",
            WARNING: "Warning",
            I_REALIZED: "I realized",
            AVOID_BECOMING_VICTIM: "To avoid becoming a victim of scammers, never transfer digital currency before actual payment! Do not believe anyone who claims to be customer support and convinces you to complete the transaction before receiving payment because they are scammers. After the order is confirmed by the seller and the property is transferred to the buyer, the transaction is considered completed and cannot be disputed. Also, the platform will not be responsible for transactions outside the platform.",
            CHOOSE_FILE: "Choose file",
            ORDER_STATUS: {
                NEW_BUY: 'Payment',
                NEW: 'Awaiting buyer',
                IN_PROGRESS: 'In Progress',
                SUPPORT: 'Support',
                CANCEL: 'Cancel',
                CLOSED: 'Closed',
                DONE: 'Completed'
            },
            ADVERTISE_TYPES: {
                BUY: 'buy',
                SELL: 'sell'
            },
            TIME_REMAINING_TO_COMPLETE_PAYMENT: "Time Remaining to Complete Payment",
            SUBTITLE_CHECK_TIMER: 'If the Payment is Not Registered within the Specified Time, the Order Will Be Sent to Support.',
            REGISTER_PAYMENT_INFORMATIN: "Register payment information",
            ACTION_TO_RELEASE: "release",
            DELETE_ADVERTISMENT: 'Delete Ad',
            DETAIL_ADVERTISMENT: 'Ad details',
            DELETE_ORDER: 'Delete Order',
            DETAIL_ORDER: 'Order Details',
            BALANCE_WALLET: "Balance: {{balance}} {{currency}}",
            CURENTR_MARKET_RATE: "Current market rate",
            CURENTR_MARKET_RATE_CRYPTO: "Current market rate",
            YOUR_EXCHANGE_RATE: "Your exchange rate",
            ALLOWED_RANGE: "Allowed range: {{min}} - {{max}}",
            ALLOWED_RANGE_PERCENTAGE: "Allowed range: <span class='percent-range'>{{min}}% - {{max}}%</span>",
            ERROR_VALIDATE_ALLOWED_RANGE: "Rate must be between {{min}} and {{max}}.",
            ERROR_VALIDATE_ALLOWED_RANGE_PERCENTAGE: "Percentage must be between <span class='percent-range'>{{min}}% - {{max}}%</span>",

            TEXT_CHANGE_PERCENT_LOWER: 'Your selling rate will always be {{value}}% lower than the Top Change rate.',
            TEXT_CHANGE_PERCENT_HIGHER: 'Your selling rate will always be {{value}}% higher than the Top Change rate.',
            TEXT_CHANGE_PERCENT_STATIC: 'Your selling rate will always be equal to the Top Change rate.',

            TEXT_CHANGE_PERCENT_LOWER_CRYPTO: 'Your selling rate will always be {{value}}% lower than the Market rate.',
            TEXT_CHANGE_PERCENT_HIGHER_CRYPTO: 'Your selling rate will always be {{value}}% higher than the Market rate.',
            TEXT_CHANGE_PERCENT_STATIC_CRYPTO: 'Your selling rate will always be equal to the Market rate.',
            AMOUNT_PAID: "Pay amount",
            EXCHANGE_RATE: 'Exchange Rate',
            ORDER_TRACKING_NUMBER: 'Order Tracking Number',
            AD_TRACKING_NUMBER: 'Ad Tracking Number',
            DESTINATION_BANK: 'Destination bank',
            VIEW_DESTINATION_BANK: 'View Destination Bank',
            VIEW_DESTINATION_BANK_DESCRIPTION: 'Now, you can see the seller’s destination bank before entering a trade, allowing you to make a more informed choice.',
            BANK_NAME: '{{name}} Bank',
            DIALOG_EXCHANGE_RATE: {
                CHANGE: {
                    TITLE: "The entered exchange rate differs significantly from the actual rate",
                    NEW_EXCHANGERATE: "Your exchange rate:",
                    TC_EXCHANGERATE: "Current purchase rate from TopChange:",
                    DESCRIPTON: "The exchange rate you have selected differs significantly from the actual exchange rate in TC. Please review it before confirming. Are you sure about this amount?",
                    EDIT_EXCHANGE_RATE: "Edit exchange rate",
                    CONTINUE: "Continue",
                }
            },
            PRICE_TOLERANCE_VALIDATION_FAILED: "The entered price differs significantly from the market price. Please adjust it and try again.",
            DIALOG_TERMS_COMMITMENT_AGREEMENT: {
                ALERT_TXT: 'Please read the rules carefully before posting an ad!'
            },

            ACTIVE_ORDERS_AD_VISIBILITY_WARNING: "When there are 4 active orders for your sell ad, the ad will automatically be hidden.",
            SUPPORT_REQUESTS_AD_VISIBILITY_WARNING: "As soon as 3 support requests are submitted against your orders, all your ads will be temporarily hidden.",
            FINAL_P2P_TRANSACTION_WARNING: "P2P transactions are final. Before placing an order, carefully review the amount, price, and payment details.",
            P2P_COLLATERAL_NOTICE: "The collateral amount serves as a guarantee that the user will comply with the platform’s P2P rules and regulations. This amount will be returned to your wallet after the ad is closed.",
            P2P_SERVICE_RESTRICTION_WARNING: "If you violate the specified rules, the relevant specialist may temporarily or permanently restrict your access to the P2P service.",

            P2P_SEND_METHOD_PRICE_NOTICE: 'Dear user, for amounts up to 15 million tomans, please transfer the funds via card-to-card transfer. For amounts over 15 million and up to 200 million tomans, please use an account-to-account transfer. Please note that for this method, the source and destination banks must be the same. Do not transfer funds using an IBAN.',
            CONFIRM_PAYMENT_NOTICE: 'Your payment details have been saved. To confirm your payment and proceed with your request, please click the «{{btnTex}}» button.',
            CONFIRM_PAYMENT: 'Confirm payment',
            UNCONFIRMED_PAYMENT_EXIT_NOTICE: 'Your payment has not been confirmed yet. Are you sure you want to leave this page?',
            RELEASE_ELIGIBILITY_CHECKING: 'Checking whether you can release the assets…',
            RELEASE_ELIGIBILITY_CHECK_FAILED: 'Could not check whether you can release the assets. Reload the page.',
            RELEASE_AVAILABLE_AFTER_DEADLINE: 'The initial deadline has passed. You can still release the assets after confirming receipt of the payment.',
            RELEASE_UNAVAILABLE_AFTER_DEADLINE: 'The initial deadline has passed. You can’t release the assets while the order is in its current status.',
        },
        AFFILIATE: {
            AFFILIATE_REQUEST: {
                ENTER_CODE_DESCRIPTION: "You can also be invited by someone else while being our affiliate and receive points based on the inviter's conditions.",
                ENTER_CODE: "Enter Referral Code",
                AFFILIATE_CONDITIONS: "Terms and conditions",
                SOCIAL_MANAGEMENT_BLOCKCHAIN: "Having social groups in the field of financial markets and currency transfers that you manage.",
                ONLINE_FINANCIAL_PLATFORMS: "Effective presence on social networks related to capital markets such as YouTube, Twitter, Instagram, and Telegram.",
                COMMUNITY_EVENTS_ATTRACTION: "Access to fan clubs, financial programs, and conferences, and the ability to create advertising space to attract new users to the TopChange platform.",
                CONTENT_COLLABORATION_IMPACT: "Experience and ability to generate content related to joint activities with TopChange and influence various user groups.",
                SEND_REQUEST: "If you want to become a member of TopChange's partnership program, click here:",
                SEE_FORM: "Affiliate Application Form"
            },
            AFFILIATE_SEND_REQUEST: {
                SEND_AFFLIATE_REQUEST: "Submit Collaboration Request",
                WEBSITE_ADDRESS: "Website address",
                SOCIAL_MEDIA: "Website or any other social media that you are a member of, such as Telegram, Twitter, etc.",
                COOPEREATED_COMPANY: "Previous affiliate program or company you worked with",
                DESCRIPTION: "Explain your strategy for collaboration (content generation, social media campaigns, email marketing, or any other advertising techniques).",
                ENTER_DESCRIPTION: "Write your message...",
                TRANSACTION_VOLUME: "Transction Volume",
                ESTIMATED_MONTHLY_TRADING_VOLUME: "Please write your estimated monthly trading volume in TCD.",
                SEND: "Submit",
                SUBMIT_SUCCESS_MESSAGE: "Your request has been registered successfully. Please wait for a call from TC"
            },
            INVITEE_ENTER_CODE: {
                INVITATION_CODE: "Referral Code",
                ENTER_INVITATION_CODE: "First, apply the invitation code of your representative.",
                YOUR_INVITATION_CODE: "Referral Code",
                ENTER_INVITAION_CODE_HINT: "Enter your referral code",
                ACTIONS: 'Submit',
                CAN_INVITED: " While being an affiliate, you can be invited by someone else and receive points according to the conditions of the inviter. ",
            },
            INVITEE_INDEX: {
                YOUR_INVITATION_CODE: "Your identification code",
                REQUEST_EMAIL: "If you want to change your inviter, apply to the email below.",
                DEFAULT_BONUS: "A definition bonus from the affiliate side for you",
                FROM_AFFILIATE_SHARE: "of the affiliate share",
                MY_PERFORMANCE: "My performance",
                VIEW_HISTORY: "View history",
                MY_AFFILIATE: "My affiliate",
                UNPAID_BONUS: "Unpaid bonus",
                PAID_BONUSES: "Total rewards received",
                SCORE: "Score",
            },
            INVITEE_HISTORY: {
                FILTERS: "Filters",
                TRACKING_NUMBER: "Tracking Number",
                IDENTIFICATION_CODE: "Identification Code",
                PROGRAM: " Program",
                FROM_DATE: "From Date",
                TO_DATE: "To Date",
                TYPE: "Type",
                MY_REWARD: "My reward",
                SCORE: "Score",
                AFFILIATE: "Affiliate",
                STATUS: "Status",
                ACTION_DATE: "Action Date",
                ACTION: "Action",
            },
            FILTER: 'Filter',
            FROM_DATE: 'From Date',
            TO_DATE: 'To Date',
            CLEAR_ALL: 'Clear All',
            SEARCH: 'Search',
            YOUR_AFFILIATE_PROGRAM: 'our monetization program',
            BONUS_FROM_BROKER: 'Bonus from the broker',
            BONUS_FROM_SPECIAL_WALLETS: '{{bonus}}% Bonus from {{specialWallets}} wallet(s)',
            FROM_ALL_BROKERS: 'Bonus from all brokers',
            SHARE_YOUR_REFERRAL: 'Share your referral link with your followers or channels.',
            ENCOURAGE_FRIENDS_TRANSACTIONS: 'Encourage friends to make transactions',
            RECEIVE_REWARDS: 'Receive rewards',
            YOUR_REFERRAL_CODE: 'Your invitation code',
            MANAGEMENT_OF_CODES: 'Management of codes',
            SHARE: 'share',
            EXPLANATION_STEPS: 'Explanation of steps',
            MORE_GUIDANCE: 'More guidance',
            CREATE_YOUR_OWN_CODE: 'Create your own invitation code and link.',
            SHARE_YOUR_CODE: 'Share the link or code you have with others.',
            ENCOURAGE_FRIENDS_COMPLETE_TRANSACTIONS: 'Encourage your friends to participate and complete specified transactions in their own apps.',
            MANAGE_REFERRAL_CODES: 'Manage your invitation codes.',
            CHANGE_BONUSES_PERCENTAGE: 'You can adjust the reward percentages for different codes based on your conditions.',
            REFERRAL_CODE: 'Referral code',
            INVITEE_USERNAME: 'Username of invitee',
            OPERATION: 'the operation',
            BONUS_RECEIVED: 'Bonus received',
            INTRODUCED_PEOPLE_NUMBER: 'The number of people introduced',
            INTRODUCED_PERSON_SHARE: 'Introduced share',
            MY_SHARE: 'my share',
            INVITATION_CODE: 'Invitation Code',
            MY_OVERALL_PERFORMANCE: 'My overall performance',
            VIEW_HISTORY: 'View history',
            THE_REFEREES: 'The referees',
            BONUS_AVAILABLE: 'Bonus available',
            TOTAL_REWARDS_RECEIVED: 'Total rewards received',
            MY_BEST_REFEREE: 'My best referee',
            YOUR_INVITATION_CODE: 'Your invitation code',
            GENERATE_REFERRAL_SAHRE: 'Generate referral codes and share commissions with your invitees.',
            CREATE_INVITATION_CODE: 'Create invitation code',
            EDIT: 'Edit',
            VIEW_TRANSACTIONS: 'View transactions',
            NAME_CHANGE: 'name change',
            NEW_NAME: 'New name',
            CHANGE: 'change',
            CREATE_CODE: 'Create code',
            INVITED_PERSON_SHARE: 'invitee share',
            YOUR_SHARE: 'Your share',
            NAME: 'Name',
            CANCEL: 'Cancel',
            CREATE: 'Create',
            INVITED_PERSON: 'invitee',
            TOTAL_REWARDS: 'total reward',
            MY_REWARD: 'my reward',
            INVITED_PERSON_REWARD: 'invitee reward',
            OPERATION_DATE: 'Operation date',
            TRACKING_NUMBER: 'Tracking number',
            TRANSACTION_TYPE: 'Transaction type',
            CHANGE_STATUS: 'Change status',
            SCORE: 'Score',
            TOTAL_SCORE: 'total score',
            INVITING_MONETIZATION_PROGRAM: 'Monetization program for inviting friends',
            BECOME_AFFILIATE: 'Collaboration Request with TopChange',
            INVITED_BY_FRIENDS: 'I have been invited by my friend',
            REFERRAL_LINK: 'Referral link',
            INCOME_SOURCE_REFERRALS: 'Income source referral codes',
            SUCCESSFUL_REFERRALS: 'Successful referral codes',
            AFFILIATE_SHARE: 'Affiliate share',
            AFFILIATE_NEW_REQUEST: {
                TITLE_FORM: 'Affiliate Program Form',
                DESCRIPTION_SUCCESS_FORM: 'Your application has been approved with the details below.',
                DESCRIPTION_PENDING_FORM: 'Your application has been submitted successfully. Our team will review it and register your account. You can view your submitted information here.',
                DESCRIPTION_FORM: 'Dear user, please complete the form below to join the TopChange Affiliate Program.',
                TELEGRAM_ID: 'Telegram ID',
                EXPECTED_INVITEE_COUNT: 'Approximately how many referrals do you expect to bring in during the first month?',
                EXPECTED_MONTHLY_VOLUME: 'What is the estimated total broker trading volume of your referrals during the first month?',
                TYPICAL_TRADE_SIZE: 'What amounts will your referrals typically trade?',
                INVITEE_COUNT_0_10: '0 to 10 people',
                MONTHLY_VOLUME_1000_10000: '$1,000 to $10,000',
                TRADE_SIZE_LOW_100_1000: 'Low ($100 to $1,000)',
                TARGET_BROKERS: 'Which brokers do you plan to recruit referrals for through TopChange?',
                REFERRAL_TRADING_BROKERS: 'Which brokers will your referrals trade with?',
                HAS_IB_EXPERIENCE: 'Have you ever worked as an Introducing Broker (IB)?',
                IB_EXPERIENCE_BROKERS: 'Which brokers have you worked with as an IB?',
                STRATEGY: 'What resources and strategies will you use to participate in the TopChange Affiliate Program?',
                STRATEGY_HINT: 'Content creation, social media campaigns, email marketing, social media channels, or other methods',
                BIGGEST_CHALLENGE: 'What will be your biggest challenge in participating in this program?',
                COMMENTS: 'Please share any additional comments or suggestions.',
                SUBMIT_REQUEST: 'Submit Application',
                CLEAR_FORM: 'Clear Form',
                YES: 'Yes',
                NO: 'No',
                TYPE_EXPECTED_INVITEE_COUNT: {
                    From0To10: '0 to 10 people',
                    From11To30: '11 to 30 people',
                    From31To50: '31 to 50 people',
                    From51To100: '51 to 100 people',
                    Over100: 'More than 100 people',
                },
                TYPE_TYPICAL_TRADE_SIZE: {
                    Low: 'Low ($100 to $1,000)',
                    Medium: 'Medium ($1,000 to $10,000)',
                    High: 'High ($1,000,000+)',
                },
                TYPE_EXPECTED_MONTHLY_VOLUME: {
                    From1KTo10K: '$1,000 – $10,000',
                    From10KTo50K: '$10,001 – $50,000',
                    From50KTo100K: '$50,001 – $100,000',
                    From100KTo250K: '$100,001 – $250,000',
                    From250KTo1M: '$250,001 – $1,000,000',
                    Over1M: 'More than $1,000,000',
                },
                ALERT: {
                    SEND_SUCCESSFUL: 'Application Submitted',
                    SEND_SUCCESSFUL_DESC: 'Your application has been submitted successfully. Our team will review it and register your account.',
                    SEND_ERROR: 'Submission Failed',
                    SEND_ERROR_DESC: 'There was a problem submitting your application. Please check your internet connection and try again, or contact support.',
                    SEND_REJECTED: 'Application Rejected',
                    SEND_REJECTED_DESC: 'Unfortunately, your application was not approved. Please review your information and try again, or contact support.',
                    SHOW_FORM: 'View Form',
                    TRY_AGAIN: 'Try Again',
                    TRACKING_NUMBER: 'Tracking Number:',
                    TRY_AGAIN_ON: 'Try again on ',
                },
                STATUS: {
                    Pending: 'Pending Review',
                    Approved: 'Approved',
                    Rejected: 'Rejected',
                    Expired: 'Closed Without Review',
                },
            },
        },
        TRANSFER: {
            TRANSFER_FROM_TC_TO_GC: 'Transfer from Topchange wallet to GreenChange website',
            GC_ADDRESS: 'https://GreenChange.io',
            TOPCHANGE_LOOKING_FOR_SAFETY: '',
            TRANSFER_ANNOUNCEMENT: {
                TITLE: 'Transfer Topchange cryptocurrencies to the GreenChange website',
                DESCRIPTION: 'Users who have previously used the cryptocurrency services of TopChange can use the same email and password to enter GreenChange; needless of registration and authentication process. So after transferring crypto wallets you can do your exchange in GreenChange but can still use your fiat wallet in TopChange',
                ITEM1: 'Automatic withdraw and deposit',
                ITEM2: 'Increase transaction security',
                ITEM3: 'Add more services in the field of cryptocurrencies'
            },
            NEW_CHANGES: {
                TITLE: 'New changes in TopChange',
                BUY: {
                    TITLE: 'Buy crypto Currency',
                    PRE_DESCRIPTION: 'Charge your green change wallets via your fiat wallets in top change',
                    DESCRIPTION: 'You can recharge your cryptocurrency wallets in Green Change through Fiat wallets in TC.'
                },
                SELL: {
                    TITLE: 'Sell crypto currency',
                    PRE_DESCRIPTION: 'Withdraw from green change crypto wallets and receive in your top change wallet',
                    DESCRIPTION: 'You can exchange your cryptocurrency from green change wallet to your fiat wallets in tc and receive the desired amount through withdrawal methods in TopChange .  [ Cash, Bank, etc ]'
                }
            },
            TRANSFER_LERANING: {
                TITLE: 'How can i transfer my cryptocurrency wallets from TopChange to GreenChange ?',
                QUESTION_ONE_LOGIN_TITLE: 'I had a transaction related to cryptocurrency wallets in TopChange',
                QUESTION_ONE_LOGIN_DESCRIPTION: 'They can still use the fiat wallets in top change ; but after transferring the cryptocurrency wallets to GreenChange; they should do all exchanges related to the cryptocurrency on the green change website',
                QUESTION_ONE_LOGIN_BTN: 'Login to GreenChange',
                QUESTION_ONE_REGISTER_TITLE: 'I have not yet registered any request in tc regarding cryptocurrency',
                QUESTION_ONE_REGISTER_DESCRIPTION: 'This group of users can also continue their activities on Fiat wallets in TopChange. But if they are interested in using currency exchange services, they must register and authenticate on the Green Change site.',
                QUESTION_ONE_REGISTER_BTN: 'Register at GreenChange',
                TRANSFER_DEADLINE: 'Deadline for transfer: 17th of July at 14:00 Gmt',
                QUESTION_TWO_REGISTER_DESCRIPTION: 'During this period, you have the opportunity to transfer your cryptocurrencies from <span class="tc-span">TopChange</span> to <span class="gc-span">GreenChange</span> or withdraw your cryptocurrency balances, otherwise the transfer of your cryptocurrencies will be done automatically on 17th of July at 14:00 Gmt'
            },
            TRANSFER_REPORT: {
                TITLE: 'Transfer TopChange wallets to the GreenChange website',
                DESCRIPTION: 'lorem ipsun',
                WALLET: 'Wallet',
                PRICE: 'Price',
                CLICK_HERE: 'Click Here!',
                I_WANT_MORE_ABOUT_TRANSFER: 'I want to know more about transferring cryptocurrency wallets.',
                BOX_INFO: {
                    TITLE: 'Characteristics',
                    TEXT: 'Dear User, Because you already had Cryptocurrency transactions on Topchange, You have an account on Greenchange website and you can enter it with your Username and Password from Topchange. Please check it and if everything is ok proceed with the transaction process, otherwise contact us from the <a href="/support/tickets">ticket</a> section.',
                    FULL_NAME: 'ّFull Name',
                    USERNAME: 'Username',
                    DATE_OF_BIRTH: 'Date of birth',
                    NATIONAL_CODE: 'National number',
                    PASSPORT: 'Passport'
                },
                CHECK_INFO_TXT: 'The specifications displayed on the GreenChange site belong to me.',
                CHECK_POLICY_TXT: 'I agree that :<br/><ul><li>a new user account at Green Change (https://GreenChange.io)  will be opened for me.</li><li>for access to my account with GreenChange, I need to use the same username and password as for Top Change</li><li>all my crypto assets will be transferred from TopChange to GreenChange.</li></ul>',
                TRANSFER_BTN: 'transfer',
                ALERT_AFTER_TRANSFER: 'Dear user, your transfer has been done.'
            },
            CONFIRM_DIALOG: {
                TITLE: 'Transfer confirmation',
                ENTER_CODE: 'To submit your request, please enter the verification code sent to <span> {{phoneNumber}} </span> and <span> {{userEmail}} </span>.',
                CANCEL: 'Cancel'
            },
            LEARN_FILES: {
                TITLE: 'Educational files',
                FILE_NAME1: 'How to transfer money from GreenChange to TopChange',
                FILE_NAME2: 'Authentication',
                FILE_NAME3: 'How to transfer money from TopChange to GreenChange',
            },
            ALERT: {
                TRANSFER_DONE_SUCCESSFULLY: 'The transfer operation was successful.',
                TRANSFER_DONE: 'Dear user, Your Cryptocurrency wallets transfered from TopChange to GreenChange successfully.',
                TRANSFER_DONE1: 'Dear user, your transfer has been done!',
                TRANSFER_DONE2: 'You can login to GreenChange and view your Cryptocurrency wallets.',
                TRANSFER_DONE3: 'Login to GreenChange',
                WITHOUT_TRANSACTION: 'Dear user, there is no transaction in your cryptocurrency wallets.'
            }
        },
        GENERAL: {
            STATUSES: "Status",
            ATTENTION: 'Attention',
            ACTION: "Action",
            ACTIONS: "Action",
            ACTIVE: "Active",
            ADD: "Submit",
            ADD2: "ADD",
            ALERT: "Alert",
            ALERT_DELETE: "Are you sure you want to delete…?",
            ALERT_SECURE_CODE_TIME_EXPIRED: "Code has expired",
            ALL: "All",
            ALLOWED_FILES: "Allowed files",
            ATTACHMENT: "Files",
            ATTACHMENT_VIEW: "Attached file",
            AUTHENTICATION: "Verification",
            AUTH_ALERT_TEXT: "Dear User, For… you need to verify these items :",
            AT_LEAST: 'At Least',
            BALANCE: 'Balance',
            VIDEO_GUIDE: 'Video guide',
            GUIDE: 'guide',
            BACK: "Back",
            BLOCK: "Block",
            BUY: "Buy",
            CANCEL: "Cancel",
            CATEGORY: "Category",
            CHANGE_FILE: "Change file",
            CLEARE_ALL: "Clear all",
            CLICK_HERE: "Click Here",
            IMPORTANT_POINTS: 'Important Points',
            CLICK_TO_COPY_NUMBER: "Click to copy number",
            TRACKING_NUMBER_COPIED_SUCCESSFULLY: "Tracking number copied successfully",
            COPIED: 'Copied',
            CLOSE: "Close",
            CODE: "Code",
            CONFIRM: "Confirm",
            OPTIONAL: "Optional",
            CONFIRM_AND_UPLOAD: "Confirm and Upload",
            CONGRATULATION: "Congratulations",
            CONTINUE_CONFIRM: "Continue Confirm",
            CONTANCT_SUPPORT_FOR_MORE_INFO: 'Contact support for more information',
            CREATE: "Create",
            DASHBOARD: "Dashboard",
            DATE: "Date",
            DATE_FROM: "Date from",
            DATE_TO: "Date to",
            DEACTIVE: "Deactive",
            DELETE: "Delete",
            DEPOSIT: "Deposit",
            DESCRIPTION: "Description",
            DETAILS: "Details",
            DONE: "Confirmed",
            DOWNLOAD: "Download",
            EDIT: "Edit",
            EMAIL: "Email",
            SMS: 'SMS',
            ERROR: "Error",
            EXAMPLE: "Example",
            EXCHANGE: "Exchange",
            CHANGE: "Change",
            EXIT: "Exit",
            EXPERT_COMMENT: "Expert Comment",
            EXPORT: "Export",
            FEMALE: "Female",
            FILTER: "Filter",
            HELP: "Help",
            HOME: "Home",
            HOURS_AGO: "Hours ago",
            LAST_UPDATE: "Last Update",
            MALE: "Male",
            MESSAGE: "Message",
            MINUTES_AGO: "Minutes ago",
            MORE_INFO: "More info",
            NAME: "Name",
            NEW: "New",
            NEW_STATUS: "New Status",
            NEXT: "Next",
            NO: "No",
            NOTHING_TO_DISPLAY: "No item to show",
            NO_ITEM_TOـSHOW: "No item to show",
            PHONE: "Phone",
            POINT: "Point",
            QUICK_ACCESS: "Quick Access",
            RECIEVE: "Receive",
            REFUND: "Refund",
            REJECTED: "Rejected",
            REPLAY: "Reply",
            REQUEST: "Request",
            RETURN: "Return",
            ROW: "Row",
            SAVE: "Save",
            SEARCH: "Search",
            SECOND_AGO: "Seconds ago",
            SECURITY_CODE: "Security Code",
            SELECT_FILE: "Select File",
            SELL: "Sell",
            SEND: "Send",
            SEND_CODE: "Send Code",
            SERVICE: "E-Money",
            SHOW_ALL: "See all",
            SMS_CREDIT: "SMS Credit",
            STATUS_DATE: "Status change date",
            LAST_STATUS_DATE: 'Date of Last Status Change',
            STATUS_TEXT: "Status",
            SUBJECT: "Subject",
            SUBMIT: "Submit",
            SUMMARY: "Request details",
            TEXT: "Text",
            TITLE: "Title",
            TRACKING_NUMBER: "Tracking Number",
            TRANSACTIONS: "Transactions",
            UPDATE: "Update",
            UPLOADING: "Uploading",
            WAITING: "Waiting",
            WATING: "Waiting",
            WITHDRAW: "Withdraw",
            YES: "Yes",
            EMONEY: 'E-Money',
            CHOOSE: 'Choose',
            CRYPTO: 'Crypto',
            UNKNOWN: 'Unknown',
            NOT_APPLICABLE: 'Not Applicable',
            TYPE: 'Type',
            TEXT_COPIED: 'Copeid to clipboard!',
            CLICK_FOR_COPY: 'Click To copy',
            RETRY: 'Retry',
            SELECT: 'Select',
            VERIFY: 'Verify',
            I_UNDERSTAND: 'I understand',
            PLEASE_CONTACT_SUPPORT: 'Please contact support.',
            ENTER_THE_INFORMATION_FIRST: 'Enter the information first.',
            FROM_DATE: "From Date",
            TO_DATE: "To Date",
            TH_1: 'First',
            TH_2: 'Second',
            TH_3: 'Third',
            TH_4: 'Fourth',
            TH_5: 'Fifth',
            TH_6: 'Sixth',
            TH_7: 'Seventh',
            TH_8: 'eighth',
            TH_9: 'Ninth',
            TH_10: 'tenth',
            TH_11: 'Eleventh',
            TH_12: 'twelfth',
            TH_13: 'thirteenth',
            TH_14: 'fourteenth',
            TH_15: 'Fifteenth',
            TH_16: 'Sixteenth',
            TH_17: 'seventeenth',
            TH_18: 'eighteenth',
            TH_19: 'nineteenth',
            TH_20: 'twentieth',
            _1: 'one',
            _2: 'two',
            _3: 'three',
            _4: 'four',
            _5: 'five',
            _6: 'six',
            _7: 'seven',
            _8: 'eight',
            _9: 'No',
            _10: 'ten',
            _11: 'eleven',
            _12: 'twelve',
            _13: 'thirteen',
            _14: 'fourteen',
            _15: 'fifteen',
            _16: 'sixteen',
            _17: 'Seventeen',
            _18: 'eighteen',
            _19: 'nineteen',
            _20: 'twenty',
            FILE_UPLOAD_LIMITAION: {
                SIZE: 'Maximum file size: {{value}} MB',
                FORMAT: 'Allowed file types: {{value}}'
            },
            INPUT: {
                CHOOSE_CURRENCY: "Choose Currency",
                MORE_INFO: "More info"
            },
            STATUS: {
                PENDING: 'Pending',
                WAITING: 'Waiting'
            },
            DISABLED: "Disabled",
            TRANSACTION_NUMBER: "Transaction number",
            DIGITAL_CURRENCY: 'cryptocurrency',
            TRANSACTION_ID: "Transaction ID (hash)",
            SEE_ALL: "See All",
            VIEW_PROFILE: 'View profile',
            NO_RESULTS: 'No results found',
            DOWNLOAD_APP: 'Download',
            VALIDATION_CALCULATION: {
                CalculationFunctionRequired: 'The specified calculation function is required but was not provided.',
                CalculationFunctionNotFound: 'The specified calculation function could not be found.',
                AmountNotFound: 'The required amount was not found.',
                NullTierRanges: 'Tier ranges are null.',
                TierRangesValidationError: 'One or more tier ranges are invalid.',
                TargetTierRangeNotFound: 'The specified target tier range could not be found.',
                RequestedAmountRequired: 'The requested amount is required but was not provided.',
                PayOrGetAmountRequired: 'The pay or get amount is required but was not provided.',
                RequestedAmountOutOfTierRange: 'The requested amount is outside the defined tier ranges.',
                PayOrGetAmountOutOfTierRange: 'The pay or get amount is outside the defined tier ranges.',
                ExchangeRateIsIncorrect: 'The exchange rate is incorrect.',
                Overlap: 'Tier ranges have overlaps.',
                Gap: 'Tier ranges have gaps.',
                ComingSoon: 'This validation is reserved for future use.',
                RequestedAmountNotInTierRange: 'Requested amount not in tier range!',
                AMOUNT_BECAME_NEGATIVE: 'Amount became negative',
            },
            DEACTIVATION: 'Deactivation',
            TRACKING_CODE: 'Tracking code',
            TRANSACTION_INFORMATION: 'Transaction information',
            TRANSACTION_STATUS: 'Transaction Status',
            CONTACT_SUPPORT: 'Contact Support',
            PRICE: "Amount",
            STAY_ON_PAGE: 'Stay on page',
            LEAVE_PAGE: 'Leave page',
        },

        ENUM: {
            WALLET_TYPES: {
                SAVING_ACCOUNT: 'Saving Account',
                TRANSIT_ACCOUNT: 'Transit Account'
            },
            ARCHIVE: {
                ARCHIVED: 'Archived',
                NONE_ARCHIVED: 'None Archived'
            },
            CHANGE_TYPE: {
                DECREASE: 'Decrease',
                INCREASE: 'Increase'
            },
            WALLET_CHANGE_TYPE: {
                INCOMING_PAYMENTS: "Deposit",
                OUTGOING_PAYMENTS: "Withdraw"
            },
            SEEN_USER_TYPES: {
                NOBODY: 'Nobody',
                FRIENDS: 'Friends',
                EVERYONE: 'Everyone'
            },
            PRIORITY_TYPES: {
                HIGH: 'High',
                MEDIUM: 'Medium',
                LOW: 'Low'
            },
            TICKET_STATUS: {
                ANSWERD: "Answered",
                CLOSED: "Closed",
                CUSTOMER_REPLY: "Customer Reply",
                IN_PROGRESS: "Processing",
                ON_HOLD: "On Hold",
                OPEN: "Open",
                TC_CONTACT: "TC Reply",
                ARCHIVED: "Archived"
            },
            PAYMENT_TYPE: {
                BANK: "Bank",
                CASH: "Cash",
                CREDIT: "Credit",
                ELECTRONIC_MONEY: "E-Money",
                ONLINE: "Online",
                ID: 'Bank Transfer',
                Crypto: 'cryptocurrency',
                OfflineCard: 'Offline Card-to-Card',
                OfflineIBAN: 'Offline Iban'
            },
            SEND_PAYMENT_TYPE: {
                BANK: 'Bank to TC',
                CASH: 'Cash to TC',
                CREDIT: 'Credit to TC',
                ONLINE: 'Online to TC',
                ELECTRONIC_MONEY: 'E-Money to TC'
            },
            PAYMENT_STATUS: {
                ACCEPTED: "Accepted",
                NO_CONFIRMED: "Not confirmed",
                PENDING: "Pending",
                REJECTED: "Rejected",
                EXIST: 'Exist',
                AWAITINGAPPROVAL: 'Awaiting Approval',
                FAILURE: 'Failure',
                NOTFOUND: 'Not Found',
                CANCELED: 'Canceled',
                COMPLETED: 'Completed',
                Incomplete: 'Incomplete',
                Refund: 'Refund'
            },
            ACCOUNT_STATUS: {
                Accepted: "Confirmed",
                Blocked: "Blocked",
                PENDING: "Awaiting approval",
                Rejected: "not confirmed",
                Unverified: "Unverified",
                VERIFIED: "not confirmed",
                New: 'Awaiting approval',
                Inquiring: 'Awaiting approval',
                OnHold: 'Awaiting approval',
            },
            REQUEST_STATUS: {
                ACCEPTED: "Accepted",
                DELETED: "Deleted",
                DONE: "Done",
                FAILED: "Failed",
                NEW: "New",
                PAYMENT: "Payment",
                PENDING: "Pending",
                PROCESSING: "Processing",
                REFUND: "Refund",
                REJECTED: "Rejected",
                Paying: "Payment"
            },
            REQUEST_STATUS_DIRECT_DEPOSIT: {
                Done: "Done",
                Refunded: "Refund",
            },
            REQUEST_STATUS_CRYPTO: {
                New: "New",
                Processing: "Processing",
                Accepted: "Processing",
                Failed: "Failed",
                Completed: 'Completed',
                Broadcast: 'Broadcast',
                Pending: 'Pending',
                Sending: 'Sending',
                AwatingApproval: 'Awating Approval',
                Paying: 'Paying',
                Done: 'Done',
                Canceled: 'Canceled',
                Failure: 'Failure',
                Exception: 'Exception',
                Scheduled: 'Processing'
            },
            GATE_WAY_REQUEST_STATUS: {
                New: "New",
                Cancel: 'Cancel',
                Paid: 'Paid',
                Verified: 'Verified',
                ExpireToken: 'ExpireToken',
                ExpireRequest: 'ExpireRequest',
                Refund: 'Refund'
            },
            ONLINE_PAYMENT_STATUS: {
                FAILED: "Failed",
                INCOMPLETE: "Incomplete",
                REFUND: "Refund",
                SUCCESS: "Successful"
            },
            DIRECT_DEPOSIT_PAYMENT_STATUS: {
                Refund: "Refund",
                ACCEPTED: "Successful",
                NO_CONFIRMED: "Not confirmed",
                PENDING: "Pending",
                REJECTED: "Rejected",
                EXIST: 'Exist',
                AWAITINGAPPROVAL: 'Awaiting Approval',
                FAILURE: 'Failure',
                NOTFOUND: 'Not Found',
                CANCELED: 'Canceled',
                COMPLETED: 'Completed',
                Incomplete: 'Incomplete',
            },
            POINT_CHANGE_TYPE: {
                ReceivedPoints: "Received points",
                WithdrawalPoints: " Withdrawn points"
            },
            TRANSACTION_TYPES: {
                BETWEEN_MY_WALLETS: "Between Wallets",
                BUY_SERVICE: "Buy E-Money",
                CHARGE_SMS_PANEL: "SMS Credit Charge",
                CHARGE_WALLET_CREDIT: "Wallet Credit Charge",
                DEPOSIT: "Deposit",
                EXCHANG_ESERVICE: "Exchange E-Money",
                INTERNAL_TRANSFER: "Internal Transfer",
                SELL_SERVICE: "Sell E-Money",
                TC_PAY_GATEWAY: "TopChange Gateway",
                VOUCHER_SERVICE: "Voucher Service",
                WITHDRAWAL: "Withdraw",
                WITHDRAWAL_POINT: "Point Withdraw",
                WalletCorrectionRequest: 'Wallet Correction',
                PointCorrectionRequest: 'Point Correction',
                Transition: 'Transition',
                TerminalSettlement: 'Terminal Settlement',
                BrokerDeposit: 'Broker Deposit',
                DirectDeposit: 'Bank Transfer',
                LOCK_WALLET: 'Locking Wallet',
                UNLOCK_WALLET: 'Unlocking Wallet',
                P2P_INTERNAL_TRANSFER: 'P2P Internal Transfer',
                P2P_PENALTY: 'P2P Penalty',
                AffiliateProgram: 'Affiliate Program',
                P2PCommission: "P2P Commission",
                CryptoDeposit: 'Cryptocurrency Deposit',
                CryptoWithdrawal: 'Cryptocurrency Withdrawal',
            },
            NOTIFICATION_TYPE: {
                ContactUs: "Contact Us",
                Deposit: "Deposit",
                Exchange: "Exchange",
                ExpertTicket: 'Support\'s Ticket',
                Friend: "Friends",
                Point: "Point",
                Receive: "Receive",
                RequestMessage: "Request\'s Message",
                Send: "Send",
                Ticket: "Tickets",
                VerifyBankAccount: "Verify Bank account",
                VerifyInfo: "Verify Info",
                Voucher: "Voucher Service",
                WalletChange: "Wallet",
                Withdrawal: "Withdraw",
                DirectDeposit: 'Bank Transfer',
                PointChange: 'Point Changes',
                P2P: "P2P",
                Crypto: 'Cryptocurrency Deposit',
                CryptoWithdraw: 'Cryptocurrency Withdrawal',
                Chat: 'Chat'
            },
            GATEWAY_ACTION_TYPE: {
                Deposit: 'Deposit',
                Withdraw: 'Withdraw',
                50: 'Deposit',
                100: 'Withdraw'
            },
            SETTLEMENT_STATUS_TYPE: {
                New: 'New',
                Completed: 'Completed',
                Failed: 'Failed',
                1: 'New',
                2: 'Completed',
                3: 'Failed',
            },
            REQUEST_TYPE_VALIDATION: {
                0: "Deposit with E-Money",
                1: "Deposit with Currency",
                2: "Currency Exchange",
                3: "E-Money Exchange",
                4: "Point Withdraw",
                5: "Send Currency",
                6: "Send from Wallet",
                7: "Buy Voucher",
                8: "E-Money Withdraw",
                9: "Currency Withdraw"
            },
            REQUEST_TYPE: {
                1: 'Deposit',
                2: 'Withdrawal',
                3: 'Send',
                4: 'Exchange',
                5: 'Point',
                6: 'Voucher'
            },
            REQUEST_TYPE_ACTICE_REQUESTS: {
                1: 'Deposit',
                2: 'Withdrawal',
                3: 'Send',
                4: 'Send',
                5: 'Withdrawal',
                6: 'Deposit',
                7: 'Exchange',
                8: 'Sms Panel Charge',
                9: 'Point',
                10: 'Voucher'
            },
            INVITEE_STATUS: {
                CLEARED: ' Cleared ',
                OUTSTANDING: 'Outstanding ',
            },
            POINT_SORT_OPTION: {
                Newest: 'Newest',
                Oldest: 'Oldest',
                MostPoints: 'Highest rating',
                LeastPoints: 'Lowest rating'
            }
        },
        VALIDATION: {
            AGREEMENT_REQUIRED: "Accepting Privacy & Policy agreement is required.",
            FILE_MAX_SIZE: "The file size is too large.",
            INVALID: "Invalid",
            INVALID_FIELD: '{{name}} is not valid',
            NOT_FOUND: "Request not found.",
            FILE_EXTENSION: 'The selected file format is incorrect.',
            MIN_LENGTH: 'Minimum {{name}} length: {{value}}',
            MAX_LENGTH: 'Maximum {{name}} length: {{value}}',
            REQUIRED: '{{name}} is required',
            MIN_LENGTH_FIELD: 'Minimum field length:',
            SELECT: '{{name}} is required',
        },
        USER: {
            ACCOUNT: {
                BANK: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                BLOCKED: 'Bank account ',
                                REJECTED: 'Bank account ',
                                ACCEPTED: 'Bank account '
                            },
                            BODY: {
                                ACCEPTED: "Bank account…. Info was accepted",
                                BLOCKED: "Account… is blocked",
                                REJECTED: "Bank account…. info was rejected",
                            }
                        }
                    }
                }
            },
            CREDIT: {
                POINT: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                CORRECTION_INCREASE: 'Point Increment',
                                CORRECTION_DECREASE: 'Point decrement'
                            },
                            BODY: {
                                CORRECTION_INCREASE: 'Points for correction was added to your total points.',
                                CORRECTION_DECREASE: 'Points for correction were deducted from your total points.'
                            }
                        }
                    }
                }
            },
            ALERT: {
                ERROR: {
                    TRY_COUNT_EXPIRED_OR_KEY_NOT_FOUND: 'The entered code is incorrect.'
                }
            }
        },
        FRIEND: {
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        NEW_REQUEST: 'Friend request',
                        NEW_REQUEST_TO_NOT: 'Friend request',
                        ACCEPTED: 'Friend request',
                        REJECTED: 'Friend request',
                        CANCEL: 'Friend request'

                    },
                    BODY: {
                        NEW_REQUEST: 'A new request has been sent to you by {{0}}.',
                        ACCEPTED: 'Your friendship request has been accepted by {{0}}.',
                        REJECTED: 'Your friendship request has been rejected by {{0}}.',
                        CANCEL: 'Your friendship request has been deleted  by {{0}}.'
                    }
                }
            }
        },
        WALLET: {
            BALANCE: "Balance",
            CHANGE_TYPE: "Change type",
            CHOOSE_CURRENCY: "Currency type",
            DESCRIPTION: "Description",
            DIACTIVE: "deactive",
            EDIT_WALLET: "Edit Wallet",
            EDIT_WALLETS: "Edit Wallet",
            EVERYONE: "Everyone",
            LOCK_MESSAGE: "Your wallet has been locked. Please contact support.",
            CURRENCY_IS_DEACTIVE: 'It is not possible to use this wallet due to lack of service or exchange rate disruption. Please be patient until it resolves.',
            MY_WALLETS: "My wallets",
            NEW_WALLET: "New Wallet",
            NOBODY: "Private",
            SAVING: "Transit Wallets",
            SEEN_USER_REQURED: "Please choose who can see your wallet.",
            SELECT_DATE_FOR_REPORTING: "Please choose from and to date. The maximum timeline you can choose is 31 days.",
            SELECT_WALLET_FOR_REPORTING: "Please choose the wallet first.",
            SUPPORT_TICKET: "Support ticket",
            TC_WALLETS: "TC Wallet",
            TEXT: "Note",
            TRANSACTIONS: "Transactions",
            TRANSACTION_TYPE: "Transaction type",
            TRANSIT: "Saving wallets",
            VIEW_FRIENDS: "Friends",
            WALLET: "Wallet",
            WALLETS: "Wallets",
            WALLET_TYPE: "Wallet type",
            WHO_CAN_SEE_MY_WALLET: "Show for",
            ACCOUNT_NUMBER: 'Account Number',
            WALLET_NAME: 'Wallet Name',
            CRYPTO_CURRENCY: 'Cryptocurrency',
            CRYPTO_CURRENCIES: 'Cryptocurrencies',
            FIAT: 'Fiat',
            FIAT_WALLETS: 'Fiat Wallets',
            CRYPTO_WALLETS: 'Crypto Wallets',
            WHAT_IS_SAVING_WALLET: 'What is TC saving wallets ?',
            WHAT_IS_TRANSIT_WALLET: 'What is TC transit wallets ?',
            INVOICE_NUMBER: 'Invoice Number',
            INFO_USER: '<span>{{dispalyName}}</span> <span>({{email}})</span> Wallets',
            WALLET_OWNERSHIP_CERTIFICATE_RETRIEVAL: 'Get Wallets Certificate',
            WITHDRAWABLE_AMOUNT: 'Withdrawable amount:',
            WITHDRAWABLE_USDT: 'Withdrawable USDT:',
            ALERT: {
                BALANCE_IS_LOW: "Your wallet\'s balance is not enough.",
                CANT_USE_WALLET_FOR_INTERNAL_TANSFER: "You can not use this wallet for internal transfer.",
                SUCCESS_ADD: "New wallets has been created successfully",
                SUCCESS_EDIT: "Editing wallet has been successful.",
                EXPORT_TRANSACTION_HINT: 'The maximum allowable time for export is one month.',
                FOR_CREATE_WALLET_YOU_NEED_VERIFY: 'To create a wallet, you must first perform your authentication steps on the site.',
                THERE_IS_NO_WALLET_TO_DISPLAY: 'There is no wallet to display',
                USDT_MERGED_WITH_USD_NOTICE: 'Your Tether wallet has been merged. Don’t worry, all your assets are completely secure and have been automatically transferred to the new wallet.',

            },
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        DECREASE: 'Wallet\'s balance decreased',
                        INCREASE: 'Wallet\'s balance increased',
                        PG_DECREASE: 'Amount of {{0}} was withdrawn from the wallet {{1}} by tc payment gateway with tracking number of {{2}}.',
                        PG_INCREASE: 'Amount of {{0}} was deposited to the wallet {{1}} by tc payment gateway with tracking number of {{2}}.',
                        CORRECTION_DECREASE: 'Amount of {{0}} was deducted from wallet {{1}} for correction.',
                        CORRECTION_INCREASE: 'Amount of {{0}} was added to wallet {{1}} for correction.',
                        IPG_SETTLEMENT_INCREASE: 'The amount of {{0}} {{4}} has been added to your Rial wallet'
                    },
                    BODY: {
                        PG_DECREASE: 'Amount of {{0}} was withdrawn from the wallet {{1}} by tc payment gateway with tracking number of {{2}}.',
                        PG_INCREASE: 'Amount of {{0}} was deposited to the wallet {{1}} by tc payment gateway with tracking number of {{2}}.',
                        CORRECTION_DECREASE: 'Amount of {{0}} was deducted from wallet {{1}} for correction.',
                        CORRECTION_INCREASE: 'Amount of {{0}} was added to wallet {{1}} for correction.',
                        IPG_SETTLEMENT_INCREASE: 'The amount of {{0}} {{4}} has been added to your Rial wallet'
                    }
                }
            },
            VALIDATION: {}
        },
        SUPPORT: {
            TICKET: {
                DISABLED_NEW_TICKET_MESSAGE: 'Dear user, create new ticket is disabled, please use online chat instead.',
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            CLOSED: 'Tickets',
                            ADD_REPLY: 'Tickets',
                            EXPERT_TICKET: 'Expert ticket'
                        },
                        BODY: {
                            ADD_REPLY: "There is a new expert reply for ticket number {{0}}.",
                            CLOSED: "Ticket number {{0}} was closed by an expert.",
                            EXPERT_TICKET: 'A tickets has been submitted for you by experts.'
                        }
                    }
                }
            },
            CHAT: {
                TRACKING_NUMBER: "Tracking number",
                SELLER: 'Seller',
                BUYER: 'Buyer',
                TRANSACTIONS: 'transactions',
                SUCCESS: 'success',
                SUPPORT: 'Support',
                WRITE_YOUR_MESSAGE_HERE: 'Write your message here...',
                CONFIRM_AND_START_CHAT: 'Confirm and Start Chat',
                THIS_CONVERSATION_HAS_ENDED: 'This conversation has ended.',
                SHOW_ALL: 'Show All',
                SHOW_LESS: 'Show less',
                CHAT_WITH_SELLER: 'Chat with seller',
                CHAT_WITH_BUYER: 'Chat with buyer',
                GROUP_YESTERDAY: 'Yesterday',
                GROUP_TODAY: 'Today',
                RULES: {
                    RULE_ONE: {
                        TITLE: 'Identity Verification',
                        TEXT_ONE: 'You confirm that you have accurately identified your role as either buyer or seller.',
                        TEXT_TWO: 'Any use of false identity, misrepresentation, or attempts to deceive the other party are prohibited.',
                    },
                    RULE_TWO: {
                        TITLE: 'Security and Confidentiality',
                        TEXT_ONE: 'Avoid sharing sensitive, confidential, or personal information in conversations that could be misused.',
                        TEXT_TWO: 'You are responsible for protecting your own information.',
                    },
                    RULE_THREE: {
                        TITLE: 'Responsible and Legal Behavior',
                        TEXT_ONE: 'Any threats, insults, illegal demands, requests contrary to the laws of the country, or unprofessional conduct are prohibited.',
                        TEXT_TWO: 'Financial or transactional agreements must be clear, traceable, and compliant with the law.',
                    },
                    RULE_FOUR: {
                        TITLE: 'Avoid Transferring Funds Outside Secure Framework',
                        TEXT_ONE: 'Do not transfer any funds until the terms of the transaction are finalized and clear.',
                        TEXT_TWO: 'If necessary, only use secure methods introduced by the platform.',
                    },
                    RULE_FIVE: {
                        TITLE: 'Transparency in Transactions',
                        TEXT_ONE: 'The seller must clearly state the details of the goods or services, final price, delivery conditions, and any potential issues.',
                        TEXT_TWO: 'The buyer must clearly communicate their conditions, expectations, and needs.',
                    },
                    RULE_SIX: {
                        TITLE: 'Support Team Intervention',
                        TEXT_ONE: 'The support team has the right to enter the conversation at any time without prior notice.',
                        TEXT_TWO: 'If suspicious behavior, rule violations, or requests from either party are observed, support may review, limit, or terminate the conversation.',
                    },
                    INTERNAL_CHAT_ONLY: "All transaction-related communications must be conducted exclusively through the platform's internal chat.",
                    EXTERNAL_CHANNEL_FORBIDDEN: "Transferring conversations to any channel outside the platform is prohibited and will not be considered valid in dispute resolution.",
                    CONTACT_SHARING_FORBIDDEN: "Sharing contact numbers, social media IDs, or transferring conversations outside the platform is strictly prohibited.",
                    UNPROFESSIONAL_MESSAGE_WARNING: "Avoid sending unprofessional or non-standard messages, or requesting changes to the terms of the transaction.",
                    DISPUTE_EVIDENCE_POLICY: "In the event of a dispute, only documents and information recorded in the platform's internal chat will serve as the basis for review and decision-making.",

                },
                REPORT_VIOLATION: 'Report',
                CONVERSATION_BLOCKED: 'The conversation has been blocked.',
                THIS_CONVERSATION_HAS_BEEN_CLOSED_BY_AN_ADMIN: 'This conversation has been closed by the admin.',
                REPORT_OF_RULE_VIOLATION: 'Report of rule violations',
                REPORT_OF_RULE_VIOLATION_TEXT: 'If you observe any suspicious activity, please report the relevant user immediately. This action helps us take necessary measures effectively and quickly, ensuring the security and safety of the user environment. Your cooperation in this matter is highly valued.',
                CONFIRM: 'Confirm',
                EDIT: 'Edit',
                ENTER_THE_DESCRIPTION: 'Enter description...',
                WE_ARE_REVIEWING_YOUR_REPORT: 'Your report has already been received and is currently under review.',
                REPORT_OF_RULE_VIOLATION_WARN: 'Report of Rule Violation',
                REPORT_OF_RULE_VIOLATION_WARN_TEXT: "Your behavior or content has not complied with some of the platform's rules and standards. This report may have been filed for reasons such as violation of safety guidelines, inappropriate communications, or unauthorized activities. Please review the rules and adhere to them in future interactions to prevent this situation from recurring.",
                CONFIRM_AND_CONTINUE_CHAT: 'Confirm and continue chat',
                REASON_REPORT: {
                    offPlatform: 'Off-platform transaction',
                    shareContact: 'Sharing contact info',
                    abuse: 'Offensive language',
                    illegal: 'Fraudulent activity',
                    spam: 'Sending spam messages',
                    threat: 'Threats or extortion',
                },
                ALERTS: {
                    TITLE_SUCCESSFULL_REPORT: 'The report has been successfully submitted.',
                    DESCRIPTION_SUCCESSFULL_REPORT: 'Thank you for your action. Our specialists are reviewing your report.',
                }
            }
        },
        ADV_BANNER: {
            ADV_BANNER_BANNER: 'TC offer to you'
        },
        CRYPTO_DEPOSIT: {
            DIALOG_ALERT: {
                TITLE_CHANGE_ADDRESS: 'Changing Tether deposit addresses',
                BIG_DESCRIPTION_CHANGE_ADDRESS: 'Your Tether deposit addresses will change starting February 3rd.',
                TEXT_ONE: 'From this date:',
                TEXT_TWO: 'Only use the new addresses on this page.',
                TEXT_THREE: 'Deposits to old addresses will be your personal responsibility.',
                GOT_IT: 'Understood',
            },
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        CRYPTO_DEPOSIT: "Received (wallet)"
                    },
                    BODY: {
                        CRYPTO_DEPOSIT: "An amount of <span class=\"fa-number-dir\">&rlm;{{0}} </span> on the <span>{{1}}</span> network with transaction ID <span>{{2}}</span> was received."
                    }
                }
            }
        },
        CRYPTO_WITHDRAW: {
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        CRYPTO_WITHDRAW: 'Withdrawal from Wallet'
                    },
                    BODY: {
                        CRYPTO_WITHDRAW: 'An amount of <span class=\"fa-number-dir\">&rlm;{{0}} </span> was withdrawn on the <span>{{1}}</span> network with tracking number <span>{{2}}</span>.'
                    }
                },
            }
        },
        APPLICATION_PWA: {
            TEXT: 'Application TopChange',
            INSTALL: 'Install',
            UPDATE_VERSION: 'A new version is ready. Update now to get the latest changes.',
            UPDATE: 'Update',
            ALERTS_PAGE: {
                UPDATE: 'Update',
                NEED_UPDATE_TEXT: "To enhance your experience, we have introduced new features and made changes to the app's performance. We recommend updating your app.",
                FORCE_UPDATE_TEXT: "To maintain the security of your account and ensure uninterrupted access to services, please update your app to the latest version. This will only take a moment.",
                LATER: 'Later',
                SERVICE_DISABLED_TITLE: 'Service Discontinued',
                SERVICE_DISABLED_TEXT: 'This version of the application has reached the end of its activity and is no longer supported. We sincerely thank you for your companionship during this time. If you have a remaining balance or any questions about your account, please contact support immediately.',
                EXIT_APP: 'Exit App',
                DEVICE_IS_ROOTED_TITLE: 'App Access Blocked',
                DEVICE_IS_ROOTED_TEXT: 'In order to protect the security of your account and assets, running TopChange on rooted devices is not permitted.',
            },
            BIOMETRIC: {
                TITLE: 'TopChange',
                SUB_TITLE: 'Verify your identity to sign in',
                CANCEL: 'Cancel',
                SAVE_TITLE: "Save Password",
                SAVE_DESC: "Save your password for faster login next time.",
                SAVE_CONFIRM: "Save",
                SAVE_CANCEL: "No, thanks"
            },
            FILE_DOWNLOAD: {
                SUCCESS_IOS: "File saved in Documents folder",
                SUCCESS_ANDROID: "File saved in Downloads folder",
                ERROR: "Error downloading file"
            }
        },
        DASHBOARD_NEW: {
            KYC_VERIFICATION: {
                TEXT: 'Please complete your authentication to access TC services and activate deposits, cryptocurrency purchases, and trading permissions.',
                AUTHENTICATION: 'Authentication',
                CONTINUE: 'Continue',
                ALERT_KYC_TITLE: "You can't use this feature",
                ALERT_KYC_TEXT: 'To access TC services, please complete your authentication first.',
            },
            ACTIVE_REQUEST: {
                TITLE_ACTIVE_REQUEST: 'Active Requests',
                VIEW: 'View',
                AMOUNT_AND_TYPE: 'Type and Amount',
                CHANGE_STATUS_DATE: 'Time of Status Change',
                YOU_HAVE_NO_ACTIVE_REQUESTS: 'You have no active requests.',
            },
            EXCHANGE_RATE: {
                TILTE_EXCHANGE_RATE: 'Exchange Rate',
                BUY: 'Buy:',
                SELL: 'Sell:',
                NOT_FOUND_SEARCH: 'No results were found for your search. Please try another currency name.',
                SEARCH: 'Search'
            },
            DIALOG_MARATHON: {
                TITLE: 'The profit marathon has begun!',
                DESC_ONE: 'Join the competition by buying or selling <span class="bold">Tether</span> on <span class="en-number">P2P</span> and win prizes!',
                DESC_TWO: 'You only have until June 17th!',
                COMPETITION_INFORMATION: 'Competition Information',
                BUY_ADS: 'Buy Advertisement'
            }
        },
        KYC_AUTH_NEW: {
            MOBILE_PHONE: 'Mobile phone',
            IDENTITY_INFORMATION: 'Identity information',
            COMMITMENT_LETTER: 'Commitment Confirmation',
            AUTHENTICATION: 'Authentication',
            TEXT_STEPPER: 'Please complete the following steps to verify your authentication.',
            PHONE_STEP_DESC: 'Please enter a mobile phone number that belongs to you.',
            COUNTRY: "Country",
            CONFIRM_CODE: 'Confirm code',
            CHANGE_NUMBER: 'Change number',
            DESCRIPTION_CONFIRM_PHONE_NUMBER_DIALOG: 'Please enter the code sent to <strong class="dltr">{{value}}</strong>.',
            YOUR_PROFILE_IS_INCOMPLETE: 'Your profile is not complete.',
            DESCRIPTION_KYC_ALERT_DIALOG: 'To display information in your profile, please authenticate first.',
            IDENTITY_INFO: {
                DESC_START_KYC: 'When you are ready, tap "Start" to begin the process.',
                TITLE_NOT_COMPLETE_KYC: 'Identity information incomplete',
                DESC_NOT_COMPLETE_KYC: 'Dear user, you have not yet completed your identity verification process. When you are ready, tap "Continue" to start the process.',
                START: 'Start',
                CONTINUE: 'Continue',
                TITLE_PENDING_CHECK_KYC: 'Reviewing identity information',
                DESC_PENDING_CHECK_KYC: 'Dear user, your documents have been successfully uploaded and are being reviewed by our experts. Please be patient.',
                LIST_INFO_FOR_KYC: {
                    TITLE_PERSONAL_INFO: 'Personal Information',
                    DESC_PERSONAL_INFO: 'Please enter your personal information (first and last name, national ID number, date of birth, gender) in Persian according to the submitted document.',
                    TITLE_DOCUMENTS: 'Identity Documents',
                    DESC_DOCUMENTS: "Please select one of the options (national ID card, passport, driver's license) and upload an image of it. Please ensure that it is not expired and is in good condition before submitting a high-quality photo.",
                    TITLE_FACE_VERIFICATION: 'Face Verification',
                    DESC_FACE_VERIFICATION: 'Visual identity verification is simply done by turning your head for a few moments in front of the camera.',
                },
                PHONE_NUMBER_INFO_EDIT: {
                    TILTE_IDENTITY_INFO_DOES_NOT_MATCH: 'The identity information does not match the phone number owner.',
                    DESC_IDENTITY_INFO_DOES_NOT_MATCH: 'Dear user, the documents you submitted do not belong to the owner of the phone number you entered. Please try again after entering a phone number that belongs to you.',
                    DOCUMENTS: 'Documents',
                    INFO_DOCUMENTS_UPLOADED: 'The documents you have uploaded are as follows:',
                    FULL_NAME: 'Full Name',
                    DATE_OF_BIRTH: 'Date of birth',
                    NATIONAL_CODE: 'National ID',
                    PENDING_REVIEW_PHONE_NUMBER: 'Your number is being reviewed, please be patient',
                },
                REJECTED: {
                    TITLE: 'Authentication failed',
                    MESSAGE_TEXT: 'Dear user, unfortunately, there have been issues with your authentication process. Please contact support to continue.',
                    CONTACT_SUPPORT: 'Contact Support',
                },
            },
            COMMITMENT_CONFIRMATION: {
                CONFIRMATION_OF_THE_COMMITMENT_LETTER: 'Confirmation of the Commitment Letter',
                SUB_TEXT_CONFIRMATION_OF_THE_COMMITMENT_LETTER: 'To complete the identity verification process, please confirm the commitment letter.',
                TEXT_CONFIRM_COMMITMENT_LETTER: 'I, {{name}}, with national ID number {{nationalIdentityNumber}}, have submitted my documents for identity verification on the (TopChange) website and I fully acknowledge and confirm the following:',
                CONFIRM: 'Confirm',
                ITEM_COMMITMENT_LETTER: {
                    TITLE_ONE: 'Personal identity verification',
                    DESC_ONE: 'The registration and submission of documents was done by me personally, and I have not provided my identity documents to anyone else.',
                    TITLE_TWO: 'Responsibility for Account Usage',
                    DESC_TWO: 'I commit to using my account personally and will not share my banking and identity information with anyone. I will also refrain from receiving cash or cryptocurrency in any form from others in exchange for using my account.',
                    TITLE_THREE: 'Acceptance of Legal Responsibilities',
                    DESC_THREE: 'In the event of any unauthorized use of the account, including the receipt of illegal deposits, I accept full responsibility for it, and in case of any violation, the legal and judicial responsibility, including prescribed penalties and compensation for the complainant, will be my responsibility.',
                }
            },
            DIALOG_AUTH_SUCCESS: {
                TITLE: 'Successful Authentication',
                DESC: 'Dear user, your authentication process has been successfully completed, and you can now use the features of TopChange.',
                PROFILE: 'Profile'
            }
        },
        DIALOG_CONTACT_SUPPORT: {
            TITLE: 'Contact TopChange Support Team',
            DESC: 'Dear user, for more information or to get in touch with our support team, please use one of the methods below.',
        },
        NEW_PROFILE: {
            EMPTY_CONTENT: "There is no content to display.",
            TABS: {
                SECURITY: 'Security',
                AUTH: 'Authentication',
                ACCOUNTS: 'Accounts',
                POINTS: 'Points',
                REQUESTS: 'Requests',
            },
            SECTION_HEAD_PROFILE: {
                LAST_LOGIN: 'Last Login:',
                TITLE_CONFIRM_TWO_FACTOR: "Two-Factor Authentication",
                TITLE_ANTI_PHISHNG: 'Anti-Phishing Code',
                TITLE_LOCAL_TIME: 'Local Time',
                DESC_LOCAL_TIME: 'Please enter the local time you are using TC.',
                TITLE_DEFAULT_LANGUAGE: "Default Language",
                DESC_DEFAULT_LANGUAGE: "Please select the default language; this language will be used for sending emails and TC notifications.",
                ACTIVATED: 'Enabled',
                NOT_ACTIVED: 'Not enabled',
                CONFIRM: 'Confirm',
                CANCEL: 'Cancel',
            },
            SECURITY: {
                TITLE_ADVANCE_SETTING: 'Advanced Security Settings',
                TITLE_CONFIRM_TWO_FACTOR: "Two-Factor Authentication",
                DESC_CONFIRM_TWO_FACTOR: 'Two-step authentication using Google Authenticator.',
                ACTIVE_BTN: 'Enable',
                DEACTIVE_BTN: 'Disable',
                EDIT_BTN: 'Edit',
                TITLE_ANTI_PHISHNG: 'Anti-Phishing Code',
                DESC_ANTI_PHISHNG: 'Make sure your notification emails are only received from Topchange.',
                DESC_2FA_DIALOG_DISABLE: 'Please enter the code sent to the app to disable 2FA.',
                RECENT_HISTORY: {
                    SECURITY_HISTORY: 'Security History',
                    SECURITY_HISTORY_EMPTY: 'There is currently no security history.',
                    RECENT_LOGIN_HISTORY: 'Recent Logins',
                    CHANGE_PASSWORD: 'Change Password',
                    IP: 'IP',
                    TYPE: 'Type',
                    TIME: 'Time',
                    ONLINE: 'Online',
                    OFFLINE: 'Offline',
                    DEVICE_TYPE: 'Device type',
                    STATUS: "Status",
                    SECURITY_RECENT_LOGINS_HISTORY_EMPTY: "There is currently no recent login history.",
                    TYPES: {
                        Register: 'Register',
                        Login: 'Login',
                        Login2FA: 'Login with two-step code',
                        SendRegisterCode: 'Send Register Code',
                        VerifyRegisterCode: 'Verify Register Code',
                        ChangePassword: 'Change password',
                    }
                },
                CHANGE_PASSWORD: {
                    TITLE_CHANGE_PASSWORD: 'Change Password',
                    DESC_DIALOG_CHANGE_PASS: 'Enter your current password and set a new one.',
                    CURRENT_PASSWORD: 'Current Password',
                    NEW_PASSWORD: 'New Password',
                    REPEAT_NEW_PASSWORD: 'Repeat New Password',
                    PASSWORDS_NOT_MATCH: 'The new passwords do not match.',
                    FORGET_CURRENT_PASSWORD: 'Forgot Current Password',
                    FORGET_PASS_DIALOG_DESC: 'Please choose one of the following methods to recover your password.',
                    SEND_CODE_TO_EMAIL: 'Send code to email',
                    FORGET_PASS_DESCRIPTIN_CONFIRM_CODE: 'Please enter the code sent to the email {{email}} to recover your password.',
                    DESC_DIALOG_FORGOT_PASS: 'Please set a new password.'
                }
            },
            AUTH: {
                YOUR_INFORMATION: 'Your information',
                EXPIRETION_DATE: 'Your authentication expiration date:',
                MOBILE_PHONE_NUMBER: 'Mobile phone number',
                CHANGE_PHONE_NUMBER: 'Change phone number',
                PENDING_REVIEW_PHONE_NUMBER: 'Your number is being reviewed, please be patient',
                PAGE_CHANGE_PHONE_NUMBER: {
                    DESC_ENTER_MOBILE_MATCH: 'Please enter the mobile phone number that matches your information.'
                }
            },
            TWO_FACTOR_AUTH: {
                SUCCESSFUL_OPERATION_DESC: 'Your two-step verification has been successfully activated.',
                SUCCESSFUL_OPERATION_DESC_EDIT: "Your two-step verification has been successfully disabled.",
                DOWNLOAD_APP: {
                    DOWNLOAD_THE_APP: 'Download the application',
                    DESC_PAGE_DOWNLOAD_APP: 'Increase the security of your account by installing one of the <span class="en-number">2FA</span> apps. These apps generate one-time codes to prevent unauthorized access.',
                    GOOGLE_AUTH: 'Google Authenticator',
                    GOOGLE_AUTH_DESC: 'Our suggestion is simple, fast, and does not require internet.',
                    OTHER_PROGRAMS: 'Other Programs',
                    OTHER_PROGRAMS_DESC: 'Diverse, reliable, and tailored to specific needs.',
                    NEXT_STEP: 'Next step',
                    DIALOG: {
                        DOWNLOAD_APP: 'Download app',
                        DOWNLOAD_APP_DESC: "Please point your phone's camera at the QR code to download the app.",
                    }
                },
                BACKUP_KEY: {
                    SCAN_THE_CODE: 'Scan the code',
                    SCAN_THE_QR_CODE_IN_THE_AUTH_APP: 'Scan the QR code in the Authenticator app.',
                    GENERATE_CODE: 'Generate code',
                    DESC_EXPIRED_CODE: 'Your previous code has expired, please generate a new code.',
                    DESC_USE_CODE: 'If you are unable to scan the QR code, please enter this code manually in the app.',
                    TITLE_SAVE_SECURITY_KEY: 'Save the security key!',
                    DESC_SAVE_SECURITY_KEY: 'If you delete the app, you can only recover your account with this key.',
                },
            },
            ANTI_PHISHING: {
                DESCRIPTIN_CONFIRM_CODE: 'Enter the code sent to the email {{email}} to activate the anti phishing code.',
                TITLE_EDIT: 'Edit Anti Phishing Code',
                TITLE_ENABLE: 'Activate Anti Phishing Code',
                SUBTITLE_DESC: 'Please enter your desired anti phishing phrase.',
                INFO_ITEM_ONE_TITLE: 'What is an anti phishing code?',
                INFO_ITEM_ONE_DESC: 'It is a code that you choose to help distinguish real TopChange emails from fake ones.',
                INFO_ITEM_TWO_TITLE: 'How does this code protect you?',
                INFO_ITEM_TWO_DESC: 'This code is displayed in all official TopChange emails. If an email does not have your code, it is likely to be fake.',
                ANTI_PHISHING_PHARSE: 'Anti Phishing Phrase',
                SUCCESSFUL_OPERATION_DESC: 'Anti-phishing code has been successfully registered.',
                SUCCESSFUL_OPERATION_DESC_EDIT: 'Anti-Phishing Code was successfully updated.',
                VALIDATE: {
                    INVALID_CHAR: 'numbers and letters',
                    INVALID_LENGTH: 'Between 4 to 15 characters',
                },
            },
            ACCOUNTS: {
                ACCOUNTS: 'Accounts',
                BANK: 'bank',
                E_MONEY: 'Electronic money',
                SEARCH_NOT_FOUND: 'No results found',
                CREATE_ACCOUNT: 'Create account',
                DEACTIVE_DIALOG: {
                    DESCRIPTION: 'Are you sure you want to deactivate your account?',
                    DEACTIVE_BTN: 'Deactivate',
                    DEACTIVE_ALERT_TEXT: 'Your account has been deactivated successfully.',
                    ACTIVE_ALERT_TEXT: 'Your account has been activated successfully.',
                },
                BANK_DATA: {
                    IBAN_NUMBER: 'IBAN number: ',
                    YOU_DO_NOT_HAVE_A_REGISTRED_BANK_CARD: 'You do not have a registered bank card.',
                    CRUD: {
                        CREATE_NEW_BANK_ACCOUNT: 'Create a new bank account',
                        ALERT_CARD_FOR_USER: 'Please be careful when entering your card number; this number must be in your name.',
                        HINT_IBAN_NUMBER: 'Please be careful when entering the IBAN number, as it cannot be edited after registration.',
                        BANK_ACCOUNT: 'Bank account',
                        INVALID_BANK_ACCOUNT: 'Invalid bank account',
                        INVALID_BANK_ACCOUNT_DESC: 'There were discrepancies in your registered bank account, please try again after verifying.',
                        APPLY_CHANGES: 'Apply changes',
                        THE_IBAN_NUMBER_CANNOT_BE_EDITED: 'The IBAN number cannot be edited.',
                    }
                },
                ACCOUNT_HISTORY: {
                    TITLE: 'Account history',
                    HISTORY_DESCRIPTION: 'In this section, you can view the history of deposits and withdrawals from your account.',
                    EMPTY_TRANSACTION: "You haven't had any impressions yet.",
                    MOUNTH: 'Month',
                    AMOUNT_IN_RIAL: 'Amount in Rials',
                    AMOUNT_IN_DOLLAR: 'Amount in TCD',
                    WITHDRAWAL: 'Withdrawal',
                    DEPOSIT: 'Deposit',
                },
                E_MONEY_DATA: {
                    YOU_DO_NOT_HAVE_A_REGISTRED_ACCOUNT: 'You do not have a registered electronic money account.',
                    CREATE_NEW_ACCOUNT: 'Create a new electronic account',
                    ACCOUNT_OWNERS_NAME: "Account holder's name",
                    ELECTRONIC_ACCOUNT: 'Electronic account',
                    DELETE_ACCOUNT: 'Your account has been successfully deleted.',
                }
            },
            POINT_TRANSACTIONS: {
                DEPOSIT_TO_WALLETS: 'Deposit to wallet',
                MINIMUM_POINT_WITHDRAWN: 'The minimum points that can be withdrawn is <span>{{value}}</span> points.',
                TRANSACTION_POINTS: 'Transaction Points',
                SEARCH_TRACKING_NUMBER: 'Search Tracking Number',
                POINTS_WITHDRAWAL: 'Points Withdrawal',
                PLEASE_SELECT_WALLET: 'Please select one of your wallets to continue.',
                WITHDRAWAL_POINTS: 'Withdrawal Points',
                WITHDRAWAL_POINTS_MIN_DESC: 'Please enter the desired points for withdrawal. The minimum withdrawable points is {{value}}.',
                EVERY_VALUE_POINT: 'Every {{value}} points',
                AMOUNT_RECEIVED: 'Amount received:',
                CONFIRM_REQUEST: 'Confirm Request',
                CONFIRM_REQUEST_DESC_DIALOG: 'To submit the request, please verify and confirm the information.',
                WITHDRAWABLE_POINTS: 'Withdrawable points:',
                VALUE_OF_VALUE_POINT: 'Value of {{value}} points:',
                DEPOSIT: 'Deposit',
                ACCEPT_POINT_WITHDRAW: 'I accept the accuracy of the above information.',
                ALERT_SUCCESS_POINT: 'Points withdrawal was successfully completed and the amount has been credited to the desired wallet.',
                MORE: 'More …',
                VALIDATION: {
                    MINIMUM_POINT_WITHDRAWN: 'The minimum points that can be withdrawn is {{value}} points.',
                    MAXIMUM_POINT_WITHDRAWN: 'The maximum points that can be withdrawn is {{value}} points.',
                }
            }
        },
        SHARED_COMPONENTS: {
            DIALOGS: {
                INACCESSIBILITY: 'Access denied',
                INACCESSIBILITY_DESC: 'If you do not have access to your email, please contact support.',
                VERIFY_EMAIL: 'Verify email',
                VERIFY_EMAIL_DESC: 'Please send the verification code to <span>{{email}}</span> to continue.',
                CONFIRM_CODE: 'Verify code',
                EMAIL_VERIFY_CODE_DESC: 'Please enter the code sent to <span>{{email}}</span>.',
                TWO_FACTOR_AUTH_VERIFY_CODE_DESC: 'Please enter the code currently displayed in the <span class="en-number">2FA</span> app.',
                CHECK_SPAM_TEXT: 'Please check your spam folder as well.'
            },
            DATEPICKER: {
                DEFAULT_RANGES: 'Default ranges',
                TODAY: 'Today',
                YESTERDAY: 'Yesterday',
                LAST_WEEK: 'Last week',
                THIS_WEEK: 'This week',
                LAST_MONTH: 'Last month',
                THIS_MONTH: 'This month',
                LAST_30_DAYS: 'Last 30 days',
                PREVIOUS_QUARTER: 'Previous Quarter',
                LAST_YEAR: 'Last Year',
                THIS_YEAR: 'This Year',
                MONTH: 'Month',
                DAY: 'Day',
                YEAR: 'Year',
                TO: 'To',
                EXACT_DATE: 'Exact date',
                HOUR: 'Hour',
                MINUTE: 'Minute',
                SECOND: 'Second',
                FROM: 'From',
                SELECT_DATES: 'Select Dates'
            }
        },
        CHAT: {
            P2P: {
                USER: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: 'New message in P2P chat'
                        },
                        BODY: {
                            MESSAGE: 'Order <span>{{2}}</span>'
                        }
                    }
                }
            }
        },
        SOCIAL_MEDIA: {
            TELEGRAM: 'Telegram',
            CHANNEL_LINK_TELEGRAM: 'TopChange Telegram Channel',
            DESC_TELEGRAM: 'Join our official channel to receive the latest news and important announcements and communicate directly with our support team.',
            APARAT: 'Aparat',
            DESC_APARAT: 'Watch educational videos, product introductions, and visual documentation of the company’s activities on our Aparat channel.',
            CHANNEL_LINK_APARAT: 'TopChange Aparat Channel',
        },
    }
};
